{
  "brand": {
    "name": "CoreWay",
    "product": "DispatchOS",
    "motto": "One System. Every Carrier. A Stronger Tomorrow.",
    "tagline": "Dispatch Smarter. Move Further.",
    "mottoLine1": "One System.",
    "mottoLine2": "Every Carrier.",
    "mottoLine3": "A Stronger Tomorrow.",
    "version": "v{{version}}"
  },
  "layout": {
    "menu": "Menú",
    "openMenu": "Abrir menú",
    "openMenuUnread": "Abrir menú, {{count}} conversaciones sin leer",
    "closeMenu": "Cerrar menú"
  },
  "nav": {
    "dashboard": "Panel",
    "documentation": "Documentación",
    "brokers": "Brokers",
    "brokersCreditCheck": "Crédito",
    "brokersRateConfirmations": "Rate Confirmations",
    "brokersBolsPods": "BOL / POD",
    "brokersReceipts": "Recibos",
    "carriers": "Carriers",
    "carriersPackages": "Paquetes",
    "carriersInvoices": "Facturas",
    "carriersTrucks": "Camiones",
    "carriersDrivers": "Choferes",
    "reports": "Informes",
    "dispatchers": "Dispatchers",
    "dispatchersAssignedDrivers": "Choferes asignados",
    "dispatchersDispatch": "Despacho",
    "loads": "Cargas",
    "tasks": "Tareas",
    "chat": "Chat",
    "support": "Soporte",
    "expand": "Desplegar {{section}}",
    "collapse": "Plegar {{section}}",
    "brokersSetups": "Altas con brokers",
    "brokersPayments": "Pagos de brokers",
    "carriersOwnerStatements": "Estados de cuenta de dueños",
    "carriersDriverSettlements": "Liquidaciones de choferes",
    "dispatchersPay": "Pago de dispatchers",
    "activity": "Actividad"
  },
  "topbar": {
    "searchPlaceholder": "Buscar cargas, carriers, choferes, brokers…",
    "searchLabel": "Búsqueda global",
    "notifications": "Notificaciones",
    "notificationCount_one": "{{count}} notificación sin leer",
    "notificationCount_other": "{{count}} notificaciones sin leer",
    "workspace": "Agencia",
    "noWorkspace": "Ninguna agencia cargada",
    "switchAgency": "Cambiar de agencia (actual: {{agency}})",
    "agencies": "Tus agencias",
    "switched": "Ahora trabajas en {{agency}}."
  },
  "search": {
    "open": "Buscar",
    "short": "Buscar",
    "title": "Buscar",
    "help": "Cargas por número, referencia del broker o ciudad; choferes; carriers por nombre, MC o DOT; camiones por unidad o VIN; brokers por nombre o MC.",
    "hint": "Escribe al menos 2 caracteres: número de carga, referencia del broker o ciudad, un chofer, un carrier, MC o DOT, la unidad o el VIN de un camión, un broker.",
    "loading": "Buscando…",
    "empty": "Nada coincide con «{{query}}» en esta agencia.",
    "error": "La búsqueda falló. Inténtalo de nuevo.",
    "results": "Resultados",
    "kinds": {
      "load": "Carga",
      "driver": "Chofer",
      "carrier": "Carrier",
      "truck": "Camión",
      "broker": "Broker"
    }
  },
  "notifications": {
    "title": "Notificaciones",
    "empty": "Estás al día.",
    "error": "No se pudieron cargar las notificaciones.",
    "unread": "Sin leer",
    "aDriver": "Un chofer",
    "chat_one": "{{driver}} envió un mensaje",
    "chat_other": "{{driver}} envió {{count}} mensajes",
    "delivered": "{{load}} fue entregada",
    "pod": "POD recibido de {{load}}",
    "kinds": {
      "chat_message": "Chat",
      "load_rejected": "Carga rechazada",
      "task_assigned": "Tarea",
      "document_expiring": "Documento",
      "invoice_overdue": "Factura",
      "load_delivered": "Entregada",
      "pod_received": "POD"
    },
    "tabs": {
      "forMe": "Para mí",
      "activity": "Actividad"
    },
    "tabCount": "{{count}} sin leer",
    "activityEmpty": "Todavía no hay actividad del equipo.",
    "activityError": "No se pudo cargar la actividad.",
    "viewAllActivity": "Ver toda la actividad",
    "activityOff": "Los avisos de actividad están apagados.",
    "activityTurnOff": "Apagar",
    "activityTurnOn": "Encender",
    "activityTurnOffLabel": "Apagar los avisos de actividad",
    "activityTurnOnLabel": "Encender los avisos de actividad"
  },
  "user": {
    "settings": "Ajustes",
    "signOut": "Cerrar sesión",
    "roleUnknown": "Rol pendiente",
    "roleLoading": "Cargando rol…",
    "roleNone": "Sin rol de oficina",
    "roleSuspended": "Acceso en pausa"
  },
  "auth": {
    "title": "Iniciar sesión",
    "subtitle": "Dispatch Smarter. Move Further.",
    "email": "Correo",
    "emailPlaceholder": "tu@agencia.com",
    "password": "Contraseña",
    "passwordPlaceholder": "Tu contraseña",
    "submit": "Entrar",
    "submitting": "Entrando…",
    "invalidCredentials": "Correo o contraseña incorrectos.",
    "checking": "Comprobando la sesión…",
    "link": {
      "toggle": "Mejor envíame un enlace de acceso",
      "usePassword": "Entrar con contraseña",
      "title": "Recibe un enlace de acceso",
      "body": "Escribe tu email y te enviaremos un enlace que te deja entrar. Sin contraseña.",
      "submit": "Envíame un enlace",
      "sending": "Enviando…",
      "emailRequired": "Escribe tu email.",
      "sent": "Si {{email}} tiene una cuenta de Coreway, le enviamos un enlace de acceso. Ábrelo en este navegador.",
      "sendAgain": "Enviar de nuevo",
      "sendAgainIn": "Enviar de nuevo en {{seconds}} s",
      "sentAgain": "Enviado de nuevo."
    },
    "linkSignedIn": {
      "title": "Sesión iniciada como {{email}}",
      "continue": "Continuar",
      "notYou": "¿No eres tú? Cierra sesión"
    },
    "oauth": {
      "google": "Continuar con Google",
      "apple": "Continuar con Apple",
      "redirecting": "Abriendo {{provider}}…",
      "or": "o"
    },
    "errors": {
      "tooManyEmails": "Se enviaron demasiados correos a esta dirección. Espera unos minutos y vuelve a intentarlo.",
      "invalidEmail": "No es un email válido.",
      "linkExpired": "Ese enlace de acceso caducó o ya se usó. Pide uno nuevo.",
      "linkOtherBrowser": "Este enlace de acceso se pidió desde otro navegador. Ábrelo allí o pide uno nuevo desde aquí.",
      "otherAccount": "Este enlace es de otra cuenta ({{email}}). Cierra sesión primero para usarlo y luego pide un enlace nuevo.",
      "weakPassword": "Elige una contraseña más segura: al menos 8 caracteres.",
      "samePassword": "Esa ya es tu contraseña. Elige una nueva.",
      "invalidCredentials": "Email o contraseña incorrectos.",
      "network": "No se pudo contactar con el servidor. Revisa tu conexión y vuelve a intentarlo.",
      "generic": "Algo salió mal. Vuelve a intentarlo.",
      "oauthCancelled": "Se canceló el inicio de sesión. Inténtalo de nuevo cuando quieras.",
      "oauthFailed": "No pudimos iniciar sesión con esa cuenta. Inténtalo de nuevo o usa tu correo.",
      "oauthUnavailable": "Esta opción no está disponible ahora. Usa tu correo.",
      "identityTaken": "Esa cuenta ya está vinculada a otra cuenta de Coreway.",
      "otherAccountOAuth": "Esa cuenta ({{email}}) es de otra cuenta de Coreway. Sigues con esta sesión; cierra sesión primero para usarla."
    },
    "signup": {
      "title": "Empieza tu prueba gratis",
      "subtitle": "30 días gratis. Sin tarjeta.",
      "body": "Escribe tu correo y te enviaremos un enlace que crea tu cuenta. Luego le pones nombre a tu agencia y empiezas a despachar.",
      "sent": "Enviamos un enlace a {{email}}. Ábrelo en este navegador para seguir.",
      "haveAccount": "¿Ya tienes cuenta?",
      "signIn": "Inicia sesión"
    },
    "startTrial": "¿Nuevo en Coreway?",
    "startTrialLink": "Empieza una prueba gratis"
  },
  "empty": {
    "notBuilt": "Todavía no existe",
    "explain": "El armazón está puesto. Esta pantalla llega con su migración, su RPC y sus tests."
  },
  "primitives": {
    "featureOff": {
      "hint": "Nada que mostrar mientras esté apagado."
    },
    "meter": {
      "milesLeft": "Faltan {{value}} mi",
      "milesOver": "Vencido por {{value}} mi",
      "daysLeft_one": "Falta {{count}} día",
      "daysLeft_other": "Faltan {{count}} días",
      "daysOver_one": "Vencido hace {{count}} día",
      "daysOver_other": "Vencido hace {{count}} días",
      "moneyLeft": "Quedan ${{amount}}",
      "moneyOver": "Excedido por ${{amount}}",
      "unknown": "Sin lectura todavía"
    },
    "rows": {
      "max": "Hasta {{max}} líneas."
    }
  },
  "kpi": {
    "activeLoads": "Cargas activas",
    "deliveredThisWeek": "Entregadas (esta semana)",
    "grossRevenue": "Ingresos brutos",
    "avgRatePerMile": "Tarifa media / milla (mes)",
    "dispatchFeesMtd": "Comisiones (mes en curso)",
    "loadedMiles": "Millas cargadas (mes)",
    "deadheadMiles": "Millas en vacío (mes)",
    "totalMiles": "Millas totales (mes)",
    "carrierRevenue": "Ingresos de carriers (mes)",
    "outstandingInvoices": "Facturas pendientes",
    "tasksDue": "Tareas para hoy",
    "deltaUp": "{{percent}} %",
    "up": "sube",
    "down": "baja",
    "loading": "Cargando KPIs…",
    "error": "No se pudieron cargar los KPIs."
  },
  "status": {
    "booked": "Reservada",
    "dispatched": "Despachada",
    "accepted": "Aceptada",
    "atPickup": "En recogida",
    "loaded": "Cargada",
    "inTransit": "En tránsito",
    "delivered": "Entregada",
    "podReceived": "POD recibido"
  },
  "invoiceStatus": {
    "draft": "Borrador",
    "sent": "Enviada",
    "paid": "Pagada",
    "overdue": "Vencida",
    "canceled": "Anulada"
  },
  "invoices": {
    "title": "Facturas",
    "loading": "Cargando facturas…",
    "error": "No se pudieron cargar las facturas.",
    "retry": "Reintentar",
    "empty": "No hay facturas que mostrar.",
    "dismiss": "Cerrar",
    "daysOverdue_one": "{{count}} día de retraso",
    "daysOverdue_other": "{{count}} días de retraso",
    "confirmVoid": "¿Anular la factura {{number}}? Un borrador se elimina y su número se libera; una factura enviada se cancela.",
    "columns": {
      "number": "N.º de factura",
      "status": "Estado",
      "carrier": "Carrier",
      "issued": "Emitida",
      "due": "Vence",
      "amount": "Importe",
      "actions": "Acciones",
      "email": "Correo"
    },
    "raise": {
      "carrierLabel": "Carrier",
      "carrierPlaceholder": "Elige un carrier…",
      "action": "Crear factura"
    },
    "actions": {
      "send": "Enviar",
      "void": "Anular",
      "download": "Descargar PDF",
      "downloadFor": "Descargar el PDF de {{number}}",
      "preparing": "Preparando PDF",
      "emailAgain": "Enviar otra vez"
    },
    "penalty": {
      "descriptionLabel": "Descripción de la penalización",
      "descriptionPlaceholder": "p. ej. Se bajó de la carga CW-1048",
      "amountLabel": "Importe",
      "action": "Añadir penalización"
    },
    "charge": {
      "open": "Agregar cargo",
      "help": "Crea una factura nueva con este cargo. Las comisiones sin facturar del transportista también se incluyen.",
      "hasDraft": "{{carrier}} tiene el borrador {{number}}: ábrelo abajo y agrega el cargo ahí.",
      "descriptionLabel": "Descripción del cargo",
      "amountLabel": "Monto del cargo",
      "submit": "Crear factura con este cargo",
      "raised": "Factura creada con el cargo"
    },
    "lines": {
      "loading": "Cargando líneas…",
      "error": "No se pudieron cargar las líneas.",
      "empty": "Esta factura todavía no tiene líneas.",
      "columns": {
        "lineNo": "N.º",
        "kind": "Tipo",
        "description": "Descripción",
        "quantity": "Cant.",
        "unitAmount": "Unitario",
        "amount": "Importe"
      },
      "kinds": {
        "dispatch_fee": "Dispatch fee",
        "penalty": "Penalización",
        "fee_true_up": "Ajuste al POD",
        "other": "Otra línea"
      },
      "provisional": "En tránsito (provisional)",
      "provisionalHelp": "Facturada en el cierre del viernes mientras la carga iba en camino. Cualquier diferencia en la comisión al llegar el POD va en una factura posterior como ajuste al POD."
    },
    "errors": {
      "forbidden": "No tienes permiso para hacer eso.",
      "badState": "La factura no está en un estado que lo permita.",
      "duplicate": "Esa carga ya está facturada en otra factura.",
      "constraint": "Esa línea no es válida para su tipo.",
      "notFound": "Ese carrier o esa factura ya no existe.",
      "generic": "La acción falló: {{message}}",
      "nothingToBill": "No hay nada que facturar a este carrier: todas las comisiones ya están en una factura o retenidas. Solo se facturan las cargas con POD recibido, más las cargas ya recogidas si el carrier está configurado para facturar en tránsito.",
      "noRecipient": "Este carrier no tiene correo de facturación ni de contacto. Añade uno, o marca la factura como enviada sin correo.",
      "hasDraft": "Este transportista ya tiene el borrador {{number}}: agrega el cargo ahí."
    },
    "payments": {
      "balanceColumn": "Saldo",
      "paidLine": "Pagado {{amount}}",
      "writtenOffLine": "Condonado {{amount}}",
      "record": "Registrar pago",
      "recordFor": "Registrar pago de {{number}}",
      "writeOff": "Condonar",
      "voidBlocked": "Revierte sus pagos antes de anularla.",
      "voidTitle": "¿Anular la factura {{number}}?",
      "voidConfirm": "Anular factura",
      "voided": "{{number}} anulada",
      "sent": "{{number}} enviada",
      "raised": "Factura creada",
      "penaltyAdded": "Penalización añadida",
      "title": "Pagos",
      "loading": "Cargando pagos…",
      "error": "No se pudieron cargar los pagos.",
      "empty": "Aún no hay pagos registrados.",
      "columns": {
        "date": "Fecha",
        "kind": "Tipo",
        "amount": "Importe",
        "reference": "Referencia / motivo",
        "recorded": "Registrado",
        "state": "Estado",
        "action": "Acción"
      },
      "writeOffKind": "Condonación",
      "reversed": "Revertido",
      "reversedBy": "por {{name}}, {{date}}: {{reason}}",
      "recordedBy": "{{name}}, {{date}}",
      "reverse": "Revertir",
      "reverseWriteOffLabel": "Revertir la condonación de {{amount}}",
      "reverseLabel": "Revertir el pago de {{amount}}",
      "dialog": {
        "title": "Registrar pago de {{number}}",
        "amount": "Importe",
        "balanceHelp": "Saldo {{amount}}",
        "paidOn": "Pagado el",
        "method": "Método",
        "methodPlaceholder": "Elige un método…",
        "reference": "Referencia",
        "notes": "Notas",
        "after": "Tras este pago el saldo queda en {{amount}}.",
        "afterZero": "La factura quedará pagada y sus recordatorios se detienen.",
        "submit": "Registrar pago",
        "done": "Pago de {{amount}} registrado en {{number}}"
      },
      "writeOffDialog": {
        "title": "¿Condonar {{number}}?",
        "body": "Cierra los {{amount}} restantes de {{number}} como incobrables. La factura cuenta como pagada y sus recordatorios se detienen. Un admin puede revertirlo.",
        "confirm": "Condonar",
        "done": "{{number}} condonada"
      },
      "reverseDialog": {
        "title": "¿Revertir este pago?",
        "body": "El pago de {{amount}} queda en el historial como revertido. La factura vuelve a enviada, o a vencida si ya pasó su fecha, y sus recordatorios se reanudan.",
        "confirm": "Revertir",
        "titleWriteOff": "¿Revertir esta condonación?",
        "bodyWriteOff": "La condonación de {{amount}} queda en el historial como revertida. La factura vuelve a enviada, o a vencida si ya pasó su fecha, y sus recordatorios se reanudan.",
        "doneWriteOff": "Condonación revertida",
        "done": "Pago revertido"
      }
    },
    "noAccess": "Las facturas a carriers las ven el administrador y contabilidad.",
    "send": {
      "title": "Enviar la factura {{number}} por correo",
      "body": "{{carrier}} recibe la factura en PDF en {{email}}. La factura pasa a Enviada y ya no se puede editar.",
      "noEmail": "{{carrier}} no tiene correo de facturación ni de contacto.",
      "noEmailBody": "Añade un correo al carrier y envíala, o márcala como enviada y entrega tú el PDF. Después ya no se puede editar.",
      "addEmail": "Añadir un correo al carrier",
      "withoutEmail": "Marcar como enviada sin correo",
      "confirm": "Enviar",
      "done": "Factura {{number}} enviada a {{email}}",
      "doneWithoutEmail": "Factura {{number}} marcada como enviada"
    },
    "again": {
      "title": "Enviar otra vez la factura {{number}}",
      "body": "El mismo PDF que recibió el carrier, en el idioma en que se envió la primera vez. Cambia la dirección para enviarlo a otro sitio.",
      "confirm": "Enviar otra vez",
      "done": "Enviando la factura {{number}}"
    },
    "email": {
      "queued": "Enviando",
      "sent": "Enviada el {{date}} a {{email}}",
      "failed": "El correo falló",
      "failedHelp": "El correo a {{email}} falló. La tarea en Tareas tiene el motivo.",
      "none": "Sin enviar"
    }
  },
  "board": {
    "title": "Tablero de despacho",
    "filtersLabel": "Filtrar el tablero por estado de la carga",
    "filters": {
      "all": "Todas",
      "booked": "Reservadas",
      "inTransit": "En tránsito",
      "delivered": "Entregadas",
      "dispatched": "Esperando respuesta"
    },
    "loading": "Cargando cargas…",
    "error": "No se pudo cargar el tablero.",
    "retry": "Reintentar",
    "empty": "No hay cargas activas ahora mismo.",
    "columns": {
      "number": "N.º de carga",
      "carrier": "Carrier",
      "driver": "Chofer",
      "origin": "Origen",
      "destination": "Destino",
      "pickup": "Recogida",
      "delivery": "Entrega",
      "status": "Estado",
      "rate": "Tarifa",
      "actions": "Acciones",
      "broker": "Broker",
      "totalMiles": "Millas totales",
      "rpm": "RPM"
    },
    "actions": {
      "view": "Ver la carga {{load}}",
      "documents": "Documentos de la carga {{load}}",
      "track": "Seguir la carga {{load}}"
    },
    "dispatch": "Despachar {{load}}"
  },
  "detail": {
    "title": "Detalle de la carga – {{load}}",
    "tabsLabel": "Secciones del detalle de la carga",
    "tabs": {
      "overview": "Resumen",
      "stops": "Paradas",
      "documents": "Documentos",
      "financials": "Finanzas",
      "tracking": "Seguimiento",
      "notes": "Notas"
    },
    "tracking": {
      "notStarted": "El seguimiento empieza cuando el chofer acepta la carga.",
      "checkIns": "Llegadas a las paradas",
      "notYet": "Aún no ha llegado"
    },
    "notes": {
      "load": "Notas de la carga",
      "none": "Esta carga no tiene notas.",
      "edit": "Editar las notas en la página de la carga"
    }
  },
  "documents": {
    "title": "Documentos",
    "kinds": {
      "rateConfirmation": "Confirmación de tarifa",
      "bol": "BOL",
      "pod": "POD",
      "lumperReceipt": "Recibo de lumper"
    },
    "uploadedOn": "Subido el {{date}}",
    "notUploaded": "Sin subir todavía",
    "upload": "Subir",
    "download": "Descargar",
    "viewAll": "Ver todos los documentos",
    "uploadKind": "Subir {{kind}}",
    "downloadKind": "Descargar {{kind}}",
    "warning": {
      "image_unconverted": "No se pudo añadir {{file}} al paquete. Descárgalo desde la carga.",
      "pdf_unreadable": "{{file}} está protegido o dañado y no se unió.",
      "logo_missing": "No se encontró el logo; el PDF salió sin él.",
      "logo_unreadable": "No se pudo leer el logo; el PDF salió sin él.",
      "generic": "No se pudo dibujar una página de este PDF."
    },
    "failed": "No se pudo preparar el PDF. Inténtalo otra vez.",
    "timeout": "El PDF está tardando más de lo normal. Inténtalo en un minuto.",
    "tooMany": "Se están preparando demasiados documentos. Inténtalo en un minuto.",
    "retry": "Intentar otra vez",
    "chooseLanguage": "Elegir el idioma de {{label}}",
    "languages": {
      "en": "English",
      "es": "Español"
    },
    "errors": {
      "packetTooBig": "Los documentos de la carga pasan de 30 MB juntos. Descárgalos uno a uno desde la carga.",
      "throttleMinute": "Este documento se envió hace un momento. Inténtalo en un minuto.",
      "throttleDay": "Este documento ya se envió 10 veces hoy.",
      "notSent": "Solo se puede enviar por correo una factura enviada.",
      "notInvoiced": "Marca primero la carga como facturada.",
      "typeEmail": "Escribe la dirección de correo a la que enviarlo.",
      "brokerNoEmail": "El broker no tiene correo registrado. Escribe uno."
    }
  },
  "timeline": {
    "title": "Línea de estado de la carga",
    "steps": {
      "dispatched": "Despachada",
      "arrivedAtShipper": "Llegó al shipper",
      "loaded": "Cargada",
      "inTransit": "En tránsito",
      "arrivedAtReceiver": "Llegó al receiver",
      "delivered": "Entregada",
      "podReceived": "POD recibido"
    },
    "empty": "Todavía no pasó nada en esta carga.",
    "line": "{{title}} {{channel}}",
    "reason": "«{{reason}}»",
    "kinds": {
      "created": "Creada",
      "declined": "Rechazada",
      "dispatchedTo": "{{driver}} · Unidad {{unit}}",
      "stopArrived": "Llegó a {{stop}}",
      "stopDeparted": "Salió de {{stop}}",
      "stopRescheduled": "{{stop}}: cita cambiada",
      "rescheduledFromTo": "De {{from}} a {{to}}",
      "appointmentCleared": "{{stop}}: cita quitada",
      "stopRemoved": "{{stop}} quitada",
      "repriced": "Tarifa cambiada",
      "repricedDetail": "Tarifa {{linehaul}}, accesorios {{accessorial}}",
      "feeDisputed": "Comisión en disputa",
      "feeDisputeCleared": "Disputa de la comisión resuelta",
      "feeReversed": "Comisión revertida",
      "documentAdded": "{{kind}} subido",
      "documentArchived": "{{kind}} archivado",
      "documentReplaced": "{{kind}} reemplazado",
      "quickPayRequested": "Pago rápido solicitado",
      "other": "Actualizada"
    },
    "channel": {
      "app": "en la app",
      "phone": "por teléfono (lo registró {{name}})",
      "phoneAnon": "por teléfono",
      "office": "por la oficina"
    }
  },
  "charts": {
    "revenueByCarrier": "Ingresos por carrier",
    "barLabel": "{{carrier}}: {{amount}}",
    "topBrokers": "Brokers con más ingresos",
    "thisMonthDelivered": "Entregadas este mes",
    "viewReport": "Ver informe",
    "others": "Otros",
    "loading": "Cargando…",
    "error": "No se pudo cargar esta tarjeta.",
    "retry": "Reintentar",
    "emptyMonth": "Aún no hay cargas entregadas este mes.",
    "loadsCount_one": "{{formatted}} carga",
    "loadsCount_other": "{{formatted}} cargas"
  },
  "tasks": {
    "title": "Tareas próximas",
    "sources": {
      "loadRejected": "{{load}} fue rechazada: {{reason}}. Despáchala de nuevo.",
      "loadRejectedNoReason": "{{load}} fue rechazada. Despáchala de nuevo.",
      "loadRejectedGeneric": "Una carga fue rechazada. Despáchala de nuevo.",
      "driverAccountDeleted": "{{driver}} eliminó su cuenta de la app. {{load}} sigue asignada a él: reasígnala.",
      "driverAccountDeletedNoDriver": "El chofer de {{load}} eliminó su cuenta de la app. Reasígnala.",
      "driverAccountDeletedGeneric": "Un chofer eliminó su cuenta de la app. Reasigna su carga.",
      "invoiceOverdue_one": "La factura {{invoice}} lleva {{count}} día de retraso. Cóbrala.",
      "invoiceOverdue_other": "La factura {{invoice}} lleva {{count}} días de retraso. Cóbrala.",
      "invoiceOverdueGeneric": "Una factura vencida necesita cobro.",
      "documentExpiry": "Un documento está por vencer.",
      "documentExpiring": "{{kind}} de {{owner}} vence el {{date}}. Pide el nuevo.",
      "documentExpired": "{{kind}} de {{owner}} venció el {{date}}. Pide el nuevo.",
      "invoiceNotEmailed": "La factura {{invoice}} no se envió: el carrier no tiene correo. Añade uno y usa Enviar otra vez.",
      "invoiceEmailFailed": "El correo de la factura {{invoice}} falló. Revisa la dirección y usa Enviar otra vez.",
      "invoiceDeliveryGeneric": "Una factura no se pudo enviar por correo.",
      "brokerInvoiceEmailFailed": "El correo de la factura {{invoice}} al broker falló ({{load}}). Revisa la dirección y envíala otra vez.",
      "brokerInvoiceEmailFailedNoLoad": "El correo de la factura {{invoice}} al broker falló. Revisa la dirección y envíala otra vez.",
      "brokerInvoiceDeliveryGeneric": "Una factura a un broker no se pudo enviar por correo.",
      "maintenanceMilesLeft": "{{label}} del camión {{truck}}: faltan {{miles}} mi. Agenda el servicio.",
      "maintenanceMilesOverdue": "{{label}} del camión {{truck}} está vencido. Agenda el servicio.",
      "maintenanceDueOn": "{{label}} del camión {{truck}} vence el {{date}}. Agenda el servicio.",
      "maintenanceWasDue": "{{label}} del camión {{truck}} venció el {{date}}. Agenda el servicio.",
      "maintenanceDueGeneric": "Un camión tiene un servicio próximo.",
      "maintenanceOverdueGeneric": "Un camión tiene un servicio vencido."
    },
    "priority": {
      "low": "Baja",
      "normal": "Normal",
      "high": "Alta"
    },
    "empty": "No hay tareas abiertas.",
    "loading": "Cargando las tareas…",
    "error": "No se pudieron cargar las tareas.",
    "dueAt": "Vence {{date}}",
    "openLoad": "Abrir {{load}}",
    "new": "Nueva tarea",
    "viewAll": "Ver todas",
    "completedOn": "Hecha {{date}}",
    "view": {
      "label": "Mostrar",
      "mine": "Mis tareas",
      "all": "Todas las tareas"
    },
    "statusFilter": {
      "label": "Estado",
      "open": "Abiertas",
      "completed": "Hechas",
      "all": "Todas"
    },
    "sourceFilter": {
      "label": "Origen",
      "any": "Cualquier origen"
    },
    "sourceNames": {
      "manual": "Escrita por la oficina",
      "document_expiry": "Documento por vencer",
      "load_rejected": "Carga rechazada",
      "invoice_overdue": "Factura vencida",
      "driver_account_deleted": "Cuenta de chofer eliminada",
      "invoice_delivery": "Correo de factura",
      "broker_invoice_delivery": "Correo de factura al broker",
      "maintenance_due": "Mantenimiento de camiones"
    },
    "dueFilter": {
      "label": "Vence",
      "any": "Cuando sea",
      "overdue": "Vencidas",
      "today": "Vencen hoy",
      "week": "Vencen esta semana",
      "none": "Sin fecha"
    },
    "due": {
      "overdue": "Vencida desde {{date}}",
      "none": "Sin fecha"
    },
    "list": {
      "empty": "No hay tareas aquí.",
      "emptyFiltered": "Ninguna tarea coincide con estos filtros.",
      "clearFilters": "Quitar filtros",
      "capped": "Se muestran las {{count}} tareas más recientes. Afina los filtros para ver las anteriores."
    },
    "assignee": {
      "none": "Sin asignar",
      "former": "Exmiembro",
      "meNamed": "{{name}} (yo)"
    },
    "links": {
      "load": "Carga {{load}}",
      "driver": "Chofer {{name}}"
    },
    "actions": {
      "complete": "Marcar como hecha",
      "completeNamed": "Marcar como hecha: {{title}}",
      "reopenNamed": "Reabrir: {{title}}",
      "snooze": "Posponer",
      "snoozeNamed": "Posponer a mañana: {{title}}",
      "edit": "Editar",
      "editNamed": "Editar: {{title}}",
      "completed": "Tarea hecha",
      "reopened": "Tarea reabierta",
      "snoozed": "Pospuesta a {{date}}"
    },
    "form": {
      "createTitle": "Nueva tarea",
      "editTitle": "Editar tarea",
      "createHint": "Di qué hay que hacer, para cuándo y quién se encarga.",
      "editHint": "Cambia qué hay que hacer, para cuándo o quién se encarga.",
      "title": "Título",
      "detail": "Notas",
      "dueDate": "Fecha de vencimiento",
      "dueTime": "Hora",
      "zoneHelp": "En hora de {{city}}, el reloj de la agencia.",
      "priority": "Prioridad",
      "assignee": "Asignar a",
      "links": "Relacionada con",
      "carrier": "Transportista",
      "load": "Carga",
      "driver": "Chofer",
      "noCarrier": "Sin transportista",
      "noLoad": "Sin carga",
      "noDriver": "Sin chofer",
      "systemNote": "Esta tarea la creó Coreway; su título sigue a lo que la originó. Puedes cambiar la fecha, la prioridad y a quién le toca.",
      "created": "Tarea creada",
      "saved": "Tarea guardada"
    },
    "errors": {
      "notFound": "Esa tarea ya no existe o no es una que puedas ver.",
      "canceled": "Esa tarea fue cancelada.",
      "titleRequired": "Ponle un título a la tarea.",
      "titleTooLong": "El título debe tener menos de 200 caracteres.",
      "detailTooLong": "Las notas deben tener menos de 2.000 caracteres.",
      "assignee": "Elige a alguien que sea miembro activo de esta agencia.",
      "outOfScope": "Esa carga, transportista o chofer no está entre los que llevas.",
      "carrierMismatch": "Esa carga pertenece a otro transportista.",
      "systemTitle": "No se puede cambiar el título de una tarea que creó Coreway."
    }
  },
  "expiring": {
    "title": "Documentos por vencer",
    "viewAll": "Ver todos",
    "empty": "Ahora mismo no hay nada por vencer ni vencido.",
    "error": "No se pudieron cargar los documentos."
  },
  "config": {
    "title": "El portal no está configurado",
    "hint": "Copia web/config.example.js a web/config.js, rellénalo y recarga."
  },
  "pages": {
    "dashboard": {
      "title": "Panel",
      "blurb": "Los cinco KPI, los ingresos por carrier y las cargas que hoy piden atención."
    },
    "documentation": {
      "title": "Documentación",
      "blurb": "Todos los documentos en un sitio: paquetes de carrier, licencias y tarjetas médicas de los choferes, registros y seguros de los camiones, cada uno con su vencimiento."
    },
    "brokers": {
      "title": "Brokers",
      "blurb": "El directorio de brokers: nombre, MC y DOT, contactos y las cargas reservadas con cada uno."
    },
    "brokersCreditCheck": {
      "title": "Crédito",
      "blurb": "Crédito y días de pago del broker, para no reservar una carga con quien no la va a pagar."
    },
    "brokersRateConfirmations": {
      "title": "Rate Confirmations",
      "blurb": "La confirmación de tarifa de cada carga, y las cargas a las que aún les falta."
    },
    "brokersBolsPods": {
      "title": "BOL / POD",
      "blurb": "Cargas entregadas que esperan sus papeles: revisa el POD y el BOL y confirma el POD recibido."
    },
    "brokersPayments": {
      "title": "Pagos de brokers",
      "blurb": "Lo que los brokers y las empresas de factoring deben a tus carriers, carga por carga: facturado, cobrado, pago corto, en disputa."
    },
    "brokersReceipts": {
      "title": "Recibos",
      "blurb": "Lo que el carrier le cobra al broker: recibos de lumper, combustible, peaje y báscula, pruebas de detención y TONU."
    },
    "carriers": {
      "title": "Carriers",
      "blurb": "Owner-operators con su propio MC y compañías carrier, con sus camiones y choferes debajo."
    },
    "carriersPackages": {
      "title": "Paquetes de carrier",
      "blurb": "Lo que le falta al paquete de alta de cada carrier, un solo sitio para subirlo, una hoja de portada imprimible y el paquete entero en una descarga."
    },
    "carriersInvoices": {
      "title": "Facturas de carrier",
      "blurb": "Lo que el carrier le debe a la agencia, y la liquidación del chofer que hay detrás."
    },
    "carriersTrucks": {
      "title": "Camiones",
      "blurb": "La flota: número de unidad, VIN, placa, registro y seguro."
    },
    "carriersDrivers": {
      "title": "Choferes",
      "blurb": "Los choferes de cada carrier, sus documentos y la cuenta con la que entran en la app."
    },
    "reports": {
      "title": "Informes",
      "blurb": "Cargas entregadas por carrier, chofer, camión, dispatcher y broker: ingresos, millas cargadas y en vacío, tarifa por milla, comisiones y facturas."
    },
    "dispatchers": {
      "title": "Dispatchers",
      "blurb": "Los miembros de la agencia, qué puede ver cada uno y cuánto ha movido."
    },
    "dispatchersAssignedDrivers": {
      "title": "Choferes asignados",
      "blurb": "Qué choferes pertenecen a qué dispatcher."
    },
    "dispatchersDispatch": {
      "title": "Despacho",
      "blurb": "El tablero de despacho: cargas abiertas, camiones disponibles y la asignación que los une."
    },
    "loads": {
      "title": "Cargas",
      "blurb": "Cada carga desde booked hasta paid, con tarifa, millas cargadas y totales, gastos y la línea de tiempo de estado."
    },
    "tasks": {
      "title": "Tareas",
      "blurb": "Lo que tiene que pasar a continuación, y quién lo debe."
    },
    "chat": {
      "title": "Chat",
      "blurb": "La conversación entre dispatcher y chofer, al lado de la carga de la que habla."
    },
    "support": {
      "title": "Soporte",
      "blurb": "Cómo hablar con una persona, y qué enviar para que podamos ayudar."
    },
    "notFound": {
      "title": "Página no encontrada",
      "blurb": "Esa dirección no pertenece al portal."
    },
    "brokersSetups": {
      "title": "Altas con brokers",
      "blurb": "Qué carrier está dado de alta con qué broker: estado, fecha de alta y la última vez que alguien lo comprobó."
    },
    "settings": {
      "title": "Ajustes de la agencia",
      "blurb": "Quién trabaja en la oficina, qué puede hacer cada rol, las reglas de la agencia y tu propio perfil."
    },
    "loadNew": {
      "title": "Nueva carga",
      "blurb": "Escribe la carga a partir de su rate confirmation: carrier, broker, paradas, tarifa y millas."
    },
    "loadPage": {
      "title": "Carga",
      "blurb": "Una carga desde la rate confirmation hasta el POD: sus paradas, documentos, dinero y cada evento."
    },
    "carriersOwnerStatements": {
      "title": "Estados de cuenta de dueños",
      "blurb": "Lo que cada carrier le paga a los dueños de los camiones arrendados, semana a semana: cargas menos la comisión, cargos semanales, deducciones y el saldo de la semana anterior."
    },
    "carriersDriverSettlements": {
      "title": "Liquidaciones de choferes",
      "blurb": "Lo que tu agencia, o un dueño de camión, le paga a cada chofer de compañía semana a semana: sus cargas, menos sus deducciones, más los ajustes."
    },
    "dispatchersPay": {
      "title": "Pago de dispatchers",
      "blurb": "Lo que la agencia debe a cada dispatcher, semana por semana: comisión de las cargas que llevó, salario semanal, lo pagado y lo que falta."
    },
    "activity": {
      "title": "Actividad",
      "blurb": "Lo que hicieron el equipo y los choferes, lo más reciente primero. Filtra por persona, chofer, tipo o fechas."
    }
  },
  "footer": {
    "tagline": "Control Every Carrier. Track Every Load. Build a Stronger Tomorrow.",
    "attribution": "Powered by LUXERAN LLC"
  },
  "roles": {
    "admin": "Admin",
    "manager": "Manager",
    "dispatcher": "Dispatcher",
    "accounting": "Contabilidad"
  },
  "agency": {
    "noAgencyTitle": "Esta cuenta no tiene agencia",
    "noAgencyBody": "Esta cuenta no es miembro de ninguna agencia. Los choferes usan la app Coreway Driver.",
    "removed": {
      "title": "Se retiró tu acceso a {{agency}}",
      "titleMany": "Se retiró tu acceso a tus agencias",
      "body": "Pide a un admin de {{agency}} que te lo devuelva si lo necesitas.",
      "bodyMany": "Sin acceso a: {{agencies}}. Pide a un admin de la agencia que te lo devuelva si lo necesitas."
    },
    "loadError": "No se pudo cargar tu agencia. Las acciones siguen ocultas hasta que cargue.",
    "retry": "Reintentar",
    "pendingInvites": {
      "title": "Tienes una invitación a una agencia",
      "body": "Ábrela para unirte. Hasta entonces esta cuenta no es miembro de ninguna agencia.",
      "line": "{{name}} te invitó a {{agency}} como {{role}}.",
      "lineNoInviter": "Te invitaron a {{agency}} como {{role}}.",
      "open": "Abrir invitación",
      "banner": "Invitaciones pendientes"
    },
    "suspended": {
      "title": "El acceso a {{agency}} está en pausa",
      "titleMany": "El acceso a tus agencias está en pausa",
      "body": "En pausa desde el {{date}}. Los datos de la agencia se conservan.",
      "line": "{{agency}}: en pausa desde el {{date}}.",
      "bodyMany": "Los datos de cada agencia se conservan.",
      "contact": "Para recuperar el acceso, escribe a <mail>{{email}}</mail>.",
      "contactNoEmail": "Para recuperar el acceso, contacta con el soporte de Coreway.",
      "billingBody": "En pausa desde el {{date}} porque hay un pago vencido. Los datos de la agencia se conservan.",
      "billingLine": "{{agency}}: en pausa desde el {{date}}, hay un pago vencido.",
      "amountDue": "Importe pendiente: {{amount}}",
      "payNow": "Pagar ahora",
      "payNowFor": "Pagar ahora por {{agency}}",
      "payHint": "El acceso vuelve en menos de un minuto tras el pago.",
      "askAdmin": "Pide a un admin de {{agency}} que pague la factura abierta. El acceso vuelve en menos de un minuto tras el pago.",
      "payContact": "Para pagar y recuperar el acceso, escribe a <mail>{{email}}</mail>.",
      "payContactNoEmail": "Para pagar y recuperar el acceso, contacta con el soporte de Coreway."
    },
    "selfCreate": {
      "cta": "Crear mi agencia",
      "intro": "Lleva tu propia agencia de despacho en Coreway. Créala ahora y empieza tu prueba gratis de 30 días. Sin tarjeta.",
      "name": "Nombre de la agencia",
      "timeZone": "Zona horaria",
      "timeZoneHelp": "Los días, los vencimientos y las facturas de la agencia siguen esta zona.",
      "zone": "Hora de {{city}}",
      "submit": "Crear agencia",
      "creating": "Creando…",
      "unavailable": "Ahora mismo no se puede crear una agencia desde aquí. Escribe al soporte de Coreway y te la preparamos.",
      "check": "Verificación de seguridad",
      "checkHelp": "Completa la verificación para crear la agencia. Así evitamos altas automáticas.",
      "checkLoadError": "La verificación de seguridad no cargó. Recarga la página y vuelve a intentarlo.",
      "referralCode": "Código de promotor",
      "referralCodeHint": "Opcional. Si alguien te recomendó Coreway, escribe su código."
    }
  },
  "inviteAccept": {
    "boot": {
      "title": "Comprobando tu invitación…"
    },
    "linkError": {
      "title": "Ese enlace de acceso caducó o ya se usó.",
      "body": "Escribe el email al que llegó la invitación y te enviaremos uno nuevo."
    },
    "linkOtherBrowser": {
      "title": "Este enlace de acceso se pidió desde otro navegador.",
      "body": "Ábrelo en el navegador desde el que lo pediste, o escribe el email al que llegó la invitación y te enviaremos uno nuevo aquí."
    },
    "signedOut": {
      "title": "Te invitaron a unirte a una agencia en Coreway",
      "body": "Escribe el email al que llegó la invitación y te enviaremos un enlace de acceso. Sin contraseña."
    },
    "havePassword": "Tengo contraseña",
    "linkSent": {
      "title": "Revisa {{email}}",
      "body": "Abre el enlace en este navegador: te trae de vuelta aquí.",
      "otherEmail": "Usar otro email"
    },
    "resolving": {
      "title": "Abriendo tu invitación…"
    },
    "card": {
      "title": "Únete a {{agency}}",
      "role": "Rol",
      "invitedBy": "Te invitó {{name}}",
      "expiresInDays_one": "Caduca en {{count}} día",
      "expiresInDays_other": "Caduca en {{count}} días",
      "expiresInHours_one": "Caduca en {{count}} hora",
      "expiresInHours_other": "Caduca en {{count}} horas",
      "expiresSoon": "Caduca antes de una hora",
      "joiningAs": "Te unes como {{email}}",
      "confirmed": "Confirmado. Acepta para unirte a {{agency}}.",
      "accept": "Aceptar y unirme",
      "accepting": "Uniéndote…",
      "decline": "Rechazar",
      "notYou": "¿No eres tú? Usa otro email",
      "declineTitle": "¿Rechazar la invitación a {{agency}}?",
      "declineBody": "No te unirás a {{agency}}. Para unirte más adelante, pide a quien te invitó una invitación nueva.",
      "declineConfirm": "Rechazar invitación"
    },
    "roleSummary": {
      "admin": "Dirige toda la agencia: personas, permisos, carriers, cargas y dinero.",
      "manager": "Lleva la oficina en el día a día: todos los carriers y cargas, y asigna carriers a los dispatchers.",
      "dispatcher": "Reserva y lleva las cargas de los carriers que tienes asignados.",
      "accounting": "Lleva las facturas, los pagos y los libros."
    },
    "proofSent": {
      "title": "Confirma que eres tú",
      "body": "Para confirmar que eres tú, abre el enlace que acabamos de enviar a {{email}}. Una contraseña sola no basta para unirse a una agencia.",
      "bodyRecent": "Hace un momento enviamos un enlace de inicio de sesión a {{email}}: ábrelo para confirmar que eres tú. Una contraseña sola no basta para unirse a una agencia.",
      "bodyNotSent": "Para confirmar que eres tú, abre un enlace de inicio de sesión enviado a {{email}}. Una contraseña sola no basta para unirse a una agencia.",
      "orProvider": "O confirma con una cuenta de Google o Apple que use {{email}}."
    },
    "inactive": {
      "title": "Tu membresía en {{agency}} está inactiva",
      "titleUnnamed": "Tu membresía en esta agencia está inactiva",
      "body": "Pide a su admin que te reactive."
    },
    "joined": {
      "title": "Te uniste a {{agency}} como {{role}}.",
      "already": "Ya eres miembro de {{agency}}.",
      "alreadyUnnamed": "Ya eres miembro de esta agencia.",
      "passwordTitle": "Pon una contraseña para la próxima vez (opcional)",
      "passwordBody": "También puedes entrar con un enlace que te llega al email.",
      "goToBoard": "Ir al tablero"
    },
    "notFound": {
      "title": "No encontramos esta invitación",
      "body": "No encontramos esta invitación para {{email}}. Puede que se enviara a otra dirección, que se cancelara o que caducara.",
      "hint": "Pide a quien te invitó que te la vuelva a enviar.",
      "appleRelay": "Apple ocultó tu correo. Entra de nuevo y elige «Compartir mi correo electrónico», o usa la dirección a la que llegó la invitación."
    },
    "declined": {
      "title": "Rechazaste la invitación a {{agency}}."
    },
    "error": {
      "networkTitle": "No se pudo contactar con el servidor",
      "genericTitle": "Algo salió mal"
    },
    "useAnotherEmail": "Usar otro email",
    "signOut": "Cerrar sesión"
  },
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "retry": "Reintentar",
    "search": "Buscar",
    "clear": "Limpiar",
    "edit": "Editar",
    "moreActions": "Más acciones",
    "discard": "Descartar",
    "discardTitle": "¿Descartar los cambios?",
    "discardBody": "Lo que escribiste en este formulario se pierde.",
    "keepEditing": "Seguir editando",
    "confirm": "Confirmar",
    "done": "Listo",
    "copy": "Copiar",
    "copied": "Copiado",
    "copyLink": "Copiar enlace",
    "unknownPerson": "Antiguo miembro",
    "noResults": "No hay resultados para esta búsqueda.",
    "loading": "Cargando…",
    "error": "No se pudo cargar esta lista.",
    "readOnly": "Solo lectura",
    "none": "Ninguno",
    "all": "Todos",
    "dismiss": "Cerrar aviso",
    "changeStatus": "Cambiar estado",
    "clearSearch": "Borrar búsqueda"
  },
  "entities": {
    "agency": "Esa agencia",
    "carrier": "Ese carrier",
    "owner": "Ese dueño",
    "truck": "Ese camión",
    "driver": "Ese chofer",
    "broker": "Ese broker",
    "seat": "Esa alta en el carrier",
    "invoice": "Esa factura",
    "payment": "Ese pago",
    "receipt": "Ese cobro",
    "load": "Esa carga",
    "member": "Ese miembro",
    "invite": "Esa invitación",
    "stop": "Esa parada",
    "document": "Ese documento"
  },
  "fields": {
    "legalName": "Razón social",
    "dba": "Nombre comercial (DBA)",
    "mcNumber": "Número MC",
    "dotNumber": "Número DOT",
    "ein": "EIN",
    "addressLine1": "Dirección, línea 1",
    "addressLine2": "Dirección, línea 2",
    "city": "Ciudad",
    "state": "Estado",
    "postalCode": "Código postal",
    "contactName": "Nombre de contacto",
    "contactPhone": "Teléfono de contacto",
    "contactEmail": "Email de contacto",
    "factoringCompany": "Empresa de factoring",
    "paymentTermsDays": "Plazo de pago (días)",
    "minimumRatePerMile": "Tarifa mínima por milla ($)",
    "ownerId": "Dueño",
    "notes": "Notas",
    "unitNumber": "Número de unidad",
    "vin": "VIN",
    "year": "Año",
    "make": "Marca",
    "model": "Modelo",
    "plate": "Placa",
    "plateState": "Estado de la placa",
    "vehicleType": "Tipo de vehículo",
    "cargoType": "Tipo de carga",
    "maxWeight": "Peso máximo (lb)",
    "lengthFt": "Largo (pies)",
    "widthFt": "Ancho (pies)",
    "heightFt": "Alto (pies)",
    "name": "Nombre",
    "phone": "Teléfono",
    "email": "Email",
    "licenseNumber": "Número de licencia",
    "licenseState": "Estado de la licencia",
    "website": "Sitio web",
    "status": "Estado",
    "setupDate": "Fecha de alta",
    "displayName": "Nombre",
    "locale": "Idioma",
    "reference": "Referencia",
    "invoiceNumber": "Número de factura",
    "invoicedOn": "Fecha de factura",
    "dueOn": "Vence el",
    "paidOn": "Pagado el",
    "factored": "Con factoring",
    "brokerTermsDays": "Plazo de pago de brokers",
    "loadNumber": "Número de carga",
    "brokerReference": "Referencia del broker",
    "commodity": "Mercancía",
    "weight": "Peso (lb)",
    "loadedMiles": "Millas cargado",
    "deadheadMiles": "Millas en vacío",
    "company": "Empresa",
    "referenceNumber": "Referencia",
    "linehaul": "Tarifa",
    "accessorial": "Accesorios",
    "appointmentAt": "Cita",
    "at": "Hora",
    "driver": "Chofer",
    "truck": "Camión",
    "billingEmail": "Correo de facturación",
    "documentLocale": "Idioma de los documentos",
    "factoringAddress": "Dirección de pago de la factoring",
    "factoringPhone": "Teléfono de la factoring",
    "factoringEmail": "Correo de la factoring",
    "brokerInvoicePrefix": "Prefijo de factura al broker",
    "brokerInvoiceNext": "Siguiente número de factura al broker",
    "paymentInstructions": "Cómo pagarte",
    "invoiceNote": "Nota bajo los totales",
    "to": "Enviar a",
    "remitAddress": "Dirección de pago",
    "noaOnFile": "Aviso de cesión (NOA) archivado",
    "noaReceivedOn": "NOA recibido el",
    "factoringId": "Empresa de factoring"
  },
  "validation": {
    "required": "Obligatorio.",
    "tooLong": "Como máximo {{max}} caracteres.",
    "authority": "De 1 a 8 dígitos (se admite el prefijo MC o DOT).",
    "ein": "9 dígitos, por ejemplo 12-3456789.",
    "state": "Código de estado de dos letras, por ejemplo TX.",
    "postal": "Solo letras, dígitos, espacios y guiones.",
    "email": "No es un email válido.",
    "phone": "Solo dígitos, espacios y + ( ) . -",
    "vin": "17 letras y dígitos, sin I, O ni Q.",
    "wholeNumber": "Un número entero.",
    "number": "Un número.",
    "range": "Entre {{min}} y {{max}}.",
    "decimals": "Como máximo {{scale}} decimales.",
    "noSpaces": "Sin espacios.",
    "dateFormat": "Una fecha (AAAA-MM-DD).",
    "dateInFuture": "No puede ser posterior a hoy.",
    "license": "Solo letras, dígitos y guiones.",
    "amountPositive": "Escribe un importe mayor que cero.",
    "amountMax": "Como máximo {{max}}.",
    "dateBeforeInvoice": "No puede ser anterior a la fecha de factura.",
    "dueBeforeInvoice": "No puede ser anterior a la fecha de factura.",
    "passwordShort": "Al menos 8 caracteres.",
    "passwordMismatch": "Las dos contraseñas no coinciden.",
    "fileType": "Usa un archivo PDF, JPEG, PNG, HEIC o WebP.",
    "fileTooLarge": "25 MB como máximo.",
    "fileEmpty": "El archivo está vacío.",
    "stateRequired": "Escribe el estado.",
    "timeRequired": "Escribe la fecha y la hora, o ninguna de las dos.",
    "timeInFuture": "La hora no puede ser en el futuro.",
    "prefix": "De 1 a 10 letras o dígitos.",
    "windowNeedsTime": "Escribe primero la fecha y la hora de la cita.",
    "windowEnd": "La ventana termina antes de empezar."
  },
  "errors": {
    "network": "No se pudo contactar con el servidor. Revisa tu conexión y vuelve a intentarlo.",
    "sessionExpired": "Tu sesión caducó. Vuelve a iniciar sesión.",
    "notAllowed": "Tu rol no puede: {{action}}. Pídeselo al admin de la agencia si lo necesitas.",
    "outsideScope": "Ese carrier no es de los tuyos.",
    "driverOutsideScope": "Este chofer también maneja para carriers que no llevas tú. Dale de baja en tu carrier en su lugar.",
    "driverOnTruckOutsideScope": "Este chofer está en un camión de un carrier que no llevas tú. Pide a quien lleva ese carrier que lo quite de ahí primero.",
    "adminOnly": "Solo el admin de la agencia puede cambiar esto.",
    "forbidden": "No tienes permiso para hacer eso.",
    "notFound": "{{thing}} ya no existe. Recarga la página.",
    "notFoundGeneric": "Algo que necesita esta acción ya no existe. Recarga la página.",
    "noSeat": "Ese chofer no maneja para el carrier de este camión. Primero dalo de alta en el carrier desde la pantalla Choferes.",
    "adminAlways": "El rol admin siempre tiene todos los permisos.",
    "dateInFuture": "La fecha no puede ser posterior a hoy.",
    "outdated": "El portal es más antiguo que el servidor. Recarga la página.",
    "invalidField": "Revisa el campo: {{field}}.",
    "invalid": "El servidor rechazó estos valores. Revisa el formulario.",
    "duplicateCarrierMc": "Otro carrier de esta agencia ya tiene este número MC.",
    "duplicateCarrierDot": "Otro carrier de esta agencia ya tiene este número DOT.",
    "duplicateBrokerMc": "Otro broker de esta agencia ya tiene este número MC.",
    "duplicateBrokerDot": "Otro broker de esta agencia ya tiene este número DOT.",
    "duplicateUnit": "Este carrier ya tiene un camión con ese número de unidad.",
    "duplicateVin": "Ya existe un camión con este VIN.",
    "duplicate": "Ese valor ya está en uso.",
    "notActive": "{{thing}} no está en activo.",
    "badState": "Este registro cambió mientras tanto. Recarga la página.",
    "constraint": "El servidor rechazó estos valores. Revisa el formulario.",
    "driverLinked": "Este chofer ya usa la app. No necesita código.",
    "driverDuplicatePhone": "Ya existe un chofer con este teléfono en esta agencia.",
    "testFence": "No se pueden mezclar registros de prueba con registros reales.",
    "termsChanged": "Los Términos se actualizaron mientras los leías. Revisa la nueva versión.",
    "truckCap": "Tu plan cubre hasta {{cap}} camiones activos. Escríbenos para pasar a un plan Enterprise y agregar más.",
    "truckCapNoNumber": "Tu plan no cubre más camiones activos. Escríbenos para pasar a un plan Enterprise y agregar más.",
    "retry": "Otra persona cambió esto al mismo tiempo. Vuelve a intentarlo.",
    "generic": "Algo salió mal ({{code}}). Vuelve a intentarlo.",
    "confirmEmail": "Confirma primero tu correo: abre el enlace de acceso que te enviamos.",
    "onlyAdminGrants": "Solo un admin puede dar el rol de admin o de manager.",
    "onlyAdminChanges": "Solo un admin puede cambiar a un admin o a un manager.",
    "mailboxProof": "Para confirmar que eres tú, abre el enlace de acceso enviado a tu correo.",
    "inviteDailyLimit": "Esta agencia ya envió hoy sus correos de invitación. Vuelve a intentarlo mañana.",
    "inviteSendLimit": "Esta invitación se envió 5 veces. Cancélala e invita de nuevo.",
    "inviteCooldown": "Espera un minuto antes de volver a enviar esta invitación.",
    "limitReached": "Se alcanzó un límite. Vuelve a intentarlo más tarde.",
    "inviteNotFound": "No encontramos esta invitación para tu correo, o caducó.",
    "lastAdmin": "La agencia necesita al menos un admin activo. Haz admin a otra persona primero.",
    "alreadyMember": "Esta persona ya es miembro de la agencia.",
    "inactiveMember": "Esta persona es un miembro dado de baja. Dale de alta en su lugar.",
    "inviteNotPending": "Esta invitación ya no está pendiente.",
    "alreadyJoined": "Ya eres miembro de esta agencia.",
    "membershipInactive": "Tu membresía está dada de baja. Pide al admin de la agencia que te dé de alta.",
    "invoiceDraft": "Esta factura es un borrador. Envíala primero.",
    "invoicePaid": "Esta factura ya está pagada.",
    "invoiceCanceled": "Esta factura está anulada.",
    "nothingToWriteOff": "No queda nada por dar por perdido en esta factura.",
    "alreadyReversed": "Esto ya se revirtió.",
    "invoiceHasPayments": "Esta factura tiene pagos. Reviértelos antes de anularla.",
    "alreadyInvoiced": "Esta carga ya está facturada al broker.",
    "notPodReceived": "Solo se factura al broker una carga con su POD recibido o una carga cancelada con TONU.",
    "notInvoiced": "Esta carga no está facturada al broker.",
    "receivableClosed": "Este cobro está cerrado. Reábrelo primero.",
    "receivableOpen": "Este cobro sigue abierto.",
    "reverseReceiptsFirst": "Revierte sus cobros antes de desmarcarla.",
    "unmarkBeforeCancel": "Esta carga está facturada al broker. Desmárcala antes de cancelarla.",
    "unmarkBeforeEdit": "Esta carga está facturada al broker. Desmárcala en Pagos de brokers antes de cambiar el broker o el número de carga.",
    "loadNotEditable": "Una carga cancelada o pagada no se puede editar.",
    "amountOverBalance": "El importe supera el saldo de {{balance}}.",
    "invalidAmount": "Revisa el importe.",
    "amountBelowReceived": "El importe no puede ser menor que lo ya cobrado ({{received}}).",
    "dateBeforeInvoice": "La fecha no puede ser anterior a la fecha de factura.",
    "dueBeforeInvoice": "El vencimiento no puede ser anterior a la fecha de factura.",
    "reasonRequired": "Escribe un motivo.",
    "reasonTooLong": "El motivo es demasiado largo (500 caracteres como máximo).",
    "factoringRequired": "Indica la empresa de factoring de una carga con factoring.",
    "invalidEmail": "No es un email válido.",
    "onlyDispatcherCarriers": "Solo a un dispatcher se le asignan carriers.",
    "duplicateInvoiceNumber": "Este carrier ya usó el número de factura {{number}}.",
    "notAllowedRun": "Tu rol no puede operar cargas de este carrier.",
    "stopGone": "Esa parada ya no está en la carga. Recarga la página.",
    "uploadMissing": "El archivo no llegó al servidor. Súbelo de nuevo.",
    "loadMoved": "Otra persona cambió esta carga. Ahora está {{status}}.",
    "loadFinished": "Esta carga está terminada: su itinerario no puede cambiar.",
    "stopVisited": "El chofer ya pasó por esta parada.",
    "stopAlreadyArrived": "La llegada a esta parada ya está registrada.",
    "stopAlreadyDeparted": "La salida de esta parada ya está registrada.",
    "stopNotArrived": "Registra la llegada antes que la salida.",
    "lastStopOfKind": "Es la única parada de su tipo y el chofer se quedaría sin itinerario.",
    "feeOnInvoice": "La comisión de esta carga está en una factura al carrier. Quita la línea antes de cancelar.",
    "feeInvoiceSent": "La comisión está en una factura al carrier ya enviada: no se puede cambiar la tarifa.",
    "needsStops": "Añade una recogida y una entrega antes de despachar.",
    "driverNotSeated": "Este chofer no tiene un puesto activo en el carrier de la carga.",
    "truckNotOfCarrier": "Este camión no es del carrier de la carga.",
    "noFeePlan": "Fija el % de dispatch de este carrier y la tarifa de la carga antes de confirmar el POD.",
    "useReprice": "La comisión ya está ganada: usa Cambiar la tarifa.",
    "duplicateLoadNumber": "Ese número de carga ya se usa en esta agencia.",
    "stampBeforeArrival": "La salida no puede ser antes de la llegada.",
    "fileTooLarge": "El archivo es demasiado grande: 25 MB como máximo.",
    "fileType": "Este tipo de archivo no se acepta: usa PDF, JPEG, PNG, HEIC o WebP.",
    "storageUnreachable": "El servidor de archivos no respondió. No se subió nada.",
    "tonuState": "El TONU solo aplica a una carga cuyo camión fue pedido y aún no se cargó.",
    "tonuOnLiveLoad": "El TONU se registra al cancelar la carga.",
    "tonuNotZero": "Un TONU registrado al cancelar no se puede dejar en cero. Escribe el importe que paga el broker.",
    "extrasBelowParts": "El total de extras es menor que el TONU, el detention y el lumper desglosados. Cambia los importes desglosados.",
    "unassignRolling": "El chofer ya llegó a una parada de esta carga, así que no se le puede quitar. Cancela la carga.",
    "unassignNeedsReason": "El chofer ya aceptó esta carga. Escribe un motivo para quitársela.",
    "onStop": "Parada {{n}}: {{reason}}",
    "windowNeedsStart": "Escribe la hora de la cita antes del fin de la ventana.",
    "windowBeforeStart": "La ventana termina antes de empezar."
  },
  "fleetStatus": {
    "active": "Activo",
    "suspended": "Suspendido",
    "out_of_service": "Fuera de servicio",
    "inactive": "Inactivo",
    "ended": "Terminado",
    "current": "Actual",
    "consequence": {
      "carrier": {
        "active": "Funciona con normalidad: cargas nuevas, despacho, todo.",
        "suspended": "Esta agencia no permite cargas nuevas para carriers suspendidos. Las cargas en curso terminan. No se borra nada.",
        "suspendedLoadsAllowed": "Esta agencia permite crear cargas para un carrier suspendido, pero no se despachan a un camión hasta que vuelva a estar activo. No se borra nada.",
        "inactive": "Sin cargas nuevas. El trabajo en curso termina. No se borra nada."
      },
      "owner": {
        "active": "Se puede vincular a carriers y camiones.",
        "inactive": "Se conserva en el registro; no se puede vincular a carriers ni camiones nuevos."
      },
      "truck": {
        "active": "Disponible para cargas.",
        "out_of_service": "En el taller: sin cargas nuevas. Sus choferes siguen asignados.",
        "inactive": "Vendido o retirado. Sin cargas nuevas.",
        "inactiveEnds_one": "Además termina {{count}} asignación de chofer en la unidad {{unit}}.",
        "inactiveEnds_other": "Además termina {{count}} asignaciones de chofer en la unidad {{unit}}."
      },
      "driver": {
        "active": "Se le pueden asignar camiones y cargas.",
        "inactive": "Sin cargas nuevas. La carga que lleva termina igual.",
        "inactiveTruck": "Quita a {{name}} de la unidad {{unit}}.",
        "inactiveInvite": "Cancela su código pendiente de la app."
      }
    }
  },
  "setupStatus": {
    "not_started": "Sin empezar",
    "in_progress": "En curso",
    "submitted": "Enviado",
    "approved": "Aprobado",
    "rejected": "Rechazado"
  },
  "carriers": {
    "new": "Nuevo carrier",
    "createTitle": "Nuevo carrier",
    "editTitle": "Editar carrier",
    "saved": "Carrier guardado",
    "created": "Carrier creado",
    "addTruck": "Agregar un camión",
    "addDriver": "Agregar un chofer",
    "empty": "Todavía no hay carriers. Agrega el primero para empezar a despachar.",
    "emptyReadOnly": "Todavía no hay carriers.",
    "emptyStatus": "No hay carriers con este estado.",
    "tabs": "Carriers y dueños",
    "tabCarriers": "Carriers",
    "tabOwners": "Dueños",
    "search": "Buscar por nombre, DBA, MC o DOT",
    "statusFilter": "Estado del carrier",
    "brokerSetups": "Setups con brokers",
    "viewTrucks": "Camiones de {{name}}",
    "viewDrivers": "Choferes de {{name}}",
    "noOwner": "Sin dueño",
    "col": {
      "carrier": "Carrier",
      "mc": "MC",
      "dot": "DOT",
      "owner": "Dueño",
      "trucks": "Camiones",
      "drivers": "Choferes",
      "dispatchPct": "% de despacho",
      "status": "Estado",
      "actions": "Acciones"
    },
    "sections": {
      "identity": "Identidad",
      "address": "Dirección",
      "contact": "Contacto",
      "business": "Condiciones comerciales",
      "owner": "Dueño",
      "notes": "Notas",
      "billing": "Facturación y documentos",
      "factoring": "Factoring",
      "numbering": "Numeración de facturas al broker"
    },
    "localeDefault": "El de la agencia",
    "billingEmailHelp": "Aquí llega la factura semanal. Vacío: el correo de contacto.",
    "nextBrokerInvoice": "Siguiente factura al broker: {{number}}",
    "nextBrokerInvoiceEstimate": "Siguiente factura al broker, si no está usada: {{number}}",
    "numberingHelp": "Las facturas a brokers por las cargas de este carrier siguen su propia serie. Un número ya usado se salta.",
    "factoringHelp": "En las cargas con factoring el broker paga a esta empresa; su dirección de pago sale en la factura al broker. La lista se gestiona en Ajustes > Factoring.",
    "noFactoring": "Ninguna: al carrier se le paga directamente",
    "factoringInactive": "{{name}} (inactiva)"
  },
  "owners": {
    "new": "Nuevo dueño",
    "createTitle": "Nuevo dueño",
    "editTitle": "Editar dueño",
    "saved": "Dueño guardado",
    "created": "Dueño creado",
    "empty": "Todavía no hay dueños.",
    "emptyStatus": "No hay dueños con este estado.",
    "search": "Buscar por nombre, DBA o EIN",
    "statusFilter": "Estado del dueño",
    "col": {
      "legalName": "Nombre legal",
      "dba": "DBA",
      "ein": "EIN",
      "contact": "Contacto",
      "carriers": "Carriers",
      "status": "Estado",
      "actions": "Acciones"
    },
    "sections": {
      "identity": "Identidad",
      "address": "Dirección",
      "contact": "Contacto",
      "notes": "Notas"
    }
  },
  "trucks": {
    "new": "Nuevo camión",
    "createTitle": "Nuevo camión",
    "editTitle": "Editar camión",
    "saved": "Camión guardado",
    "created": "Camión creado",
    "empty": "Todavía no hay camiones.",
    "emptyStatus": "No hay camiones con este estado.",
    "unassigned": "Sin asignar",
    "search": "Buscar por unidad, VIN, placa, marca o modelo",
    "statusFilter": "Estado del camión",
    "carrierFilter": "Carrier",
    "allCarriers": "Todos los carriers",
    "carrier": "Carrier",
    "carrierPick": "Elige un carrier",
    "noOwner": "Sin dueño",
    "unit": "Unidad {{unit}}",
    "dimensions": "{{length}} x {{width}} x {{height}} ft",
    "manageDrivers": "Choferes de la unidad {{unit}}",
    "manageDriversName": "{{shown}}, choferes de la unidad {{unit}}",
    "assignTitle": "Choferes de la unidad {{unit}}",
    "assignCurrent": "En este camión",
    "assignNobody": "Nadie maneja este camión todavía.",
    "assignPick": "Ponerle un chofer",
    "assignPickPlaceholder": "Elige un chofer",
    "assign": "Asignar",
    "unassign": "Quitar a {{name}}",
    "movesFrom": "Pasa a {{name}} desde la unidad {{unit}}.",
    "noCandidates": "Ningún chofer activo tiene puesto en {{carrier}}. Agrégalo al carrier en la pantalla de Choferes.",
    "assigned": "{{name}} está en la unidad {{unit}}",
    "unassignedToast": "{{name}} ya no está en la unidad {{unit}}",
    "col": {
      "unit": "Unidad",
      "carrier": "Carrier",
      "vehicle": "Vehículo",
      "equipment": "Equipo",
      "plate": "Placa",
      "drivers": "Choferes",
      "status": "Estado",
      "actions": "Acciones",
      "owner": "Dueño"
    },
    "sections": {
      "identity": "Camión",
      "registration": "Registro",
      "equipment": "Equipo",
      "owner": "Dueño"
    },
    "cargoTypes": {
      "dry_van": "Caja seca",
      "reefer": "Refrigerado",
      "flatbed": "Plataforma",
      "step_deck": "Step deck",
      "power_only": "Solo tractor",
      "hotshot": "Hotshot",
      "box_truck": "Camión de caja",
      "tanker": "Cisterna",
      "car_hauler": "Portaautos",
      "other": "Otro"
    },
    "ownerUnavailable": "Dueño no disponible",
    "leasedBadge": "Arrendado {{pct}}%"
  },
  "drivers": {
    "new": "Nuevo chofer",
    "createTitle": "Nuevo chofer",
    "editTitle": "Editar chofer",
    "saved": "Chofer guardado",
    "added": "{{name}} fue agregado a {{carrier}}.",
    "empty": "Todavía no hay choferes.",
    "emptyStatus": "No hay choferes con este estado.",
    "search": "Buscar por nombre, teléfono, email o licencia",
    "statusFilter": "Estado del chofer",
    "carrierFilter": "Carrier",
    "allCarriers": "Todos los carriers",
    "carrier": "Carrier",
    "carrierPick": "Elige un carrier",
    "showEnded": "Mostrar puestos terminados",
    "noTruck": "Sin camión",
    "appCode": "Código de la app",
    "sendCodeNow": "Enviar el código de la app ahora",
    "app": {
      "linked": "Vinculado",
      "pending": "Código pendiente, vence {{when}}",
      "expired": "Código vencido",
      "none": "Sin invitar"
    },
    "col": {
      "name": "Nombre",
      "carriers": "Carriers",
      "phone": "Teléfono",
      "truck": "Camión",
      "app": "App",
      "status": "Estado",
      "actions": "Acciones"
    },
    "sections": {
      "identity": "Chofer",
      "license": "Licencia",
      "notes": "Notas",
      "seats": "Carriers para los que maneja"
    },
    "seats": {
      "since": "Desde {{date}}",
      "endedOn": "Terminó {{date}}",
      "none": "No tiene puesto en ningún carrier.",
      "end": "Terminar puesto",
      "endLabel": "Terminar puesto en {{carrier}}",
      "endTitle": "¿Terminar el puesto en {{carrier}}?",
      "endBody": "Termina su asignación en los camiones de {{carrier}}. Sus cargas en curso se terminan.",
      "ended": "Puesto terminado",
      "add": "Agregar a un carrier",
      "addPick": "Carrier",
      "addPlaceholder": "Elige un carrier",
      "added": "Puesto agregado",
      "nothingToAdd": "Ya tiene puesto en todos los carriers activos."
    },
    "createDescription": "Añade un chofer a uno de tus carriers. Luego puedes enviarle el código de la app.",
    "duplicate": {
      "title": "Este teléfono ya está en tu agencia",
      "inScope": "{{name}} ya está entre tus choferes ({{carriers}}).",
      "inScopeNoSeats": "{{name}} ya está entre tus choferes.",
      "addPrompt": "¿Agregarlo a {{carrier}} en vez de crear un segundo registro?",
      "pickCarrier": "Elige un carrier arriba para agregarlo.",
      "alreadySeated": "{{name}} ya maneja para {{carrier}}.",
      "inactive": "{{name}} ya está entre tus choferes, pero inactivo. Ábrelo para reactivarlo.",
      "outOfScope": "Ya existe un chofer con este teléfono en carriers que no llevas tú. Pide a un admin o manager que lo agregue a este carrier.",
      "addToCarrier": "Agregar al carrier",
      "openDriver": "Abrir chofer",
      "createAnyway": "Crear un registro aparte de todos modos",
      "forced": "Al guardar se crea un registro aparte con este teléfono.",
      "samePhone": "Mismo teléfono que {{names}}"
    }
  },
  "invite": {
    "share": "{{name}}, tu código de Coreway Driver es {{code}}. Instala la app Coreway Driver, inicia sesión y escribe el código. Vence el {{expires}} (hora de {{zone}}).",
    "revoked": "Código cancelado",
    "title": "Código de la app para {{name}}",
    "minting": "Creando el código…",
    "confirmBody": "{{name}} tiene un código pendiente hasta el {{when}}. Uno nuevo lo reemplaza.",
    "newCode": "Crear un código nuevo",
    "revoke": "Cancelar el código",
    "codeLabel": "Código de la app",
    "copyCode": "Copiar código",
    "validUntil": "Válido hasta el {{when}} (hora de {{zone}})",
    "onceWarning": "Este código se muestra una sola vez. Cópialo o envíalo ahora.",
    "messageLang": "Idioma del mensaje",
    "langEs": "Español",
    "langEn": "English",
    "langHint": "Los choferes leen sobre todo en español; cambia si {{name}} prefiere inglés.",
    "preview": "Mensaje",
    "copyMessage": "Copiar mensaje",
    "openWhatsapp": "Abrir WhatsApp",
    "failed": "No se pudo crear el código.",
    "description": "Envía este código a {{name}}: lo escribe en la app Coreway Driver."
  },
  "brokers": {
    "new": "Nuevo broker",
    "createTitle": "Nuevo broker",
    "editTitle": "Editar broker",
    "saved": "Broker guardado",
    "empty": "Todavía no hay brokers.",
    "emptyHint": "Agrega los brokers con los que reservan tus dispatchers, para seguir el alta de cada carrier con ellos.",
    "sheetHelp": "La lista de brokers es de toda la agencia.",
    "search": "Buscar brokers",
    "searchPlaceholder": "Nombre, MC o DOT",
    "count_one": "{{count}} broker",
    "count_other": "{{count}} brokers",
    "setupsCount": "Aprobadas: {{approved}} de {{total}}",
    "noSetups": "Ninguna todavía",
    "sections": {
      "identity": "Broker",
      "contact": "Contacto",
      "address": "Dirección"
    },
    "columns": {
      "broker": "Broker",
      "mc": "MC",
      "dot": "DOT",
      "location": "Ubicación",
      "phone": "Teléfono",
      "email": "Correo",
      "setups": "Altas",
      "actions": "Acciones"
    },
    "billingEmailHelp": "La dirección de cuentas por pagar (AP) del broker. Las facturas van aquí; si no hay, al correo de arriba.",
    "payStats": {
      "title": "Historial de pagos",
      "help": "Del libro del broker de los carriers que ves.",
      "none": "Todavía no hay facturas a este broker.",
      "invoiced": "Facturas",
      "open": "Abiertas",
      "openBalance": "Saldo abierto",
      "closed": "Cerradas",
      "avgDays": "Días promedio de pago",
      "days_one": "{{count}} día",
      "days_other": "{{count}} días",
      "shortPays": "Pagos incompletos",
      "lastPaid": "Último pago",
      "error": "No se pudo leer el historial de pagos."
    }
  },
  "brokerSetups": {
    "saved": "Alta guardada",
    "approvedTodayHint": "Se registrará la fecha de hoy.",
    "verifiedToday": "Verifiqué esta alta hoy",
    "never": "Nunca",
    "sheetTitle": "{{carrier}} con {{broker}}",
    "sheetHelp": "Cómo está este carrier con este broker y cuándo lo revisó alguien por última vez.",
    "lastVerified": "Última verificación: {{when}}",
    "view": {
      "label": "Vista",
      "carrier": "Por carrier",
      "broker": "Por broker"
    },
    "carrierSelect": "Carrier",
    "brokerSelect": "Broker",
    "searchBrokers": "Buscar brokers",
    "searchCarriers": "Buscar carriers",
    "searchPlaceholder": "Nombre o MC",
    "statusFilter": "Estado del alta",
    "noCarriers": "Todavía no hay carriers. Agrega uno primero en la pantalla Carriers.",
    "noBrokers": "Todavía no hay brokers. Agrega uno primero en la pantalla Brokers.",
    "noneInStatus": "No hay altas con este estado.",
    "columns": {
      "broker": "Broker",
      "carrier": "Carrier",
      "mc": "MC",
      "status": "Estado del alta",
      "setupDate": "Fecha de alta",
      "lastVerified": "Última verificación",
      "notes": "Notas",
      "actions": "Acciones"
    }
  },
  "settings": {
    "tabs": {
      "label": "Secciones de ajustes",
      "team": "Equipo",
      "permissions": "Permisos y reglas",
      "profile": "Mi perfil",
      "fees": "Comisiones",
      "pay": "Pago a choferes",
      "company": "Empresa",
      "billing": "Facturación",
      "factoring": "Factoring"
    },
    "agencyRules": {
      "title": "Reglas de la agencia",
      "intro": "Cómo trata la agencia a los carriers suspendidos y a los brokers que le deben dinero.",
      "readOnlyNote": "Solo el admin de la agencia cambia estas reglas."
    },
    "brokerTerms": {
      "label": "Plazo de pago de los brokers",
      "suffix": "días",
      "help": "Cuando una carga se factura a un broker, su vencimiento es la fecha de factura más los días de pago del último credit check del broker, o este número si no tiene ninguno. Ejemplo: 30 días: facturada el 1 sept, vence el 1 oct.",
      "save": "Guardar plazo",
      "saved": "Plazo de pago guardado"
    },
    "disputeHoldsFee": {
      "label": "Las disputas de brokers retienen la comisión de la agencia",
      "help": "Activado (por defecto): mientras un broker disputa una carga, la comisión de la agencia sobre ella queda fuera de la factura semanal del carrier hasta que se resuelve la disputa. Desactivado: la comisión se factura como siempre. Una comisión que ya está en una factura nunca se retira.",
      "saved": "Ajuste guardado"
    },
    "permissions": {
      "title": "Permisos",
      "intro": "Elige qué puede hacer cada rol de la oficina. Ejemplo: apaga Agregar y editar camiones para Dispatcher y solo managers y admins agregarán camiones.",
      "adminHelp": "El admin siempre puede todo, así la agencia nunca se queda bloqueada.",
      "readOnlyNote": "Solo el admin de la agencia cambia esto. Puedes ver qué puede hacer cada rol.",
      "scopeNote": "Una dispatcher sigue actuando solo sobre los carriers que tiene asignados, diga lo que diga esta tabla.",
      "custom": "Personalizado",
      "reset": "Volver al valor por defecto",
      "defaultOn": "Por defecto: encendido",
      "defaultOff": "Por defecto: apagado",
      "cellLabel": "{{action}} para {{role}}",
      "resetCell": "Volver al valor por defecto: {{cell}}",
      "actionHeader": "Acción",
      "adminLocked": "Siempre permitido",
      "loadError": "No se pudieron cargar los permisos."
    },
    "suspended": {
      "saved": "Ajuste guardado",
      "readOnlyNote": "Solo el admin de la agencia cambia este ajuste.",
      "title": "Cargas para carriers suspendidos",
      "label": "Los carriers suspendidos pueden recibir cargas nuevas",
      "help": "Apagado (por defecto): nadie puede crear una carga para un carrier suspendido. Encendido: se pueden crear, por ejemplo para seguir reservando mientras renueva el seguro, pero no se despachan a un camión hasta que el carrier vuelva a estar activo. Los carriers inactivos nunca reciben cargas nuevas."
    }
  },
  "permissionGroups": {
    "owner": "Dueños",
    "carrier": "Carriers",
    "truck": "Camiones",
    "maintenance": "Mantenimiento de camiones",
    "driver": "Choferes",
    "broker": "Brokers",
    "credit": "Crédito de brokers",
    "invoice": "Facturas a carriers",
    "receivable": "Cobros a brokers",
    "team": "Equipo",
    "owner_fee": "Comisiones de dueños (camiones arrendados)",
    "billing": "Plan y facturación de Coreway",
    "dispatcher_pay": "Pago de dispatchers",
    "activity": "Actividad",
    "driver_pay": "Pago a choferes"
  },
  "permissions": {
    "owner": {
      "manage": {
        "label": "Gestionar dueños",
        "help": "Agregar y editar dueños y vincularlos a un carrier o a un camión arrendado. Ejemplo: registrar a Luis Mierez como dueño de sus dos MC."
      }
    },
    "carrier": {
      "create": {
        "label": "Agregar carriers",
        "help": "Crear un carrier nuevo en la cartera de la agencia. Ejemplo: la agencia firma con Panthers Express y registra su MC y DOT."
      },
      "edit": {
        "label": "Editar datos del carrier",
        "help": "Cambiar nombre, MC, DOT, dirección, contacto, factoring y notas. Ejemplo: el carrier cambia de empresa de factoring."
      },
      "edit_terms": {
        "label": "Editar condiciones del carrier",
        "help": "Cambiar los días de pago y la tarifa mínima por milla. Ejemplo: el carrier ahora acepta cargas desde $2.10 la milla."
      },
      "set_status": {
        "label": "Suspender o dar de baja carriers",
        "help": "Marcar un carrier activo, suspendido o inactivo. Ejemplo: suspender un carrier con el seguro vencido."
      }
    },
    "truck": {
      "manage": {
        "label": "Agregar y editar camiones",
        "help": "Agregar camiones y editar unidad, VIN, placa y equipo. Ejemplo: el carrier compra la unidad 112, un reefer de 53 pies."
      },
      "set_status": {
        "label": "Sacar camiones de servicio",
        "help": "Marcar un camión activo, fuera de servicio o inactivo; inactivo además le quita sus choferes. Ejemplo: la unidad 104 entra al taller una semana."
      },
      "assign_driver": {
        "label": "Asignar choferes a camiones",
        "help": "Poner o quitar un chofer de un camión. Un chofer maneja un camión a la vez: asignarlo a otro lo mueve. Ejemplo: Pedro pasa de la unidad 98 a la 104."
      }
    },
    "maintenance": {
      "manage": {
        "label": "Llevar el mantenimiento de camiones",
        "help": "Activar el seguimiento de mantenimiento de un camión, fijar sus planes de servicio (cada N millas o días) y registrar servicios con su costo. Ejemplo: cambio de aceite de la unidad 104 cada 25,000 mi."
      }
    },
    "odometer": {
      "record": {
        "label": "Registrar lecturas de odómetro",
        "help": "Anotar el odómetro de un camión o anular una lectura equivocada con un motivo. Los planes por millas cuentan desde estas lecturas. Ejemplo: la unidad 104 marca 412,350 mi en la parada de combustible."
      }
    },
    "driver": {
      "edit": {
        "label": "Agregar y editar choferes",
        "help": "Agregar choferes, editar contacto y licencia, y darlos de alta o baja en un carrier. Ejemplo: Pedro empieza a manejar también para otro carrier."
      },
      "set_status": {
        "label": "Dar de baja choferes",
        "help": "Marcar un chofer activo o inactivo; inactivo lo quita de su camión y cancela su código pendiente, y la carga que lleva termina igual. Ejemplo: un chofer renuncia."
      }
    },
    "broker": {
      "manage": {
        "label": "Gestionar la lista de brokers",
        "help": "Agregar brokers y editar sus datos; la lista es de toda la agencia. Ejemplo: una dispatcher reserva con un broker nuevo de DAT."
      }
    },
    "broker_credit": {
      "record": {
        "label": "Registrar revisiones de crédito de brokers",
        "help": "Guardar lo que dice DAT, Truckstop, la compañía de factoring o FMCSA de un broker, con una decisión: aprobado, precaución o rechazado. Ejemplo: TQL muestra hoy A 94 y 28 días de pago en DAT."
      }
    },
    "broker_incident": {
      "manage": {
        "label": "Registrar incidentes con brokers",
        "help": "Registrar, resolver y reabrir lo que salió mal con un broker: pago tardío, impago, una disputa, sospecha de doble corretaje. Ejemplo: el broker lleva 20 días de retraso con la carga CW-1042."
      }
    },
    "broker_setup": {
      "manage": {
        "label": "Actualizar altas con brokers",
        "help": "Registrar si un carrier está dado de alta con un broker: estado, fecha, última verificación. Ejemplo: TQL aprobó hoy el alta de Panthers."
      }
    },
    "invoice": {
      "record_payment": {
        "label": "Registrar pagos de facturas de carriers",
        "help": "Registrar un pago que el carrier hizo a la factura semanal de la agencia, total o parcial; una factura pagada deja de enviar recordatorios. La lista de facturas sigue visible solo para admin y contabilidad. Ejemplo: Panthers Express paga $450 de la factura de esta semana por Zelle."
      },
      "reverse_payment": {
        "label": "Revertir pagos de facturas de carriers",
        "help": "Deshacer un pago registrado, con un motivo, si rebotó o se anotó por error; la factura vuelve a quedar abierta y sus recordatorios siguen. Ejemplo: rebota un cheque de Panthers Express."
      },
      "write_off": {
        "label": "Dar por perdidas facturas de carriers",
        "help": "Cerrar lo que queda de una factura como incobrable, con un motivo; la factura cuenta como pagada. Ejemplo: un carrier que cerró todavía debe $120 que la agencia nunca va a cobrar."
      }
    },
    "receivable": {
      "mark_invoiced": {
        "label": "Marcar cargas facturadas al broker",
        "help": "Registrar que el carrier, o su empresa de factoring, le facturó al broker una carga con el POD recibido: número de factura, monto y vencimiento. Ejemplo: la carga CW-1040 va a TQL como la factura A1-001, a 30 días."
      },
      "record_payment": {
        "label": "Registrar pagos de brokers",
        "help": "Registrar lo que el broker o la empresa de factoring pagó por una carga; pagada completa, la carga queda pagada, y un pago incompleto se puede cerrar con un motivo. Ejemplo: el factoring adelanta $2,150 por la carga CW-1040."
      },
      "dispute": {
        "label": "Disputar cobros a brokers",
        "help": "Marcar que el broker disputa la factura de una carga, con un motivo; si el ajuste de la agencia está activo, la comisión de la agencia en esa carga queda retenida hasta cerrar la disputa. Ejemplo: el broker rechaza un cargo de detention de $150."
      },
      "correct": {
        "label": "Corregir cobros a brokers",
        "help": "Corregir los datos de un cobro, revertir un pago recibido, reabrir un cobro cerrado o desmarcar una carga facturada por error. Ejemplo: un cheque se aplicó a la carga equivocada y hay que revertirlo."
      }
    },
    "report": {
      "receivables": {
        "label": "Ver cobros a brokers en los reportes",
        "help": "Muestra lo que deben los brokers en Reportes > Explorar: número y fechas de factura, monto, cobrado, saldo, estado de cobro, antigüedad y factoraje, y la vista Pendiente de cobro. Sin este permiso esas columnas no aparecen. Ejemplo: un dispatcher ve las cargas y el bruto, pero no lo que TQL aún debe."
      }
    },
    "lockedField": "Tu rol no puede cambiar esto: {{action}}.",
    "deniedHint": "Tu rol no puede hacer esto. Pídeselo al admin de la agencia.",
    "member": {
      "invite": {
        "label": "Invitar personas a la oficina",
        "help": "Invitar a una persona por correo y reenviar o cancelar invitaciones pendientes. Sin ser admin solo se invita a dispatchers y contabilidad. Ejemplo: invitar a Ana, la nueva dispatcher, con sus carriers."
      },
      "manage": {
        "label": "Gestionar miembros de la oficina",
        "help": "Cambiar el rol de un miembro y darlo de baja o de alta. Sin ser admin: solo dispatchers y contabilidad, nunca a uno mismo. La agencia siempre conserva un admin activo. Ejemplo: Pedro pasa de dispatch a contabilidad."
      }
    },
    "dispatcher": {
      "assign_carriers": {
        "label": "Asignar carriers a dispatchers",
        "help": "Elegir qué carriers lleva cada dispatcher: solo ve y trabaja esos. Ejemplo: darle a Ana el carrier Panthers Express."
      }
    },
    "fee_settings": {
      "edit": {
        "label": "Editar ajustes de comisiones",
        "help": "Cambiar sobre qué se calcula el porcentaje de la agencia, los valores por defecto de los arrendamientos y las reglas de los estados de cuenta. Ejemplo: fijar en 5 % el porcentaje de la agencia sobre el detention."
      }
    },
    "lease": {
      "manage": {
        "label": "Gestionar arrendamientos",
        "help": "Arrendar un camión a un carrier, cambiar su comisión y sus cargos semanales, terminar el arrendamiento. Ejemplo: el T-12 de Pedro arrendado a Panthers al 15 % con $250 de seguro a la semana."
      }
    },
    "owner_statement": {
      "manage": {
        "label": "Preparar estados de cuenta",
        "help": "Generar un estado de cuenta, añadir una deducción o un crédito, perdonar un cargo semanal, pasar una carga a la semana siguiente. Ejemplo: añadir la tarjeta de combustible al estado de cuenta de Pedro."
      },
      "finalize": {
        "label": "Finalizar estados de cuenta",
        "help": "Cerrar un borrador para poder pagarlo; un estado de cuenta final ya no cambia. Ejemplo: finalizar OS-1001 el viernes después de revisarlo."
      },
      "cancel": {
        "label": "Cancelar estados de cuenta",
        "help": "Cancelar un borrador o un estado de cuenta final con un motivo; sus cargas vuelven a quedar pendientes. Ejemplo: cancelar OS-1001 porque la tarjeta de combustible se anotó dos veces."
      }
    },
    "billing": {
      "manage": {
        "label": "Gestionar el plan y la facturación de Coreway",
        "help": "Ver el plan y las facturas que Coreway envía a la agencia, añadir una tarjeta, suscribirse y pagar una factura abierta. Ejemplo: dejar que Contabilidad pague la factura mensual."
      }
    },
    "dispatcher_pay": {
      "manage": {
        "label": "Definir el pago de dispatchers",
        "help": "Elegir el plan de pago de cada dispatcher (también al invitarlo), las bases de pago que usa la agencia y el plan por defecto. Requiere además el rol admin o contabilidad. Ejemplo: pasar a Ana del 25% de la comisión al 30% desde el lunes."
      },
      "record_payment": {
        "label": "Registrar pagos a dispatchers",
        "help": "Marcar pagada la semana de un dispatcher, completa o en parte. Requiere además el rol admin o contabilidad. Ejemplo: registrar el Zelle de $450 enviado a Ana el viernes."
      },
      "reverse_payment": {
        "label": "Revertir pagos a dispatchers",
        "help": "Deshacer un pago registrado por error, con un motivo; el pago queda en la lista como revertido. Ejemplo: el Zelle se registró dos veces."
      }
    },
    "activity": {
      "read": {
        "label": "Ver la actividad del equipo",
        "help": "La pestaña Actividad de la campana y la página de Actividad: lo que hacen el equipo y los choferes en las cargas, carriers, camiones y choferes que este rol ve. Un dispatcher ve solo los carriers que tiene asignados. Ejemplo: Ana llegó a la recogida de CW-1046."
      },
      "office": {
        "label": "Ver la actividad de la oficina",
        "help": "También las acciones de oficina que no son de ningún carrier: invitaciones y roles, brokers y factoring, ajustes de la agencia. Son de toda la agencia, así que un dispatcher con este permiso las ve todas. Ejemplo: Maria invitó a un nuevo dispatcher."
      },
      "money": {
        "label": "Ver la actividad de dinero",
        "help": "También los eventos de dinero: facturas a carriers, estados de cuenta de dueños, arrendamientos, planes de pago y ajustes de comisiones, y los documentos de dinero. El feed nunca muestra una cantidad, solo que algo pasó. Ejemplo: se emitió una factura a Panthers Express."
      }
    },
    "driver_settlement": {
      "manage": {
        "label": "Preparar liquidaciones de choferes",
        "help": "Armar la liquidación semanal de un chofer que paga tu agencia o un dueño, añadir o quitar líneas y anotar horas. También requiere el rol admin o contabilidad. Ejemplo: añadir un ajuste de $50 de adelanto de combustible a la semana de Pedro."
      },
      "finalize": {
        "label": "Cerrar liquidaciones de choferes",
        "help": "Cerrar una liquidación revisada para que sus números no cambien más. También requiere el rol admin o contabilidad. Ejemplo: cerrar la semana de Pedro el viernes tras revisar sus cargas."
      },
      "cancel": {
        "label": "Cancelar liquidaciones de choferes",
        "help": "Cancelar una liquidación con un motivo; sus cargas y deducciones pasan a la siguiente. Solo admin por defecto. Ejemplo: la semana se armó con el pagador equivocado."
      },
      "record_payment": {
        "label": "Registrar pagos a choferes",
        "help": "Marcar pagada una liquidación cerrada (fecha, método, referencia) o deshacer esa marca. También requiere el rol admin o contabilidad. Ejemplo: registrar el Zelle enviado a Pedro el viernes."
      }
    },
    "driver_deduction": {
      "manage": {
        "label": "Gestionar deducciones de choferes",
        "help": "Crear, cambiar y retirar las deducciones recurrentes y adelantos de un chofer, y el catálogo de deducciones de la agencia. También requiere el rol admin o contabilidad. Ejemplo: $150 a la semana de seguro para Pedro."
      }
    }
  },
  "credit": {
    "chip": {
      "ok": "Aprobado",
      "caution": "Precaución",
      "declined": "Rechazado",
      "expired": "Vencido",
      "no_check": "Sin revisar",
      "watch": "Vigilar",
      "overridden": "Autorizado",
      "blocked": "Bloqueado",
      "authority_inactive": "Sin autoridad"
    },
    "decision": {
      "approved": "Aprobado",
      "caution": "Precaución",
      "declined": "Rechazado"
    },
    "decisionHelp": {
      "approved": "Se puede reservar.",
      "caution": "Con cuidado: plazos cortos, puntuación baja.",
      "declined": "No reservar. Bloquea cargas nuevas."
    },
    "source": {
      "dat": "DAT",
      "truckstop": "Truckstop",
      "factoring": "Compañía de factoring",
      "fmcsa": "FMCSA",
      "other": "Otra",
      "manual": "Manual"
    },
    "flag": {
      "declined": "Rechazado en la última revisión de crédito.",
      "caution": "Precaución en la última revisión de crédito.",
      "expired": "La última revisión de crédito venció el {{date}}.",
      "no_check": "Este broker no tiene ninguna revisión de crédito.",
      "overdue_invoices_one": "{{count}} factura a este broker está vencida, por {{days}} días.",
      "overdue_invoices_other": "{{count}} facturas a este broker están vencidas, la más antigua por {{days}} días.",
      "open_incidents_one": "{{count}} incidente abierto con este broker.",
      "open_incidents_other": "{{count}} incidentes abiertos con este broker.",
      "authority_inactive": "Según FMCSA, la autoridad de este broker no está activa (última consulta a FMCSA)."
    },
    "blocked": {
      "declined": "Un broker rechazado no puede recibir una carga nueva hasta que una revisión nueva lo apruebe o un administrador de la agencia lo autorice.",
      "policy": "Tu agencia bloquea las cargas nuevas de un broker con cualquiera de estos avisos. Registra una revisión nueva o pide a un administrador de la agencia que lo autorice."
    },
    "override": {
      "action": "Autorizar",
      "title": "Autorizar a {{broker}}",
      "body": "Durante las próximas 24 horas se podrán reservar cargas nuevas con este broker a pesar del bloqueo de crédito. Tu nombre y el motivo quedan en el registro de actividad. Una revisión de crédito nueva termina la autorización.",
      "confirm": "Autorizar 24 horas",
      "saved": "{{broker}} se puede reservar durante las próximas 24 horas",
      "active": "Autorizado por un administrador hasta {{until}}: {{reason}}"
    },
    "hint": {
      "loading": "Revisando el crédito del broker…",
      "unavailable": "No se pudo leer el crédito del broker. Puedes guardar igualmente.",
      "ok": "Crédito aprobado ({{source}}), válido hasta el {{date}}.",
      "title": "Revisa el crédito de {{broker}} antes de reservar",
      "recordNow": "Registrar revisión ahora",
      "askAdmin": "Solo un administrador de la agencia puede autorizarlo.",
      "open": "Abrir revisión de crédito",
      "blockedSubmit": "El crédito de este broker bloquea la carga. Registra una revisión nueva o pide a un administrador de la agencia que lo autorice."
    },
    "check": {
      "action": "Registrar revisión",
      "title": "Revisión de crédito: {{broker}}",
      "intro": "Lo que dice hoy el load board, la compañía de factoring o FMCSA. Coreway guarda cada revisión con su fecha.",
      "decision": "Tu decisión",
      "source": "Fuente",
      "sourcePlaceholder": "¿Dónde lo revisaste?",
      "checkedOn": "Revisado el",
      "tooOld": "Como mucho hace un año.",
      "score": "Puntuación o calificación",
      "scoreHelp": "Tal como la muestra la fuente, por ejemplo A 94 u 88.",
      "daysToPay": "Días de pago",
      "daysToPayHelp": "El promedio de la fuente. También fija el vencimiento de la próxima factura a este broker.",
      "creditLimit": "Límite de crédito",
      "authority": "Estado de la autoridad",
      "authorityHelp": "De FMCSA, por ejemplo Active.",
      "submit": "Guardar revisión",
      "saved": "Revisión de crédito guardada para {{broker}}"
    },
    "incident": {
      "add": "Registrar incidente",
      "title": "Incidente con {{broker}}",
      "intro": "Algo que salió mal con este broker. Los incidentes abiertos avisan a todos los que lo reservan.",
      "kind": "Qué pasó",
      "kindPlaceholder": "Elige uno",
      "occurredOn": "Cuándo",
      "carrier": "Carrier",
      "carrierHelp": "Opcional. Solo tus carriers.",
      "noCarrier": "Sin carrier",
      "otherCarrier": "Otro carrier",
      "load": "Carga",
      "loadHelp": "Opcional. Un TONU o una disputa nombra su carga; su carrier viene con ella.",
      "noLoad": "Sin carga",
      "amount": "Importe",
      "submit": "Guardar incidente",
      "saved": "Incidente guardado para {{broker}}",
      "open": "Abierto",
      "resolve": "Resolver",
      "resolveTitle": "Resolver: {{kind}}",
      "resolveBody": "Escribe cómo se arregló. El incidente queda registrado.",
      "resolved": "Incidente resuelto",
      "resolvedOn": "Resuelto el {{date}}",
      "reopen": "Reabrir",
      "reopened": "Incidente reabierto",
      "noDetail": "Sin detalles",
      "ledgerOwned": "Viene de Pagos de brokers: reabre el cobro de la carga para cambiarlo."
    },
    "incidentKind": {
      "slow_pay": "Pago tardío",
      "non_payment": "Impago",
      "dispute": "Disputa",
      "double_brokering": "Sospecha de doble corretaje",
      "claim": "Reclamo",
      "tonu": "TONU",
      "unpaid_detention": "Detención sin pagar",
      "other": "Otro",
      "short_pay": "Pago incompleto"
    },
    "sheet": {
      "external": "Revisión de crédito externa",
      "coreway": "Historial en Coreway",
      "corewayNote": "Las cargas, las facturas y las vencidas cuentan toda la agencia. Las líneas de dinero cuentan tus carriers.",
      "checked": "Revisado",
      "checkedBy": "{{when}} por {{who}}",
      "validUntil": "Válido hasta",
      "expiredOn": "Venció el {{date}}",
      "noCheck": "Aún no hay revisiones de crédito.",
      "loads": "Cargas",
      "lastLoad": "última {{date}}",
      "invoices": "Facturas pagadas",
      "invoicesPaid": "{{paid}} de {{total}}",
      "avgDays": "Días reales de pago",
      "days_one": "{{count}} día",
      "days_other": "{{count}} días",
      "overdue": "Facturas vencidas",
      "overdueValue_one": "{{count}}, con {{days}} días de retraso",
      "overdueValue_other": "{{count}}, la más antigua con {{days}} días de retraso",
      "none": "Ninguna",
      "myOpen": "Saldo abierto (tus carriers)",
      "myShort": "Pagos incompletos (tus carriers)",
      "setups": "Altas de carriers y aprobación del factoring",
      "openSetups": "Abrir altas con brokers",
      "incidents_one": "Incidentes ({{count}} abierto)",
      "incidents_other": "Incidentes ({{count}} abiertos)",
      "noIncidents": "No hay incidentes registrados.",
      "history": "Historial de revisiones",
      "detailError": "No se pudo leer el historial."
    },
    "list": {
      "search": "Buscar brokers",
      "searchPlaceholder": "Nombre, MC o DOT",
      "filter": "Crédito",
      "all": "Todos",
      "attention": "Requieren atención",
      "blocked": "Bloqueados",
      "never": "Nunca revisado",
      "checked": "Revisado el {{date}} en {{source}}",
      "validUntil": "válido hasta el {{date}}",
      "expired": "venció el {{date}}",
      "checkDays_one": "{{count}} día para pagar",
      "checkDays_other": "{{count}} días para pagar",
      "paidIn_one": "te pagó en {{days}} días de media ({{count}} factura pagada)",
      "paidIn_other": "te pagó en {{days}} días de media ({{count}} facturas pagadas)",
      "overdue_one": "{{count}} vencida",
      "overdue_other": "{{count}} vencidas",
      "incidents_one": "{{count}} incidente abierto",
      "incidents_other": "{{count}} incidentes abiertos",
      "empty": "Todavía no hay brokers. Agrégalos en Brokers.",
      "error": "No se pudo leer el crédito de los brokers.",
      "policyWarn": "Una revisión de crédito vale {{days}} días. Un broker con avisos se puede reservar; uno rechazado no.",
      "policyBlock": "Una revisión de crédito vale {{days}} días. Tu agencia bloquea las cargas nuevas de cualquier broker con avisos."
    },
    "settings": {
      "title": "Crédito de brokers",
      "expiryLabel": "Una revisión de crédito vale",
      "days": "días",
      "saveExpiry": "Guardar",
      "expiryHelp": "Pasados estos días el broker aparece Vencido y el formulario de carga nueva pide una revisión nueva. Ejemplo: 30 días: revisado el 1 de sept, vence el 1 de oct.",
      "policyLabel": "Cuando un broker tiene avisos",
      "policy": {
        "warn": "Avisar (por defecto)",
        "block": "Bloquear"
      },
      "policyHelp": {
        "warn": "El formulario de carga nueva muestra el aviso y deja guardar la carga. Solo se bloquea un broker rechazado.",
        "block": "Sin revisión, una revisión vencida o de precaución, facturas vencidas o un incidente abierto bloquean la carga hasta que alguien registre una revisión nueva o un administrador lo autorice."
      },
      "saved": "Ajuste guardado"
    },
    "errors": {
      "blocked": "El crédito de este broker bloquea la carga. Registra una revisión de crédito nueva o pide a un administrador de la agencia que lo autorice.",
      "alreadyResolved": "Este incidente ya está resuelto.",
      "notResolved": "Este incidente no está resuelto.",
      "ledgerShortPay": "Este pago incompleto viene de Pagos de brokers. Reabre el cobro de la carga para cambiarlo.",
      "checkTooOld": "Una revisión de crédito puede tener como mucho un año.",
      "resolvedBefore": "Un incidente no se puede resolver antes de que ocurra.",
      "loadNotOnBroker": "Esa carga no es de este broker.",
      "incidentNotFound": "Este incidente ya no existe o no es de tus carriers."
    },
    "noNumbers": "Sin MC ni DOT registrados",
    "unknownMember": "un exmiembro",
    "fmcsa": {
      "title": "Autoridad en FMCSA",
      "help": "Busca al broker en los registros públicos de FMCSA. Una consulta por clic; dentro de 10 minutos vuelves a ver el último resultado.",
      "action": "Consultar FMCSA",
      "checking": "Consultando FMCSA",
      "notConfigured": "Sin configurar",
      "notConfiguredHint": "La consulta a FMCSA necesita su clave de acceso, que aún no está configurada. Pídesela al operador de Coreway.",
      "authority": {
        "active": "Autoridad activa",
        "inactive": "Autoridad no activa",
        "not_found": "No aparece en FMCSA"
      },
      "notFoundHelp": "FMCSA no tiene ningún registro de {{number}}. Revisa que el número del broker sea correcto y búscalo en la web de FMCSA.",
      "recent": "Consultado {{when}}, hace menos de 10 minutos: este es ese resultado.",
      "checkedBy": "Consultado {{when}} por {{who}}",
      "legalName": "Razón social",
      "dba": "DBA",
      "allowed": "Autorizado a operar",
      "yes": "Sí",
      "no": "No",
      "brokerAuthority": "Autoridad de broker",
      "commonAuthority": "Autoridad común",
      "contractAuthority": "Autoridad por contrato",
      "code": {
        "A": "Activa",
        "I": "Inactiva",
        "N": "Ninguna",
        "unknown": "{{value}}"
      },
      "bipd": "Responsabilidad civil (BIPD) registrada",
      "cargo": "Seguro de carga registrado",
      "bond": "Fianza registrada",
      "insuranceValue": "{{value}}K USD",
      "none": "Ninguno",
      "safetyRating": "Calificación de seguridad",
      "rating": {
        "S": "Satisfactoria",
        "C": "Condicional",
        "U": "Insatisfactoria",
        "none": "Sin calificar"
      },
      "oosDate": "Fuera de servicio desde",
      "address": "Dirección",
      "matches_one": "{{count}} registro coincide con este número; se muestra el primero.",
      "matches_other": "{{count}} registros coinciden con este número; se muestra el primero.",
      "error": {
        "in_flight": "Ya hay una consulta de este broker en curso.",
        "no_identifier": "Primero añade el MC o el DOT del broker.",
        "unavailable": "FMCSA no respondió. Inténtalo de nuevo en un momento.",
        "key_rejected": "FMCSA rechazó la clave de acceso de Coreway. Avisa al operador de Coreway.",
        "forbidden": "Tu rol no puede registrar revisiones de crédito.",
        "not_found": "Este broker no es de tu agencia.",
        "not_configured": "La consulta a FMCSA no está configurada.",
        "failed": "La consulta a FMCSA falló. Inténtalo de nuevo."
      },
      "inactiveReason": {
        "not_allowed": "FMCSA no autoriza a esta entidad a operar.",
        "no_broker_authority": "Sin autoridad de broker activa. Un carrier que corretea cargas sin autoridad de broker es el patrón del doble corretaje: no reserves hasta aclararlo."
      }
    }
  },
  "receivableStatus": {
    "open": "Abierto",
    "partially_paid": "Pago parcial",
    "overdue": "Vencido",
    "disputed": "En disputa",
    "paid": "Pagado",
    "short_paid": "Pago corto"
  },
  "paymentMethod": {
    "ach": "ACH",
    "zelle": "Zelle",
    "check": "Cheque",
    "wire": "Transferencia",
    "cash": "Efectivo",
    "card": "Tarjeta",
    "other": "Otro"
  },
  "payer": {
    "broker": "Broker",
    "factoring": "Empresa de factoring"
  },
  "receivables": {
    "tableLabel": "Pagos de brokers",
    "tabsLabel": "Cobros",
    "tabs": {
      "ready": "Por facturar",
      "open": "Abiertos",
      "overdue": "Vencidos",
      "disputed": "En disputa",
      "closed": "Cerrados",
      "all": "Todos"
    },
    "summary": {
      "label": "Resumen",
      "openBalance": "Saldo abierto",
      "onLoads_one": "en {{count}} carga",
      "onLoads_other": "en {{count}} cargas",
      "overdue": "Vencido",
      "disputed": "En disputa"
    },
    "filters": {
      "carrier": "Carrier",
      "allCarriers": "Todos los carriers",
      "broker": "Broker",
      "allBrokers": "Todos los brokers",
      "search": "Buscar pagos de brokers",
      "searchPlaceholder": "Carga, factura, broker o carrier"
    },
    "columns": {
      "load": "Carga",
      "carrier": "Carrier",
      "broker": "Broker",
      "invoiceNumber": "Factura n.º",
      "invoiced": "Facturada",
      "due": "Vence",
      "amount": "Importe",
      "received": "Cobrado",
      "balance": "Saldo",
      "status": "Estado",
      "dispatcher": "Dispatcher",
      "rate": "Tarifa",
      "note": "Nota",
      "actions": "Acciones"
    },
    "noBroker": "Sin broker",
    "factored": "Con factoring",
    "overdueBy_one": "{{count}} día vencida",
    "overdueBy_other": "{{count}} días vencida",
    "dueIn_one": "Vence en {{count}} día",
    "dueIn_other": "Vence en {{count}} días",
    "dueToday": "Vence hoy",
    "paidIn_one": "Pagada en {{count}} día",
    "paidIn_other": "Pagada en {{count}} días",
    "empty": "No hay nada en esta lista.",
    "invoicedLine": "Facturada el {{date}}",
    "receivedLine": "Cobrado {{amount}}",
    "emptyWithReady": "Todavía no hay nada. Una carga entra en esta lista cuando la marcas como facturada en Por facturar.",
    "emptyReady": "Nada por facturar. Una carga aparece aquí cuando se recibe su POD.",
    "adoption": "Marcada como facturada antes de existir los cobros: registra su factura",
    "tonuTag": "TONU",
    "tonuNote": "Cancelada con TONU: factúraselo al broker. La carga sigue cancelada.",
    "actions": {
      "recordReceipt": "Registrar cobro",
      "recordReceiptFor": "Registrar cobro de {{load}}",
      "markInvoiced": "Marcar facturada",
      "markInvoicedFor": "Marcar {{load}} como facturada",
      "closeShort": "Cerrar con pago corto",
      "closeZero": "Cerrar como pagada",
      "dispute": "Disputar",
      "clearDispute": "Quitar disputa",
      "edit": "Editar factura",
      "unmark": "Desmarcar facturada",
      "reopen": "Reabrir",
      "details": "Detalles"
    },
    "blocked": {
      "unmark": "Revierte sus cobros primero."
    },
    "sheet": {
      "title": "Carga {{load}}",
      "money": "Importes",
      "amount": "Importe",
      "received": "Cobrado",
      "balance": "Saldo",
      "invoicedOn": "Facturada el",
      "dueOn": "Vence el",
      "daysOutstanding": "Días pendiente",
      "daysToPay": "Días hasta el pago",
      "carrier": "Carrier",
      "broker": "Broker",
      "dispatcher": "Dispatcher",
      "invoiceNumber": "Factura n.º",
      "notes": "Notas",
      "noNotes": "Sin notas.",
      "receipts": "Cobros",
      "noReceipts": "Aún no hay cobros registrados.",
      "receiptsError": "No se pudieron cargar los cobros."
    },
    "banners": {
      "disputed": "En disputa desde el {{date}}: {{reason}}",
      "feeHeld": "La comisión de la agencia por esta carga queda fuera de la factura semanal hasta que se quite la disputa.",
      "shortPaid": "Cerrada con pago corto de {{amount}}: {{reason}}. La comisión de la agencia no cambió.",
      "zero": "Todo está cobrado. Ciérrala para marcar la carga como pagada."
    },
    "history": {
      "date": "Fecha",
      "payer": "Pagador",
      "reference": "Referencia",
      "amount": "Importe",
      "recorded": "Registrado",
      "state": "Estado",
      "payerFactoring": "Factoring: {{company}}",
      "reversed": "Revertido",
      "reversedBy": "por {{name}}, {{date}}: {{reason}}",
      "recordedBy": "{{name}}, {{date}}",
      "reverseLabel": "Revertir el cobro de {{amount}}"
    },
    "reason": {
      "label": "Motivo",
      "counter": "{{count}} de {{max}} caracteres"
    },
    "mark": {
      "title": "Marcar {{load}} como facturada",
      "invoiceNumber": "Número de factura",
      "invoiceNumberHelp": "Único por carrier",
      "invoicedOn": "Facturada el",
      "amount": "Importe",
      "amountHelp": "La tarifa: {{amount}}",
      "dueOn": "Vence el",
      "dueHelp": "Vacío: los días de pago del broker según su último credit check, o el valor por defecto de esta agencia, {{days}} días (Ajustes, Reglas de la agencia)",
      "factored": "Con factoring",
      "factoredHelp": "La empresa de factoring cobra al broker; los cobros se le atribuyen por defecto",
      "factoringCompany": "Empresa de factoring",
      "notes": "Notas",
      "submit": "Marcar facturada",
      "done": "Marcada como facturada: {{load}}"
    },
    "receipt": {
      "title": "Registrar cobro de {{load}}",
      "shortTitle": "Cerrar {{load}} con pago corto",
      "zeroTitle": "Cerrar {{load}} como pagada",
      "amount": "Importe",
      "balanceHelp": "Saldo {{amount}}",
      "nothingMore": "Pon 0 si no va a llegar nada más.",
      "paidOn": "Cobrado el",
      "paidOnZeroHelp": "El día en que llegó el último dinero",
      "payer": "Pagado por",
      "reference": "Referencia",
      "closeShort": "Cerrar con pago corto",
      "shortReason": "Motivo",
      "shortBy": "Faltan {{amount}}. La comisión de la agencia no cambia: sigue la rate confirmation.",
      "incident": "Se registra una incidencia de pago corto para {{broker}}.",
      "zeroBody": "Todo está cobrado. El cobro se cierra como pagado y la carga queda pagada.",
      "submit": "Registrar cobro",
      "submitShort": "Cerrar con pago corto",
      "submitZero": "Cerrar como pagada",
      "done": "Cobro de {{amount}} registrado",
      "doneShort": "{{load}} cerrada con pago corto",
      "doneZero": "{{load}} cerrada como pagada"
    },
    "dispute": {
      "title": "Disputar {{load}}",
      "holds": "Mientras esté en disputa, la comisión de la agencia por esta carga queda fuera de la factura semanal del carrier (salvo que ya esté en una). Se cambia en Ajustes, Reglas de la agencia.",
      "noHold": "La comisión de la agencia se factura como siempre (Ajustes, Reglas de la agencia).",
      "confirm": "Disputar",
      "done": "{{load}} en disputa"
    },
    "clear": {
      "title": "¿Quitar la disputa de {{load}}?",
      "body": "La comisión retenida, si la hay, se libera.",
      "confirm": "Quitar disputa",
      "done": "Disputa quitada de {{load}}"
    },
    "edit": {
      "title": "Editar la factura de {{load}}",
      "belowReceived": "No puede ser menor que lo ya cobrado ({{amount}})",
      "done": "Factura de {{load}} actualizada"
    },
    "unmark": {
      "title": "¿Desmarcar {{load}} como facturada?",
      "body": "El cobro se elimina y la carga vuelve a POD recibido.",
      "confirm": "Desmarcar",
      "done": "{{load}} desmarcada"
    },
    "reopen": {
      "title": "¿Reabrir {{load}}?",
      "body": "La carga vuelve a facturada; una incidencia de pago corto queda resuelta.",
      "confirm": "Reabrir",
      "done": "{{load}} reabierta"
    },
    "reverse": {
      "title": "¿Revertir este cobro?",
      "body": "El cobro de {{amount}} queda en el historial como revertido y el saldo vuelve a crecer en esa cantidad. Un cobro cerrado se reabre.",
      "confirm": "Revertir",
      "done": "Cobro revertido"
    },
    "invoice": {
      "numberOptional": "Número de factura (opcional)",
      "numberAuto": "Automático: {{number}}",
      "numberHelp": "Déjalo vacío para usar el siguiente número del carrier, o escribe el que te dio la factoring."
    },
    "docs": {
      "title": "Documentos",
      "invoicePdf": "Factura en PDF",
      "packetPdf": "Paquete PDF (factura, {{docs}})",
      "packetPdfNeutral": "Paquete PDF (factura con los documentos de la carga)",
      "packetPdfNone": "Paquete PDF (solo la factura, aún sin documentos de la carga)",
      "kinds": {
        "rate_confirmation": "RC",
        "bol": "BOL",
        "pod": "POD",
        "lumper_receipt": "recibo de lumper"
      },
      "emailBroker": "Enviar al broker",
      "factoredWarning": "Esta carga está factorizada: normalmente la factoring presenta la factura. ¿Enviarla igualmente?",
      "attach": {
        "label": "Adjuntar",
        "packet": "Factura con {{docs}}",
        "packetNeutral": "Factura con los documentos de la carga",
        "packetNone": "Factura y documentos de la carga (aún ninguno)",
        "invoice": "Solo la factura"
      },
      "history": "Historial",
      "noHistory": "Aún no se ha preparado ni enviado nada.",
      "version": "{{file}}, versión {{version}}, {{pages}} páginas, {{date}}",
      "emailed": "Enviada el {{date}} a {{email}}",
      "emailing": "Enviando a {{email}}",
      "emailFailed": "El correo a {{email}} falló: {{error}}",
      "latestWarnings": "En la última versión:",
      "email": {
        "title": "Enviar la factura {{number}} a {{broker}}",
        "body": "Cuentas por pagar del broker recibe el PDF; las respuestas llegan a tu correo de facturación.",
        "confirm": "Enviar",
        "done": "Enviando la factura {{number}}"
      }
    },
    "errors": {
      "numbersExhausted": "Este carrier usó todos los números de su serie. Pon un prefijo nuevo en el carrier."
    }
  },
  "inviteState": {
    "pending": "Pendiente",
    "expired": "Caducada",
    "accepted": "Aceptada",
    "declined": "Rechazada",
    "revoked": "Cancelada",
    "superseded": "Reemplazada"
  },
  "members": {
    "deletedUser": "Usuario eliminado",
    "deletedNoReactivate": "Su dueño eliminó esta cuenta y no se puede reactivar. Para que la persona vuelva, invítala de nuevo."
  },
  "memberStatus": {
    "active": "De alta",
    "inactive": "De baja"
  },
  "profile": {
    "title": "Tus datos",
    "intro": "Tu equipo ve este nombre en las cargas, los pagos y las invitaciones que registras.",
    "name": "Nombre",
    "phone": "Teléfono",
    "language": "Idioma",
    "languageHelp": "Los correos que Coreway te envía, y el idioma del portal.",
    "email": "Correo",
    "emailHelp": "La dirección con la que entras. No se cambia aquí.",
    "languages": {
      "en": "English",
      "es": "Español"
    },
    "save": "Guardar perfil",
    "saving": "Guardando…",
    "saved": "Perfil guardado",
    "noChanges": "Nada que guardar: no cambió ningún campo.",
    "loadError": "No se pudo cargar tu perfil.",
    "password": {
      "title": "Poner una contraseña nueva",
      "description": "Útil si entraste con un enlace de acceso. Puedes seguir entrando con un enlace enviado a tu correo.",
      "new": "Contraseña nueva",
      "repeat": "Escríbela otra vez",
      "help": "Al menos 8 caracteres.",
      "submit": "Guardar contraseña",
      "saving": "Guardando…",
      "saved": "Contraseña guardada. Úsala la próxima vez que entres."
    },
    "banner": {
      "text": "Añade tu nombre para que tu equipo vea quién hizo qué.",
      "action": "Añadir mi nombre",
      "dismiss": "Descartar"
    },
    "methods": {
      "title": "Métodos de inicio de sesión",
      "intro": "Las formas de entrar a esta cuenta.",
      "provider": {
        "email": "Correo",
        "google": "Google",
        "apple": "Apple",
        "phone": "Teléfono"
      },
      "link": "Vincular {{provider}}",
      "unlink": "Desvincular",
      "unlinkTitle": "¿Desvincular {{provider}}?",
      "unlinkBody": "Ya no podrás entrar con {{provider}} ({{email}}).",
      "needed": "Necesario para entrar",
      "linked": "{{provider}} quedó vinculado. Podrás entrar con él la próxima vez.",
      "unlinked": "{{provider}} se desvinculó.",
      "loadError": "No se pudieron cargar tus métodos de inicio de sesión."
    }
  },
  "team": {
    "block": {
      "self": "No puedes cambiar tu propia membresía. Pídeselo a un admin.",
      "onlyAdminChanges": "Solo un admin puede cambiar a un admin o a un manager.",
      "onlyAdminGrants": "Solo un admin puede dar el rol de admin o de manager.",
      "lastAdmin": "La agencia necesita al menos un admin activo. Haz admin a otra persona primero."
    },
    "title": "Miembros",
    "count_one": "{{count}} miembro",
    "count_other": "{{count}} miembros",
    "invite": "Invitar a alguien",
    "statusFilter": "Estado del miembro",
    "search": "Buscar por nombre o correo",
    "you": "Tú",
    "noName": "Sin nombre todavía",
    "emptyStatus": "No hay miembros con este estado.",
    "inactiveSince": "desde el {{date}}",
    "col": {
      "name": "Nombre",
      "email": "Correo",
      "role": "Rol",
      "carriers": "Carriers",
      "phone": "Teléfono",
      "joined": "Entró",
      "status": "Estado",
      "actions": "Acciones"
    },
    "carriers": {
      "count_one": "{{count}} carrier",
      "count_other": "{{count}} carriers",
      "none": "Ninguno todavía",
      "noneHelp": "No ve cargas hasta que tenga carriers.",
      "all": "Todos los carriers",
      "edit": "Carriers de {{name}}: {{summary}}"
    },
    "roleSummary": {
      "admin": "Todo, incluidos el equipo, los permisos y las reglas de la agencia.",
      "manager": "Lleva la flota y los brokers, y asigna carriers a los dispatchers.",
      "dispatcher": "Mueve cargas de los carriers que tiene asignados.",
      "accounting": "Facturas, pagos y los dos libros de cuentas."
    },
    "roleConsequence": {
      "admin": "{{name}} podrá hacerlo todo, incluida esta página.",
      "manager": "{{name}} podrá gestionar la flota y asignar carriers a los dispatchers, según los permisos de esta agencia.",
      "dispatcher": "{{name}} empieza sin carriers: asígnaselos después de guardar.",
      "accounting": "{{name}} llevará facturas y pagos, según los permisos de esta agencia.",
      "leaveDispatcher_one": "{{name}} pierde su {{count}} carrier; si vuelve a dispatcher empieza sin ninguno.",
      "leaveDispatcher_other": "{{name}} pierde sus {{count}} carriers; si vuelve a dispatcher empieza sin ninguno."
    },
    "sheet": {
      "readOnlyNote": "Cada persona edita su propio nombre y teléfono en Mi perfil.",
      "details": "Datos",
      "joined": "Entró",
      "invitedBy": "Invitación de",
      "role": "Rol",
      "saveRole": "Guardar rol",
      "roleSaved": "Rol guardado",
      "access": "Acceso",
      "activeNote": "De alta: puede entrar a esta agencia.",
      "inactiveNote": "De baja desde el {{date}}: no puede entrar a esta agencia.",
      "deactivate": "Dar de baja",
      "reactivate": "Dar de alta",
      "deactivateTitle": "¿Dar de baja a {{name}}?",
      "deactivateBody": "{{name}} pierde el acceso a esta agencia ahora: en su próxima pantalla del portal no verá nada de ella, y no puede volver a entrar. Sus carriers asignados se guardan por si vuelve, y su nombre sigue en los registros pasados.",
      "deactivated": "{{name}} ya no tiene acceso",
      "reactivated": "{{name}} vuelve a tener acceso",
      "carriers": "Carriers",
      "noCarriers": "Sin carriers todavía: no ve cargas.",
      "editCarriers": "Editar carriers"
    },
    "assign": {
      "title": "Carriers de {{name}}",
      "description": "Solo ve y trabaja los carriers marcados aquí.",
      "search": "Buscar carriers",
      "save": "Guardar carriers",
      "empty": "Ningún carrier coincide.",
      "planning": "Se puede asignar un carrier que no está activo, para planificar.",
      "inactiveNoAdd": "Da de alta a {{name}} para darle carriers. Quitar sigue permitido.",
      "resultAdded_one": "{{count}} añadido para {{name}}",
      "resultAdded_other": "{{count}} añadidos para {{name}}",
      "resultRemoved_one": "{{count}} quitado para {{name}}",
      "resultRemoved_other": "{{count}} quitados para {{name}}",
      "result": "{{added}} añadidos, {{removed}} quitados para {{name}}",
      "nothing": "No cambió nada.",
      "partial": "Algunos cambios no se aplicaron. El resto se guardó.",
      "failure": "{{name}}: {{message}}",
      "none": "Aún no hay carriers. Puedes asignarlos más tarde."
    },
    "dispatchers": {
      "column": "Dispatcher",
      "unassigned": "Sin asignar",
      "more": "+{{count}}",
      "manage": "Dispatchers de {{name}}: {{summary}}",
      "title": "Dispatchers de {{name}}",
      "description": "Cada dispatcher marcado aquí ve y trabaja este carrier.",
      "empty": "Todavía no hay dispatchers activos en la agencia. Invita a alguien desde Ajustes, Equipo.",
      "save": "Guardar dispatchers"
    },
    "roleConfirm": {
      "title": "¿Hacer {{role}} a {{name}}?",
      "body": "{{name}} deja de llevar estos carriers: {{carriers}}. Para volver a llevarlos habrá que asignarlos a mano.",
      "confirm": "Cambiar rol"
    }
  },
  "memberInvite": {
    "block": {
      "onlyAdmin": "Solo un admin reenvía o cancela una invitación de admin o de manager.",
      "notPending": "Esta invitación ya terminó.",
      "sendLimit": "Enviada {{count}} veces. Cancélala e invita de nuevo.",
      "cooldown": "Podrás volver a enviarla en {{seconds}} s."
    },
    "dialog": {
      "title": "Invitar a alguien",
      "description": "Enviamos por correo un enlace para unirse a esta agencia. Sirve durante 7 días.",
      "name": "Nombre",
      "email": "Correo",
      "role": "Rol",
      "carriers": "Carriers",
      "carriersHelp": "Opcional. También puedes asignar carriers después.",
      "carriersSearch": "Buscar carriers",
      "language": "Idioma del correo",
      "languageHelp": "El correo de invitación se escribe en este idioma.",
      "submit": "Enviar invitación",
      "sending": "Enviando…",
      "sent": "Invitación enviada a {{email}}",
      "showMember": "Ver miembro",
      "openMember": "Abrir su membresía"
    },
    "card": {
      "title": "Invitaciones",
      "description": "Personas invitadas a la oficina que aún no han entrado, y qué pasó con las invitaciones anteriores.",
      "filter": "Invitaciones",
      "tabPending": "Pendientes",
      "tabHistory": "Historial",
      "historyNote": "Invitaciones que terminaron en los últimos 90 días.",
      "emptyPending": "No hay invitaciones pendientes. Usa Invitar a alguien para sumar a una persona a la oficina.",
      "emptyHistory": "Ninguna invitación terminó en los últimos 90 días."
    },
    "col": {
      "person": "Persona",
      "role": "Rol",
      "state": "Estado",
      "email": "Correo",
      "invitedBy": "Invitó",
      "actions": "Acciones"
    },
    "expires": "Vence {{date}}",
    "delivery": {
      "failed": "No entregado",
      "sending": "Enviando",
      "sent": "Enviado {{when}}",
      "none": "Sin enviar todavía",
      "sends": "{{count}} de {{max}} envíos",
      "providerMessage": "Mensaje del proveedor"
    },
    "resend": "Reenviar",
    "resendFor": "Reenviar la invitación a {{email}}",
    "resendExpired": "Reenviarla le da 7 días más.",
    "resent": "Enviada otra vez. Ahora vence {{date}}",
    "copyLinkFor": "Copiar enlace para {{email}}",
    "linkCopied": "Enlace copiado",
    "linkNote": "El enlace solo sirve para {{email}}: lo confirma con un enlace de acceso enviado a esa dirección.",
    "revoke": "Revocar",
    "revokeFor": "Revocar la invitación de {{email}}",
    "revokeTitle": "¿Revocar la invitación de {{name}}?",
    "revokeBody": "El enlace de {{name}} deja de funcionar. Un correo aún no entregado se descarta.",
    "revoked": "Invitación revocada"
  },
  "loadStatus": {
    "potential": "Potencial",
    "booked": "Reservada",
    "dispatched": "Despachada",
    "accepted": "Aceptada",
    "atPickup": "En recogida",
    "loaded": "Cargada",
    "inTransit": "En tránsito",
    "delivered": "Entregada",
    "podReceived": "POD recibido",
    "invoiced": "Facturada",
    "paid": "Pagada",
    "canceled": "Cancelada",
    "unknown": "Estado desconocido"
  },
  "loads": {
    "tableLabel": "Cargas",
    "tabsLabel": "Filtrar las cargas por estado",
    "tabs": {
      "active": "Activas",
      "delivered": "Entregadas",
      "billing": "Facturación",
      "closed": "Cerradas",
      "all": "Todas"
    },
    "columns": {
      "load": "Carga",
      "carrier": "Carrier",
      "driverTruck": "Chofer / Camión",
      "route": "Ruta",
      "pickup": "Recogida",
      "delivery": "Entrega",
      "broker": "Broker",
      "rate": "Tarifa",
      "status": "Estado",
      "docs": "Docs",
      "dispatcher": "Dispatcher",
      "actions": "Acciones",
      "podBol": "POD / BOL"
    },
    "unit": "Unidad {{unit}}",
    "unassigned": "Sin asignar",
    "route": "{{origin}} → {{destination}}",
    "noRoute": "Todavía sin paradas",
    "moreStops_one": "+{{count}} parada",
    "moreStops_other": "+{{count}} paradas",
    "ratePerMile": "{{rate}}/mi",
    "belowMinimum": "Por debajo del mínimo del carrier, {{min}}/mi",
    "noRate": "Sin tarifa",
    "waitingMinutes_one": "Esperando {{count}} min",
    "waitingMinutes_other": "Esperando {{count}} min",
    "waitingHours": "Esperando {{hours}} h {{minutes}} min",
    "docMarks": {
      "rateCon": "RC",
      "bol": "BOL",
      "pod": "POD"
    },
    "docPresent": "{{kind}} subido",
    "docMissing": "Falta {{kind}}",
    "search": "Buscar cargas",
    "searchPlaceholder": "N.º de carga, referencia, carrier, chofer, broker o ciudad",
    "filters": {
      "label": "Filtros",
      "toggle": "Filtros ({{count}})",
      "toggle_zero": "Filtros",
      "carrier": "Carrier",
      "allCarriers": "Todos los carriers",
      "driver": "Chofer",
      "allDrivers": "Todos los choferes",
      "dispatcher": "Dispatcher",
      "allDispatchers": "Todos los dispatchers",
      "broker": "Broker",
      "allBrokers": "Todos los brokers",
      "pickupFrom": "Recogida desde",
      "pickupTo": "Recogida hasta",
      "clear": "Quitar filtros"
    },
    "empty": {
      "noLoads": "Todavía no hay cargas. Crea la primera a partir de su rate confirmation.",
      "noMatch": "Ninguna carga cumple estos filtros.",
      "podReview": "Ninguna carga entregada espera sus papeles."
    },
    "cap": "Se muestran las {{count}} más recientes. Acota las fechas para ver cargas anteriores.",
    "loading": "Cargando las cargas…",
    "error": "No se pudieron cargar las cargas.",
    "newLoad": "Nueva carga",
    "rowActions": {
      "open": "Abrir {{load}}",
      "openFullPage": "Abrir en página completa",
      "more": "Más acciones de {{load}}"
    },
    "podReview": {
      "from": "{{kind}} de {{name}}",
      "fromApp": "{{kind}} de {{name}} (app)",
      "at": "{{time}}",
      "nothing": "Todavía sin POD ni BOL",
      "deliveredAt": "Entregada {{time}}"
    }
  },
  "loadForm": {
    "sections": {
      "parties": "Carrier y broker",
      "load": "Carga",
      "stops": "Paradas",
      "money": "Tarifa y millas",
      "rateCon": "Confirmación de tarifa",
      "status": "Estado",
      "notes": "Notas"
    },
    "carrier": "Carrier",
    "carrierPlaceholder": "Elige un carrier",
    "noCarriers": "No hay ningún carrier activo para crear una carga.",
    "broker": "Broker",
    "brokerNone": "Todavía sin broker",
    "brokerOption": "{{name}} · MC {{mc}}",
    "brokerReferenceHelp": "El número de carga o de PO del broker.",
    "loadNumberPlaceholder": "Se asigna solo",
    "weightUnit": "lb",
    "frozenNote": "Puedes cambiarlos después desde la carga, con Editar detalles.",
    "setup": {
      "approved": "Dado de alta con {{broker}} el {{date}}.",
      "approvedNoDate": "Dado de alta con {{broker}}.",
      "notApproved": "{{carrier}} todavía no está dado de alta con {{broker}} ({{status}}). Puedes guardar igualmente.",
      "none": "{{carrier}} todavía no está dado de alta con {{broker}}. Puedes guardar igualmente.",
      "open": "Abrir altas con brokers"
    },
    "rate": "Tarifa (linehaul)",
    "rateMissing": "Sin tarifa no se puede confirmar el POD.",
    "loadedMiles": "Millas cargado",
    "deadheadMiles": "Millas en vacío",
    "preview": {
      "title": "Estimado",
      "totalMiles": "Millas totales",
      "rpmLoaded": "Tarifa / milla cargado",
      "rpmTotal": "Tarifa / milla total",
      "belowMinimum": "Por debajo del mínimo de {{carrier}}, {{min}}/mi.",
      "estimatedAt": "Estimado al {{pct}} %",
      "fee": "Comisión de dispatch",
      "carrierNet": "Neto del carrier",
      "noCarrier": "Elige un carrier para estimar la comisión.",
      "noPlan": "Este carrier no tiene % de dispatch: fíjalo antes del POD.",
      "feeHidden": "La comisión de dispatch la ven admin y contabilidad.",
      "noRate": "Añade la tarifa para ver el dinero.",
      "detentionUnknown": "El detention se estima al 0 %; al ganarse la comisión se aplica la tasa de detention de la agencia.",
      "detentionAt": "Detention al {{pct}} %."
    },
    "rateCon": {
      "drop": "Suelta aquí la rate confirmation del broker, o elige un archivo",
      "choose": "Elegir archivo",
      "remove": "Quitar el archivo",
      "accepted": "PDF, JPEG, PNG, HEIC o WebP, 25 MB como máximo.",
      "none": "Ningún archivo elegido. Puedes subirlo después."
    },
    "status": {
      "label": "Estado",
      "booked": "Reservada",
      "bookedHelp": "Confirmada con el broker.",
      "potential": "Potencial",
      "potentialHelp": "Todavía en negociación."
    },
    "submit": "Crear carga",
    "steps": {
      "create": "Creando la carga…",
      "upload": "Subiendo la rate confirmation…",
      "register": "Adjuntando la rate confirmation…"
    },
    "created": "{{load}} creada",
    "dispatchNow": "Despachar ahora",
    "result": {
      "title": "{{load}} se creó, pero no se guardó todo.",
      "upload": "No se pudo subir la rate confirmation: {{reason}} Súbela de nuevo abajo.",
      "register": "La rate confirmation se subió pero no quedó adjunta: {{reason}} Inténtalo de nuevo abajo.",
      "uploadAgain": "Subir de nuevo",
      "attachAgain": "Adjuntarla de nuevo"
    },
    "extras": {
      "title": "Extras",
      "help": "Los paga el broker además de la tarifa. El porcentaje de la agencia se aplica a la tarifa; el detention tiene su propia tasa; el lumper y otros reembolsos nunca cuentan.",
      "detention": "Detention",
      "lumper": "Lumper",
      "other": "Otros",
      "tonu": "TONU"
    }
  },
  "addressSearch": {
    "label": "Buscar dirección",
    "help": "Elija una sugerencia para marcar la parada en el mapa. También puede escribir los campos de abajo.",
    "placeholder": "Empresa, calle o ciudad",
    "count_one": "{{count}} sugerencia",
    "count_other": "{{count}} sugerencias",
    "empty": "Sin resultados. Escriba la dirección abajo; la parada se guarda sin marca en el mapa.",
    "unavailable": "La búsqueda de direcciones no está disponible ahora. Escriba la dirección abajo; la parada se guarda sin marca en el mapa.",
    "attribution": "© OpenStreetMap contributors",
    "pin": {
      "pinned": "Marcada en el mapa",
      "notPinned": "Sin marcar en el mapa",
      "srPrefix": "Mapa:"
    }
  },
  "locationMap": {
    "title": "Ubicación",
    "state": {
      "noDriver": "La ubicación en vivo empieza cuando un chofer acepta la carga.",
      "notYet": "La ubicación en vivo empieza cuando {{driver}} acepte la carga.",
      "noApp": "{{driver}} no usa la app de Coreway, así que no hay ubicación en vivo.",
      "none": "Sin ubicación en vivo. {{driver}} no ha compartido su ubicación en esta carga. Compartir la ubicación es opcional para los choferes.",
      "fresh": "Actualizada {{ago}} · {{time}}",
      "stale": "Última actualización {{ago}} · {{time}}. Puede que el teléfono no tenga conexión o que la app esté cerrada.",
      "old": "Sin actualizaciones desde {{time}} ({{ago}}). Puede que el teléfono no tenga conexión o que la app esté cerrada.",
      "ended": "El seguimiento terminó con la entrega. Última posición: {{time}}.",
      "error": "No se pudo cargar la ubicación en vivo."
    },
    "call": "Llamar a {{driver}}",
    "approx": "Aproximada (a menos de {{miles}} mi).",
    "recenter": "Centrar",
    "mapLabel": "Mapa del camión y las paradas marcadas. {{line}}",
    "mapLabelStops": "Mapa de las paradas marcadas.",
    "truck": "Camión",
    "noTiles": "Las imágenes del mapa no están configuradas (config.js no tiene mapboxToken).",
    "unpinnedNote": "Las paradas sin marcar no aparecen en el mapa.",
    "loading": "Cargando el mapa…",
    "attribution": {
      "mapbox": "© Mapbox",
      "osm": "© OpenStreetMap contributors",
      "improve": "Improve this map"
    }
  },
  "stops": {
    "kinds": {
      "pickup": "Recogida",
      "delivery": "Entrega"
    },
    "label": "{{kind}} {{n}}",
    "labelCity": "{{kind}} {{n}} · {{city}}",
    "company": "Empresa",
    "address": "Dirección",
    "addressLine2": "Dirección, línea 2",
    "city": "Ciudad",
    "state": "Estado",
    "postal": "ZIP",
    "appointmentDate": "Fecha de la cita",
    "appointmentTime": "Hora de la cita",
    "appointmentEnd": "Fin de la ventana",
    "appointmentEndHelp": "Déjalo vacío si la cita es a una hora fija.",
    "contactName": "Contacto",
    "contactPhone": "Teléfono de contacto",
    "reference": "Referencia",
    "notes": "Notas",
    "zoneNames": {
      "eastern": "Hora del Este",
      "central": "Hora del Centro",
      "mountain": "Hora de la Montaña",
      "arizona": "Hora de Arizona",
      "pacific": "Hora del Pacífico",
      "alaska": "Hora de Alaska",
      "hawaii": "Hora de Hawái",
      "other": "Hora de {{city}}"
    },
    "zoneLine": "{{zone}} ({{abbrev}}), según el estado",
    "zoneChosen": "{{zone}} ({{abbrev}})",
    "zoneAgency": "Hora de la agencia ({{abbrev}}): escribe el estado para usar la zona de la parada",
    "splitHint": "{{state}} tiene dos zonas horarias. Comprueba la zona.",
    "zoneSelect": "Zona horaria",
    "agencyTime": "{{time}} hora de la agencia",
    "noAppointment": "Sin cita",
    "window": "{{start}} a {{end}}",
    "arrived": "Llegó {{time}}",
    "departed": "Salió {{time}}",
    "dwell_one": "{{count}} min en el lugar",
    "dwell_other": "{{count}} min en el lugar",
    "editor": {
      "addPickup": "Añadir recogida",
      "addDelivery": "Añadir entrega",
      "moveUp": "Subir {{stop}}",
      "moveDown": "Bajar {{stop}}",
      "remove": "Quitar {{stop}}",
      "lastPickup": "Una carga necesita al menos una recogida.",
      "lastDelivery": "Una carga necesita al menos una entrega."
    },
    "reasons": {
      "visited": "El chofer ya pasó por esta parada.",
      "onlyPickup": "Es la única recogida de una carga que ya salió.",
      "onlyDelivery": "Es la única entrega de una carga que ya salió.",
      "finished": "El itinerario de una carga terminada no puede cambiar."
    },
    "actions": {
      "edit": "Editar {{stop}}",
      "recordArrival": "Registrar llegada",
      "recordDeparture": "Registrar salida",
      "remove": "Quitar",
      "add": "Añadir parada"
    },
    "removeTitle": "¿Quitar {{stop}}?",
    "removeBody": "La parada sale del itinerario y la app del chofer la quita.",
    "addPickupTitle": "Añadir una recogida a {{load}}",
    "addDeliveryTitle": "Añadir una entrega a {{load}}",
    "editTitle": "Editar {{stop}}",
    "noChange": "Todavía no cambiaste nada.",
    "saved": "Parada guardada",
    "addPartial": "Parada añadida, pero no se guardó su zona horaria, el fin de la ventana o la línea 2 de la dirección. Edita la parada para añadirlos.",
    "removed": "Parada quitada",
    "stamp": {
      "arrivalTitle": "Registrar la llegada a {{stop}}",
      "departureTitle": "Registrar la salida de {{stop}}",
      "arrivalQuestion": "¿Cuándo llegó el chofer?",
      "departureQuestion": "¿Cuándo salió el chofer?",
      "date": "Fecha",
      "time": "Hora",
      "zoneNote": "En la hora de la parada: {{zone}} ({{abbrev}}).",
      "save": "Registrar",
      "saved": "Hora registrada"
    }
  },
  "loadDetail": {
    "loading": "Cargando la carga…",
    "error": "No se pudo cargar la carga.",
    "notFound": "Esta carga no existe o no es de las tuyas.",
    "backToLoads": "Volver a las cargas",
    "sheetTitle": "Carga {{load}}",
    "openFullPage": "Abrir en página completa",
    "dispatcher": "Dispatcher: {{name}}",
    "noDispatcher": "Sin dispatcher",
    "reference": "Ref. {{reference}}",
    "tabsLabel": "Secciones de la carga",
    "tabs": {
      "overview": "Resumen",
      "stops": "Paradas",
      "documents": "Documentos",
      "financials": "Finanzas",
      "timeline": "Historial"
    },
    "parties": {
      "broker": "Broker",
      "carrier": "Carrier",
      "driver": "Chofer",
      "truck": "Camión",
      "mc": "MC {{mc}}",
      "dot": "DOT {{dot}}",
      "app": "App",
      "noApp": "Sin app",
      "noDriver": "Todavía sin chofer",
      "noTruck": "Todavía sin camión",
      "noBroker": "Sin broker",
      "setup": "Alta: {{status}}",
      "noSetup": "Sin alta con este broker",
      "call": "Llamar a {{name}}",
      "truckModel": "{{make}} {{model}}",
      "unit": "Unidad {{unit}}"
    },
    "ends": {
      "pickup": "Recogida",
      "delivery": "Entrega"
    },
    "facts": {
      "commodity": "Mercancía",
      "weight": "Peso",
      "weightValue": "{{weight}} lb",
      "length": "Largo",
      "lengthValue": "{{length}} pies",
      "notes": "Notas",
      "notSet": "Sin indicar"
    },
    "milesSummary": "{{loaded}} cargado + {{deadhead}} en vacío = {{total}} mi",
    "financials": {
      "rate": "Tarifa",
      "total": "Total",
      "loadedMiles": "Millas cargado",
      "deadheadMiles": "Millas en vacío",
      "totalMiles": "Millas totales",
      "rpmLoaded": "Tarifa / milla cargado",
      "rpmTotal": "Tarifa / milla total",
      "minimum": "Mínimo del carrier",
      "belowMinimum": "Por debajo del mínimo del carrier, {{min}}/mi.",
      "notSet": "Sin indicar",
      "feeTitle": "Comisión de dispatch",
      "estimatedAt": "Estimada al {{pct}} %",
      "sourceTruck": "Según el plan del camión.",
      "sourceCarrier": "Según el plan del carrier.",
      "frozen": "Fijada el {{date}} al {{pct}} %",
      "fee": "Comisión de dispatch",
      "carrierNet": "Neto del carrier",
      "disputed": "En disputa",
      "noPlan": "Este carrier no tiene % de dispatch.",
      "feeHidden": "La comisión de dispatch la ven admin y contabilidad.",
      "milesLocked": "Las millas todavía no se pueden cambiar después del POD.",
      "tonuFrozen": "Comisión del TONU ganada el {{date}} al {{pct}} %",
      "accessorial": "Extras"
    }
  },
  "loadActions": {
    "label": "Acciones de la carga",
    "book": "Reservar",
    "dispatch": "Despachar",
    "accept": "El chofer aceptó (por teléfono)",
    "decline": "El chofer rechazó (por teléfono)",
    "unassign": "Quitar chofer",
    "atPickup": "En recogida (por teléfono)",
    "loaded": "Cargada (por teléfono)",
    "inTransit": "En tránsito (por teléfono)",
    "delivered": "Entregada (por teléfono)",
    "podReceived": "POD recibido",
    "uploadPod": "Subir POD",
    "price": "Editar tarifa y millas",
    "reprice": "Cambiar la tarifa",
    "invoiceBroker": "Facturar al broker",
    "cancel": "Cancelar la carga",
    "editDetails": "Editar detalles",
    "more": "Más acciones",
    "block": {
      "noStops": "Añade una recogida y una entrega antes de despachar.",
      "noRate": "Añade la tarifa antes de confirmar el POD.",
      "noPlan": "Fija el % de dispatch de este carrier antes de confirmar el POD.",
      "receivable": "Esta carga está facturada al broker. Desmárcala en Pagos de brokers antes de cancelarla.",
      "rolling": "El chofer ya llegó a una parada. Para quitarle la carga, cancélala."
    },
    "dispatchDialog": {
      "title": "Despachar {{load}}",
      "driver": "Chofer",
      "driverApp": "{{name}} · App",
      "driverNoApp": "{{name}} · Sin app (responde por teléfono)",
      "truck": "Camión",
      "truckOption": "Unidad {{unit}}",
      "truckPaired": "Unidad {{unit}} · Asignado a {{name}}",
      "choose": "Elige…",
      "noDrivers": "Ningún chofer activo tiene puesto en {{carrier}}.",
      "noTrucks": "{{carrier}} no tiene ningún camión activo.",
      "appLine": "{{name}} recibe un aviso en la app y responde allí.",
      "noAppLine": "{{name}} no tiene app: registra su respuesta por teléfono.",
      "bookFirst": "Primero se reserva la carga.",
      "noBroker": "Esta carga todavía no tiene broker. Puedes despacharla ahora y agregar el broker después con Editar detalles.",
      "submit": "Despachar",
      "bookedButNotDispatched": "{{load}} quedó reservada, pero el despacho falló: {{reason}}"
    },
    "acceptDialog": {
      "title": "¿{{name}} aceptó {{load}}?",
      "body": "Esto registra que {{name}} aceptó por teléfono.",
      "submit": "Registrar la aceptación"
    },
    "declineDialog": {
      "title": "{{name}} rechazó {{load}}",
      "body": "Esto registra que {{name}} rechazó. La carga vuelve a Reservada y se abre una tarea.",
      "reasonPlaceholder": "¿Qué dijo el chofer?",
      "submit": "Registrar el rechazo"
    },
    "advanceDialog": {
      "title": "¿Marcar {{load}} como {{status}}?",
      "body": "La app de {{name}} también lo muestra.",
      "submit": "Marcar {{status}}"
    },
    "priceDialog": {
      "title": "Editar tarifa y millas de {{load}}",
      "submit": "Guardar"
    },
    "editDetailsDialog": {
      "title": "Editar detalles de {{load}}",
      "body": "Corrige lo que se escribió mal o quedó en blanco al crear la carga. La tarifa y las millas se editan aparte.",
      "notes": "Notas de la oficina",
      "notesHelp": "Solo la oficina ve estas notas. El chofer no.",
      "invoicedLock": "Esta carga está facturada al broker: desmárcala en Pagos de brokers para cambiar el broker o el número de carga.",
      "submit": "Guardar"
    },
    "repriceDialog": {
      "title": "Cambiar la tarifa de {{load}}",
      "consequence": "La comisión se recalcula al {{pct}} % ya fijado.",
      "consequenceUnknown": "La comisión se recalcula al porcentaje ya fijado.",
      "submit": "Cambiar la tarifa"
    },
    "cancelDialog": {
      "title": "¿Cancelar {{load}}?",
      "body": "La app del chofer quita la carga. Sin TONU, la comisión y el pago del chofer, si los hay, se revierten.",
      "submit": "Cancelar la carga",
      "tonu": "El broker paga un TONU",
      "tonuHelp": "La comisión de la agencia y la del arrendamiento se cobran sobre el TONU, ganadas hoy.",
      "tonuAmount": "Importe del TONU"
    },
    "unassignDialog": {
      "title": "¿Quitar a {{name}} de {{load}}?",
      "titleNoName": "¿Quitar el chofer de {{load}}?",
      "bodyDispatched": "La carga vuelve a Reservada sin chofer ni camión, y la app del chofer la quita. Después, despáchala a otro chofer.",
      "bodyAccepted": "El chofer ya aceptó esta carga. Vuelve a Reservada sin chofer ni camión, y la app del chofer la quita. Escribe el motivo: queda en el registro de la oficina y el chofer no lo ve.",
      "optional": "Opcional. El chofer no lo ve.",
      "submit": "Quitar chofer"
    },
    "podDialog": {
      "title": "¿Confirmar el POD de {{load}}?",
      "withPod": "POD de {{name}}, {{date}}.",
      "noPod": "No hay ningún POD subido para {{load}}. Confirma solo si lo tienes por correo o en papel. Puedes subirlo después.",
      "uploadFirst": "Subirlo primero",
      "consequence": "La comisión de la agencia se gana ahora.",
      "submit": "Confirmar POD recibido"
    },
    "uploadDialog": {
      "title": "Subir un documento a {{load}}",
      "hint": "Elige el tipo de documento y el archivo. La oficina y la app del chofer lo ven en la carga.",
      "kind": "Tipo de documento",
      "file": "Archivo",
      "submit": "Subir",
      "uploading": "Subiendo…"
    },
    "reason": "Motivo",
    "noChange": "Todavía no cambiaste nada.",
    "done": {
      "booked": "{{load}} reservada",
      "dispatched": "{{load}} despachada a {{name}}",
      "accepted": "{{load}} aceptada",
      "declined": "{{load}} vuelve a estar Reservada",
      "advanced": "{{load}} ahora está {{status}}",
      "podReceived": "POD recibido de {{load}}",
      "priced": "Tarifa y millas guardadas",
      "repriced": "Tarifa de {{load}} cambiada",
      "detailsSaved": "Detalles de {{load}} guardados",
      "canceled": "{{load}} cancelada",
      "uploaded": "{{kind}} subido",
      "unassigned": "{{load}} vuelve a estar Reservada. Despáchala a otro chofer."
    }
  },
  "docCenter": {
    "ownerKind": {
      "label": "Tipo",
      "carrier": "Carriers",
      "truck": "Camiones",
      "driver": "Choferes",
      "one": {
        "carrier": "Carrier",
        "truck": "Camión",
        "driver": "Chofer"
      }
    },
    "status": {
      "valid": "Vigente",
      "missing": "Falta",
      "expiresToday": "Vence hoy",
      "expiresIn_one": "Queda {{count}} día",
      "expiresIn_other": "Quedan {{count}} días",
      "expiredAgo_one": "Venció hace {{count}} día",
      "expiredAgo_other": "Venció hace {{count}} días"
    },
    "required": "Obligatorio",
    "optional": "Opcional",
    "expiresOn": "Vence el {{date}}",
    "copies_one": "{{count}} copia",
    "copies_other": "{{count}} copias",
    "progress": "{{done}} de {{total}} obligatorios archivados",
    "checklist": "Lista",
    "openChecklist": "Abrir los documentos de {{owner}}",
    "search": "Buscar por nombre",
    "loadFailed": "No se pudieron cargar los documentos.",
    "empty": {
      "carrier": "Todavía no hay carriers.",
      "truck": "Todavía no hay camiones.",
      "driver": "Todavía no hay choferes."
    },
    "filter": {
      "label": "Mostrar",
      "all": "Todos",
      "attention": "Requieren atención",
      "missing": "Con documentos que faltan",
      "expiring": "Por vencer",
      "expired": "Vencidos",
      "complete": "Completos"
    },
    "summary": {
      "complete": "Completo",
      "missing_one": "Falta {{count}}",
      "missing_other": "Faltan {{count}}",
      "expiring_one": "{{count}} por vencer",
      "expiring_other": "{{count}} por vencer",
      "expired_one": "{{count}} vencido",
      "expired_other": "{{count}} vencidos"
    },
    "actions": {
      "upload": "Subir",
      "uploadKind": "Subir {{kind}}",
      "replace": "Reemplazar",
      "replaceKind": "Reemplazar {{kind}}",
      "addCopy": "Añadir copia",
      "addCopyKind": "Añadir una copia de {{kind}}",
      "download": "Descargar",
      "downloadKind": "Descargar {{kind}}",
      "dates": "Fechas",
      "datesKind": "Editar las fechas de {{kind}}",
      "archive": "Archivar",
      "archiveKind": "Archivar {{kind}}",
      "addDocument": "Añadir un documento"
    },
    "upload": {
      "title": "Subir un documento de {{owner}}",
      "titleKind": "Subir {{kind}}",
      "forOwner": "Para {{owner}}.",
      "pickHint": "Elige el tipo, el archivo y sus fechas.",
      "replaceTitle": "Reemplazar {{kind}}",
      "replaceHint": "La copia actual ({{file}}) pasa al historial.",
      "kind": "Documento",
      "file": "Archivo",
      "issuedOn": "Emitido el",
      "expiresOn": "Vence el",
      "expiresHint": "Déjalo vacío si el documento no vence.",
      "submit": "Subir",
      "replaceSubmit": "Reemplazar",
      "uploading": "Subiendo…",
      "attachFailed": "El archivo se subió pero no se guardó en la lista. Inténtalo de nuevo.",
      "done": "Documento guardado."
    },
    "dates": {
      "title": "Corregir las fechas",
      "saved": "Fechas guardadas."
    },
    "archive": {
      "title": "¿Archivar {{kind}}?",
      "body": "Deja de contar en la lista y pasa al historial, donde se puede seguir descargando.",
      "done": "Documento archivado."
    },
    "history": {
      "title": "Historial",
      "empty": "No hay copias reemplazadas ni archivadas.",
      "replaced": "Reemplazado",
      "archived": "Archivado"
    },
    "requirements": {
      "open": "Requisitos",
      "title": "Requisitos de documentos",
      "blurb": "Lo que la agencia exige a cada carrier, camión y chofer, y cuántos días antes del vencimiento se crea la tarea.",
      "required": "Obligatorio",
      "requiredFor": "Obligatorio: {{kind}}",
      "warnDays": "días de aviso",
      "saved": "Requisito guardado."
    },
    "errors": {
      "expiryBeforeIssue": "La fecha de vencimiento no puede ser anterior a la de emisión.",
      "wrongKind": "Ese documento no corresponde a este registro.",
      "alreadyReplaced": "Alguien ya reemplazó o archivó esta copia. Recarga la lista.",
      "notAllowed": "No puedes cambiar este documento. Los papeles de dinero son para admin y contabilidad; el resto, para quien lleva el carrier."
    },
    "package": {
      "filter": {
        "incomplete": "Paquetes incompletos",
        "complete": "Paquetes completos",
        "all": "Todos los carriers"
      },
      "search": "Buscar carriers",
      "missingTitle": "Falta",
      "more": "+{{count}} más",
      "print": "Hoja de portada",
      "printNow": "Imprimir",
      "download": "Descargar paquete",
      "downloadFor": "Descargar el paquete de {{carrier}}",
      "preparing": "Preparando…",
      "partial_one": "No se pudo descargar {{count}} archivo; el paquete lleva el resto.",
      "partial_other": "No se pudieron descargar {{count}} archivos; el paquete lleva el resto.",
      "allComplete": "Todos los paquetes de carrier están completos.",
      "notFound": "Este carrier no está en tu lista.",
      "back": "Volver a paquetes",
      "sheetTitle": "Paquete del carrier: {{carrier}}",
      "generated": "Generado el {{date}}"
    }
  },
  "documentKind": {
    "rateConfirmation": "Confirmación de tarifa",
    "bol": "BOL",
    "pod": "POD",
    "lumperReceipt": "Recibo de lumper",
    "fuelReceipt": "Recibo de combustible",
    "tollReceipt": "Recibo de peaje",
    "scaleReceipt": "Ticket de báscula",
    "detention": "Detención",
    "tonu": "TONU",
    "other": "Otro",
    "w9": "W-9",
    "mcAuthority": "Autoridad MC",
    "insurance": "Certificado de seguro (COI)",
    "noa": "Carta NOA",
    "dispatchAgreement": "Contrato de despacho",
    "factoring": "Contrato de factoring",
    "cdl": "CDL",
    "medicalCard": "Tarjeta médica",
    "registration": "Registro",
    "annualInspection": "Inspección anual",
    "permit": "Permiso",
    "voidCheck": "Cheque anulado",
    "zelleInfo": "Datos de Zelle",
    "dotAuthority": "Autoridad DOT",
    "limitedPoa": "Poder notarial limitado",
    "companyProfile": "Hoja de perfil de la compañía",
    "truckOperationForm": "Formulario de operación de camiones",
    "carrierReferences": "Referencias",
    "cabCard": "Cab card",
    "truckPhoto": "Foto del camión (con los carteles)",
    "vinPhoto": "Foto del VIN",
    "maintenanceRecord": "Registro de mantenimiento"
  },
  "loadDocs": {
    "upload": "Subir documento",
    "download": "Descargar {{name}}",
    "newPill": "Nuevo",
    "notUploaded": "Sin subir",
    "fromApp": "{{name}} desde la app",
    "uploadedBy": "{{name}}, {{time}}",
    "sizeKb": "{{size}} KB",
    "sizeMb": "{{size}} MB",
    "empty": "Todavía no hay documentos.",
    "attachFailed": "El archivo se subió pero no quedó adjunto. Inténtalo de nuevo.",
    "fileName": "Documento",
    "replace": "Reemplazar {{name}}",
    "archive": "Archivar {{name}}",
    "replaceDialog": {
      "title": "Reemplazar {{name}}",
      "body": "El archivo nuevo ocupa su lugar en {{load}}. La copia anterior queda en el historial, con tu nombre y el motivo.",
      "reason": "Motivo (opcional)",
      "submit": "Reemplazar",
      "busy": "Reemplazando…"
    },
    "archiveDialog": {
      "title": "¿Archivar {{name}}?",
      "body": "Sale de la carga, de las listas y del próximo paquete al broker. El archivo queda en el historial, con tu nombre y el motivo. Un paquete ya enviado conserva su copia.",
      "confirm": "Archivar"
    },
    "history": {
      "title": "Reemplazados y archivados",
      "replaced": "{{kind}} · reemplazado por {{name}}, {{time}}",
      "archived": "{{kind}} · archivado por {{name}}, {{time}}",
      "reason": "Motivo: {{reason}}"
    },
    "done": {
      "replaced": "Documento reemplazado.",
      "archived": "Documento archivado."
    },
    "errors": {
      "notAllowed": "Solo la oficina que lleva este carrier (admin, manager o su dispatcher) puede reemplazar o archivar un documento de la carga.",
      "alreadyChanged": "Alguien ya reemplazó o archivó esta copia. Vuelve a abrir la carga.",
      "alreadyOnLoad": "Ese archivo ya está en esta carga. Vuelve a subir la copia nueva.",
      "reasonRequired": "Escribe por qué lo archivas.",
      "reasonTooLong": "El motivo no puede pasar de 500 caracteres."
    },
    "inInvoice": "En la factura al broker"
  },
  "chat": {
    "inboxTitle": "Mensajes",
    "inboxEmpty": "Aún no hay conversaciones. Empieza una desde un chofer.",
    "newMessage": "Mensaje nuevo",
    "searchDrivers": "Buscar choferes",
    "pickDriver": "¿A quién quieres escribir?",
    "pickThread": "Elige una conversación, o empieza una con Mensaje nuevo.",
    "youPrefix": "Tú:",
    "attachmentPhoto": "Foto",
    "attachmentPdf": "PDF",
    "attachmentUnavailable": "No disponible",
    "openAttachment": "Abrir {{name}}",
    "placeholder": "Escribe un mensaje",
    "send": "Enviar",
    "attach": "Adjuntar una foto o un PDF",
    "aboutLoad": "Sobre la carga",
    "noLoad": "Sin carga",
    "aLoad": "Carga",
    "seen": "Visto",
    "sending": "Enviando…",
    "failed": "No se envió. Reintentar",
    "today": "Hoy",
    "yesterday": "Ayer",
    "earlier": "Mensajes anteriores",
    "threadEmpty": "Aún no hay mensajes. Saluda.",
    "noApp": "{{driver}} todavía no tiene la app de Coreway. Tus mensajes lo esperan aquí hasta que entre.",
    "noAppShort": "Sin app",
    "removed": "Este chofer fue eliminado. La conversación es solo de lectura.",
    "removedDriver": "Chofer eliminado",
    "formerMember": "Antiguo miembro del equipo",
    "driverSide": "Chofer",
    "notAllowed": "El chat es para el despachador del chofer, los administradores y los gerentes.",
    "badge": "{{count}} conversaciones sin leer",
    "unreadInThread": "{{count}} sin leer",
    "backToInbox": "Volver a mensajes",
    "openDriver": "Abrir chofer",
    "toast": {
      "newMessage": "Mensaje nuevo de {{driver}}",
      "open": "Abrir"
    },
    "errors": {
      "tooBig": "Archivo demasiado grande (máx. 10 MB).",
      "badType": "Envía una foto (JPEG, PNG, WebP) o un PDF.",
      "tooLong": "Un mensaje puede tener hasta 4000 caracteres.",
      "notAllowed": "Ya no puedes escribir a este chofer.",
      "gone": "Esta conversación ya no está disponible.",
      "removed": "Este chofer fue eliminado.",
      "paused": "Esta agencia está en pausa.",
      "generic": "Algo salió mal. Inténtalo de nuevo."
    },
    "entry": {
      "message": "Escribir",
      "messageDriver": "Escribir al chofer",
      "loadPanelTitle": "Chat de esta carga",
      "loadPanelEmpty": "Aún no hay mensajes sobre esta carga.",
      "openThread": "Abrir la conversación completa"
    }
  },
  "docLists": {
    "search": "Buscar",
    "searchPlaceholder": "Carga, archivo, broker, carrier, chofer",
    "window": "Incluye las cargas de la lista de Cargas: en curso, y cerradas en los últimos 90 días.",
    "noMatch": "Ningún documento coincide con estos filtros.",
    "open": "Abrir",
    "columns": {
      "load": "Carga",
      "kind": "Tipo",
      "status": "Estado",
      "broker": "Broker",
      "carrier": "Carrier",
      "pickup": "Recogida",
      "file": "Archivo",
      "uploaded": "Subido",
      "actions": "Acciones",
      "invoice": "En la factura al broker"
    },
    "rateCons": {
      "tabsLabel": "Confirmaciones de tarifa",
      "tabs": {
        "onFile": "Archivadas",
        "missing": "Faltan"
      },
      "empty": "Aún no hay confirmaciones de tarifa. Se suben al crear la carga, o desde la pestaña Faltan.",
      "noneMissing": "Todas las cargas reservadas tienen su confirmación de tarifa.",
      "uploadFor": "Subir la confirmación de tarifa de la carga {{load}}",
      "uploaded": "Confirmación de tarifa de {{load}} subida."
    },
    "receipts": {
      "add": "Añadir recibo",
      "allKinds": "Todos los tipos",
      "empty": "Aún no hay recibos. Añade uno aquí o desde la carga.",
      "archived": "Archivado",
      "includeInInvoice": "Incluir {{name}} en la factura al broker",
      "marked": "{{name}} va en la factura al broker.",
      "unmarked": "{{name}} queda fuera de la factura al broker.",
      "showArchived": "Mostrar archivados",
      "invoiceHelp": "El paquete al broker adjunta los recibos marcados. Un recibo de lumper nuevo se marca solo y los anteriores se desmarcan."
    },
    "upload": {
      "action": "Subir",
      "title": "Añadir un recibo",
      "hint": "Escribe el número de carga y luego elige el tipo y el archivo.",
      "loadNumber": "Número de carga",
      "loadNumberPlaceholder": "CW-1041",
      "noSuchLoad": "No hay ninguna carga {{number}} en tu lista. Revisa el número, o añádelo desde la carga."
    }
  },
  "support": {
    "mailSubject": "Soporte de Coreway ({{version}})",
    "version": "Versión del portal",
    "contact": {
      "title": "Contactar con soporte",
      "body": "Escríbenos y te responde una persona. Cuenta qué estabas haciendo y qué esperabas.",
      "noEmail": "Este portal no tiene configurada una dirección de soporte. Usa la página de soporte de abajo.",
      "page": "Página de soporte: horario y contacto de seguridad"
    },
    "report": {
      "title": "Cómo reportar un problema",
      "steps": {
        "what": "Qué hiciste, y qué pasó en su lugar.",
        "where": "Dónde: la pantalla, y el número de carga, chofer o carrier.",
        "when": "Cuándo pasó (tu zona horaria).",
        "screenshot": "Una captura de pantalla, si puedes.",
        "diagnostics": "Los datos de abajo, pegados en tu mensaje."
      },
      "security": "¿Un problema de seguridad? Dilo en el asunto, y no incluyas contraseñas.",
      "copy": "Copiar datos",
      "copied": "Datos copiados"
    }
  },
  "assignedDrivers": {
    "noDispatcher": "Sin dispatcher",
    "counts": "Carriers: {{carriers}} · Choferes: {{drivers}}",
    "carriers": "Carriers",
    "noCarriers": "Aún no tiene carriers asignados.",
    "noDrivers": "Ningún chofer con un puesto activo en estos carriers.",
    "truck": "Camión {{unit}}",
    "noTruck": "Sin camión",
    "hasApp": "Tiene la app",
    "call": "Llamar a {{name}}",
    "manage": "Asignar carriers",
    "empty": "Aún no hay dispatchers activos. Invita a uno desde Ajustes > Equipo.",
    "emptySelf": "Aún no tienes carriers asignados. Un admin los asigna en Ajustes > Equipo."
  },
  "realtime": {
    "live": "En vivo",
    "liveTitle": "Los cambios aparecen aquí en cuanto pasan.",
    "polling": "Se actualiza cada 20 s",
    "pollingTitle": "La conexión en vivo está caída: esta vista se actualiza cada 20 segundos.",
    "announce": "{{load}} ahora está {{status}}",
    "announceDocument": "Llegó {{kind}} de {{load}}",
    "rejected": "{{driver}} rechazó {{load}}: {{reason}}",
    "rejectedNoReason": "{{driver}} rechazó {{load}}",
    "unknownDriver": "El chofer",
    "openLoad": "Abrir la carga"
  },
  "dashboard": {
    "selectLoad": "Elige una carga en el tablero",
    "sampleBadge": "Datos de ejemplo",
    "sampleBadgeTitle": "Estas cifras todavía no salen de tus datos.",
    "detailTitle": "Detalle de la carga"
  },
  "legal": {
    "checking": "Comprobando tu aceptación…",
    "error": "No pudimos comprobar si aceptaste los Términos. Revisa tu conexión e inténtalo de nuevo.",
    "retry": "Reintentar",
    "title": "Revisa y acepta para continuar",
    "body": "Antes de usar el Portal de Coreway, lee los Términos del Servicio y la Política de Privacidad.",
    "updated": "Los Términos del Servicio o la Política de Privacidad cambiaron desde la última vez que los aceptaste.",
    "record": "Al aceptar, guardamos las versiones que aceptaste, la fecha, que fue en el Portal y el idioma.",
    "terms": "Términos del Servicio",
    "privacy": "Política de Privacidad",
    "version": "Versión {{version}}",
    "newTab": "(se abre en una pestaña nueva)",
    "agree": "He leído y acepto los Términos del Servicio y he leído la Política de Privacidad",
    "accept": "Acepto",
    "accepting": "Guardando…",
    "decline": "Rechazar y cerrar sesión"
  },
  "ownerFees": {
    "settings": {
      "title": "Comisiones y estados de cuenta de dueños",
      "intro": "Cómo se calcula el porcentaje de la agencia, los valores con que empieza un arrendamiento nuevo y cómo cierran los estados de cuenta semanales. Cada cambio aplica a las cargas cuyo POD se marque recibido después.",
      "readOnly": "Solo el administrador de la agencia (o quien tenga \"Editar ajustes de comisiones\") los cambia.",
      "noAccess": "Los ajustes de comisiones los ven el administrador y contabilidad.",
      "saved": "Ajustes de comisiones guardados",
      "save": "Guardar ajustes de comisiones",
      "exampleLabel": "Ejemplo",
      "dispatchFeeBase": {
        "label": "Sobre qué se calcula el porcentaje de la agencia",
        "rule": "Flete más TONU. El lumper y otros reembolsos nunca se incluyen."
      },
      "defaultLeaseCommissionPct": {
        "label": "Comisión por defecto de los camiones arrendados",
        "help": "El porcentaje que el carrier se queda de cada carga de un camión arrendado, precargado al arrendar un camión. Cada arrendamiento puede tener el suyo. La comisión de la agencia va dentro, no se suma.",
        "example": "15 % de un flete de $2,400 = $360.00. Con la agencia al 5 % ($120.00), el carrier se queda $240.00."
      },
      "defaultLeaseWeeklyInsurance": {
        "label": "Seguro semanal por defecto por camión arrendado",
        "help": "Se precarga como el cargo semanal «Seguro» de un arrendamiento nuevo. Se cobra una vez por cada semana que toca el arrendamiento, haya cargas o no; puedes perdonarlo en un borrador. 0 significa sin cargo por defecto.",
        "example": "$250. Una semana sin cargas: el estado de cuenta muestra -$250.00."
      },
      "ownerDeficitCarryForward": {
        "label": "Arrastrar una semana negativa",
        "help": "Cuando un estado de cuenta final termina en negativo (el dueño del camión le debe al carrier), el saldo abre el siguiente. Desactivado: cada semana va sola y el déficit se cobra fuera de Coreway.",
        "example": "Semana 1: solo seguro, -$250.00. Semana 2: $1,275.00 de cargas, -$250.00 de seguro, -$250.00 de saldo: paga $775.00."
      },
      "ownerStatementsAutoFinalize": {
        "label": "Finalizar automáticamente los estados de cuenta",
        "help": "Desactivado (por defecto): el cierre del viernes deja borradores para revisar, añadir la tarjeta de combustible y finalizar. Activado: el cierre del viernes los finaliza; uno con una carga en disputa queda en borrador.",
        "example": "Desactivado: OS-1001 espera como borrador el viernes por la mañana."
      },
      "pctInvalid": "Escribe un porcentaje de 0 a 100, con dos decimales como máximo.",
      "dispatchDetentionPct": {
        "label": "Porcentaje de la agencia sobre el detention",
        "help": "0 (por defecto, lo que dice el contrato: «excluding accessorial») significa que la agencia no cobra sobre el detention. Solo las cargas cuya comisión se gane después del cambio usan la tasa nueva.",
        "example": "Flete $2,000, detention $150, lumper $150, 5 %: al 0 % la agencia factura $100.00; al 5 % $107.50."
      },
      "defaultLeaseDetentionPct": {
        "label": "Comisión por defecto sobre el detention (camiones arrendados)",
        "help": "Se precarga en los arrendamientos nuevos. 0 deja el detention completo al dueño del camión.",
        "example": "Detention $150 al 15 %: $22.50 más de comisión."
      },
      "tonuDriverPay": {
        "label": "Pago al chofer en un TONU",
        "help": "«Plan del chofer» paga a cada chofer según su plan sobre el TONU (el dueño-operador se queda el TONU menos la comisión; un chofer a porcentaje del flete no recibe nada). «Sin pago al chofer» deja todo TONU fuera del pago.",
        "example": "TONU $300, arrendamiento 15 %: la parte del dueño-operador es $255.00.",
        "plan": "Plan del chofer",
        "none": "Sin pago al chofer"
      }
    },
    "lease": {
      "title": "Arrendamiento",
      "loading": "Cargando el arrendamiento",
      "error": "No se pudo cargar el arrendamiento.",
      "ownedByCarrier": "Es del carrier: sus cargas no pagan comisión de dueño.",
      "noOwner": "Este camión aún no tiene dueño. Indica el dueño arriba y guarda antes de arrendarlo.",
      "ownerIsCarrierOwner": "Su dueño también es dueño del carrier: un camión propio del carrier no se arrienda.",
      "leasedBy": "Arrendado por {{owner}} desde {{date}}",
      "until": "hasta {{date}}",
      "commission": "Comisión {{pct}} % del flete + TONU; detention {{detention}} %",
      "charges": "Cargos semanales",
      "noCharges": "Sin cargo semanal",
      "chargeLine": "{{label}}: {{amount}} a la semana",
      "notes": "Notas",
      "create": "Arrendar este camión",
      "edit": "Editar condiciones",
      "end": "Terminar arrendamiento",
      "history": "Arrendamientos anteriores",
      "historyLine": "{{from}} a {{to}} · {{owner}} · {{pct}} %",
      "open": "abierto",
      "marginWarning": "La comisión ({{pct}} %) es menor que la comisión de la agencia en este camión ({{fee}} %): el carrier perdería dinero en cada carga.",
      "pastStart_one": "{{date}} ya pasó. Al guardar se cobra la comisión en {{count}} carga de este camión entregada desde entonces con el POD recibido. Va en el próximo estado de cuenta del dueño, y el truck net que se pague por ella baja en la comisión.",
      "pastStart_other": "{{date}} ya pasó. Al guardar se cobra la comisión en {{count}} cargas de este camión entregadas desde entonces con el POD recibido. Van en el próximo estado de cuenta del dueño, y el truck net que se pague por ellas baja en la comisión.",
      "pastStartNone": "{{date}} ya pasó. Ninguna carga de este camión entregada desde entonces está pendiente de comisión, así que ahora no se cobra nada nuevo; las que reciban el POD más tarde pagan la comisión.",
      "pastStartUnknown": "{{date}} ya pasó. Al guardar se cobra la comisión en las cargas de este camión entregadas desde entonces con el POD recibido. Van en el próximo estado de cuenta del dueño, y el truck net que se pague por ellas baja en la comisión.",
      "dialog": {
        "createTitle": "Arrendar el camión {{unit}}",
        "editTitle": "Editar el arrendamiento del camión {{unit}}",
        "description": "{{owner}} arrienda este camión a {{carrier}}. El carrier se queda la comisión de cada carga y le paga al dueño el resto cada semana.",
        "startsOn": "Empieza el",
        "startsOnHelp": "Las cargas entregadas desde esta fecha (hora de la agencia) pagan la comisión. Una fecha anterior también cobra las cargas ya entregadas.",
        "commissionPct": "Comisión %",
        "chargesLabel": "Cargos semanales",
        "chargesHelp": "Se cobran una vez por cada semana que toca el arrendamiento, haya cargas o no.",
        "chargeLabel": "Cargo",
        "chargeAmount": "Por semana",
        "addCharge": "Añadir un cargo",
        "removeCharge": "Quitar {{label}}",
        "notes": "Notas",
        "save": "Guardar arrendamiento",
        "created": "El camión {{unit}} ya está arrendado",
        "saved": "Arrendamiento guardado",
        "appliesNote": "Una comisión nueva aplica a las cargas que se marquen recibidas desde ahora; las ya congeladas conservan la suya.",
        "detentionPct": "Comisión sobre el detention %",
        "ruleNote": "El % de comisión se aplica al flete más el TONU; el detention tiene su propio %; el lumper y otros reembolsos van completos al dueño del camión."
      },
      "endDialog": {
        "title": "Terminar el arrendamiento del camión {{unit}}",
        "body": "Las cargas entregadas después de esta fecha (hora de la agencia) ya no pagan la comisión, y los cargos semanales paran después de esa semana.",
        "endsOn": "Último día",
        "confirm": "Terminar arrendamiento",
        "done": "Arrendamiento terminado",
        "beforeStart": "El último día no puede ser anterior al inicio del arrendamiento ({{date}})."
      },
      "notLeased": "Aún sin arrendar: es de {{owner}}. No hay comisión de dueño hasta que lo arriendes.",
      "notLeasedHiddenOwner": "Aún sin arrendar: no hay comisión de dueño hasta que se arriende."
    },
    "statements": {
      "weekRule": "Una carga entra en el primer cierre del viernes (hora de la agencia, {{timeZone}}) después de marcar su POD como recibido.",
      "pendingNote": "Las cargas en disputa se listan aquí y no se cuentan hasta resolver la disputa.",
      "noAccess": "Los estados de cuenta de dueños los ven el administrador y contabilidad.",
      "loading": "Cargando los estados de cuenta",
      "error": "No se pudieron cargar los estados de cuenta.",
      "retry": "Reintentar",
      "empty": "Aún no hay estado de cuenta de esta semana. Se generan cada viernes para cada camión arrendado.",
      "emptyFiltered": "Ningún estado de cuenta coincide con estos filtros.",
      "filters": {
        "week": "Semana",
        "allWeeks": "Todas las semanas",
        "carrier": "Carrier",
        "owner": "Dueño arrendador",
        "status": "Estado",
        "all": "Todos"
      },
      "columns": {
        "number": "Número",
        "week": "Semana",
        "carrier": "Carrier",
        "lessor": "Dueño arrendador",
        "trucks": "Camiones",
        "loads": "Cargas",
        "gross": "Bruto",
        "commission": "Comisión",
        "charges": "Cargos",
        "adjustments": "Ajustes",
        "net": "Neto",
        "status": "Estado"
      },
      "totals": "Totales",
      "pendingBadge": "{{count}} pendientes",
      "status": {
        "draft": "Borrador",
        "final": "Final",
        "canceled": "Cancelado"
      },
      "weekOf": "Semana del {{date}}",
      "generate": {
        "action": "Generar estado de cuenta",
        "title": "Generar un estado de cuenta de dueño",
        "body": "Arma el borrador de un carrier y un dueño arrendador para una semana, o lo actualiza con lo que llegó después. El cierre del viernes lo hace solo.",
        "key": "Carrier y dueño arrendador",
        "keyPick": "Elige un arrendamiento",
        "noKeys": "Todavía no hay camiones arrendados. Arrienda un camión desde su ficha en Camiones.",
        "week": "Semana (lunes)",
        "weekHelp": "Sirve cualquier día de la semana; el estado de cuenta empieza en su lunes.",
        "confirm": "Generar",
        "done": "Estado de cuenta listo",
        "nothing": "No hay nada que liquidar esa semana: ni cargas, ni cargos semanales, ni saldo."
      }
    },
    "statement": {
      "back": "Todos los estados de cuenta",
      "loading": "Cargando el estado de cuenta",
      "error": "No se pudo cargar el estado de cuenta.",
      "notFound": "Este estado de cuenta no existe o no lo puedes ver.",
      "header": "{{carrier}} le paga a {{owner}}",
      "weekRange": "Semana del {{from}} al {{to}}",
      "sections": {
        "loads": "Cargas",
        "charges": "Cargos semanales",
        "adjustments": "Deducciones y créditos",
        "balanceForward": "Saldo anterior",
        "pending": "Pendientes (en disputa)",
        "totals": "Totales",
        "nextStatement": "Ganadas después del corte de este estado de cuenta (van en el siguiente)"
      },
      "columns": {
        "load": "Carga",
        "truck": "Camión",
        "delivered": "Entregada",
        "earned": "Ganada",
        "gross": "Bruto",
        "pct": "%",
        "commission": "Comisión",
        "agencyFee": "Comisión agencia",
        "carrierMargin": "Le queda al carrier",
        "amount": "Importe",
        "description": "Descripción",
        "reason": "Disputa"
      },
      "officeOnly": "La comisión de la agencia y lo que le queda al carrier son solo de la oficina: no salen en la copia del dueño.",
      "none": "Ninguno",
      "waived": "Perdonado",
      "waive": "Perdonar",
      "restore": "Restaurar",
      "defer": "Pasar a la semana siguiente",
      "deferHint": "Una carga que sale de este borrador entra en el estado de cuenta de la semana siguiente.",
      "removeLine": "Quitar",
      "addDeduction": "Añadir deducción",
      "addCredit": "Añadir crédito",
      "formula": {
        "loads": "Cargas (menos la comisión)",
        "charges": "Cargos semanales",
        "adjustments": "Deducciones y créditos",
        "balanceForward": "Saldo anterior",
        "netPay": "Neto: pagar a {{owner}}",
        "netOwes": "Neto: {{owner}} debe {{amount}}"
      },
      "actions": {
        "refresh": "Actualizar",
        "finalize": "Finalizar",
        "cancel": "Cancelar estado de cuenta",
        "print": "Imprimir copia del dueño",
        "csv": "Exportar CSV"
      },
      "refreshed": "Estado de cuenta actualizado",
      "finalizeDialog": {
        "title": "¿Finalizar {{number}}?",
        "body": "Un estado de cuenta final ya no cambia: para corregirlo después se cancela y se vuelve a generar la semana. Neto {{net}}.",
        "confirm": "Finalizar",
        "done": "{{number}} está final"
      },
      "cancelDialog": {
        "title": "¿Cancelar {{number}}?",
        "body": "Sus líneas se anulan y sus cargas vuelven a quedar pendientes. El número no se reutiliza.",
        "confirm": "Cancelar estado de cuenta",
        "done": "{{number}} cancelado"
      },
      "canceledNote": "Cancelado: {{reason}}",
      "carriedNote": "Su saldo lo arrastra un estado de cuenta posterior.",
      "finalNote": "Final el {{date}}.",
      "lineDialog": {
        "deductionTitle": "Añadir una deducción",
        "creditTitle": "Añadir un crédito",
        "description": "Descripción",
        "descriptionHelp": "Lo que lee el dueño, por ejemplo Tarjeta de combustible o Devolución de adelanto.",
        "amount": "Importe",
        "truck": "Camión",
        "anyTruck": "No es de un camión",
        "save": "Añadir",
        "done": "Línea añadida"
      },
      "lineRemoved": "Línea quitada",
      "lineWaived": "Cargo perdonado",
      "lineRestored": "Cargo restaurado",
      "loadDeferred": "Carga pasada a la semana siguiente",
      "editAmount": "Cambiar importe",
      "edited": "Cambiado, era {{amount}}",
      "amountDialog": {
        "body": "{{line}}. Escribe el importe sin signo; sigue siendo un cargo o un crédito.",
        "reason": "Motivo (opcional)",
        "done": "Importe cambiado"
      },
      "pctWithLease": "{{pct}} % (arrendamiento {{lease}} %)",
      "tonuTag": "TONU",
      "nextStatementNote": "Estas cargas generaron su comisión después del cierre del viernes a las 00:00 de esta semana ({{cut}}, hora de la agencia {{timeZone}}), o se pasaron a la semana siguiente. Van en el siguiente estado de cuenta y aquí no se cuentan.",
      "nextStatementError": "No se pudieron listar las cargas del siguiente estado de cuenta. Recarga la página para intentarlo de nuevo.",
      "canceledOn": "Cancelada {{date}}",
      "changeCommission": "Cambiar comisión"
    },
    "print": {
      "title": "Estado de cuenta del dueño",
      "language": "Idioma",
      "from": "Paga",
      "to": "Recibe",
      "period": "Semana",
      "number": "Estado de cuenta",
      "status": "Estado",
      "print": "Imprimir",
      "back": "Volver al estado de cuenta",
      "generatedOn": "Impreso el {{date}}"
    },
    "matrix": {
      "moneyOnly": "{{role}}: no disponible. El dinero de los dueños es solo para el administrador y contabilidad."
    },
    "errors": {
      "truckNoOwner": "Indica el dueño del camión antes de arrendarlo.",
      "ownerInactive": "El dueño del camión está inactivo. Reactívalo primero.",
      "overlap": "Este camión ya tiene un arrendamiento en esas fechas.",
      "loadsOutside": "Una carga de este arrendamiento se entregó fuera de esas fechas. Deja las fechas alrededor de cada carga entregada.",
      "onFinalStatement": "Esta carga está en un estado de cuenta final del dueño. Cancela el estado de cuenta primero.",
      "notDraft": "Solo se puede cambiar un estado de cuenta en borrador.",
      "disputedOnFinalize": "Una carga de este estado de cuenta está en disputa. Quítala o resuelve la disputa.",
      "cancelOrder": "Un estado de cuenta posterior arrastra este saldo. Cancela ese primero.",
      "weekFinal": "El estado de cuenta de esa semana está final. Cancélalo primero para volver a generarlo.",
      "alreadyCanceled": "Este estado de cuenta ya está cancelado.",
      "lineState": "Esa línea ya está en ese estado. Recarga el estado de cuenta.",
      "ownTruck": "Un camión propio del carrier no se arrienda.",
      "weekNotMonday": "Elige una semana que ya empezó (esta semana o antes).",
      "notLeased": "El camión de esta carga no está arrendado al carrier.",
      "lineWaivedAmount": "Restaura la línea antes de cambiar su importe.",
      "lineNotEditable": "Una línea de carga sigue a su comisión, y un saldo arrastrado solo se puede condonar.",
      "commissionPct": "Escribe un porcentaje de 0 a 100, con dos decimales como mucho."
    },
    "loadCommission": {
      "block": "Comisión del dueño",
      "title": "Comisión de esta carga",
      "useLease": "Usar la del arrendamiento ({{pct}} %)",
      "dialogBody": "La comisión del dueño del camión solo en esta carga. La del arrendamiento es {{pct}} %; el estado de cuenta del dueño la sigue mientras sea borrador.",
      "leasePct": "Arrendamiento",
      "loadPct": "Esta carga",
      "commission": "Comisión",
      "estimated": "Estimada {{amount}}",
      "statement": "Estado de cuenta",
      "noStatement": "Aún no está en un estado de cuenta",
      "notFrozen": "Estimada: la comisión se fija cuando la carga gana su comisión de dispatch.",
      "onFinal": "En el estado de cuenta final {{number}}: cancélalo para cambiarla.",
      "set": "Fijar la comisión de esta carga",
      "pct": "Comisión %",
      "reason": "Motivo",
      "saved": "Comisión guardada"
    }
  },
  "reports": {
    "download": "Descargar CSV",
    "carrier": "Carrier",
    "allCarriers": "Todos los carriers",
    "rule": "Cargas entregadas, y TONU, del {{from}} al {{to}}. Los días siguen la zona horaria de la agencia ({{timeZone}}); las semanas van de lunes a domingo.",
    "summary": "Totales del periodo",
    "moneyHidden": "Las comisiones, los ingresos de carriers y las facturas los ven el admin y contabilidad.",
    "groupBy": "Agrupar por",
    "tableLabel": "Ingresos por {{group}}",
    "loading": "Cargando el informe…",
    "empty": "No hay cargas entregadas en este periodo.",
    "error": "No se pudo cargar el informe.",
    "retry": "Reintentar",
    "total": "Total",
    "formerMember": "Antiguo miembro",
    "unknown": "Desconocido",
    "views": {
      "label": "Informe",
      "summary": "Resumen",
      "loads": "Detalle de cargas",
      "explore": "Explorar",
      "weekly": "Semana por chofer"
    },
    "cutDay": {
      "label": "La semana cierra el",
      "days": {
        "1": "Lunes",
        "2": "Martes",
        "3": "Miércoles",
        "4": "Jueves",
        "5": "Viernes",
        "6": "Sábado",
        "7": "Domingo"
      }
    },
    "scope": {
      "label": "Cargas",
      "completed": "Completadas",
      "pending": "Pendientes",
      "all": "Completadas y pendientes"
    },
    "dateBy": {
      "label": "Fecha por",
      "pickup": "Recogida",
      "completed": "Entrega",
      "help": {
        "pickup": "Una carga cuenta en el periodo de su primera recogida, aunque se haya entregado después. Su estado es el que tiene ahora.",
        "completed": "Las cargas completadas cuentan en el periodo en que se entregaron (un TONU, cuando se canceló). Las pendientes son las que siguen abiertas ahora."
      }
    },
    "driver": "Chofer",
    "allDrivers": "Todos los choferes",
    "detail": {
      "tableLabel": "Cargas por carrier y chofer",
      "rule": "Cargas del {{from}} al {{to}}. Los días siguen la zona horaria de la agencia ({{timeZone}}).",
      "pendingRule": "Pendientes: de reservada a en tránsito, con la primera recogida antes del fin del periodo (o sin programar aún), con su estado de ahora.",
      "truncated": "Solo se muestran las primeras 20.000 cargas. Acorta el periodo para verlas todas.",
      "noDriver": "Sin chofer asignado",
      "subtotalDriver_one": "Subtotal {{name}} · {{count}} carga",
      "subtotalDriver_other": "Subtotal {{name}} · {{count}} cargas",
      "subtotalCarrier_one": "Subtotal {{name}} · {{count}} carga",
      "subtotalCarrier_other": "Subtotal {{name}} · {{count}} cargas",
      "total_one": "Total · {{count}} carga",
      "total_other": "Total · {{count}} cargas",
      "empty": "No hay cargas en este periodo.",
      "tonu": "TONU",
      "columns": {
        "loadNumber": "Carga #",
        "status": "Estado",
        "broker": "Broker",
        "pickup": "Recogida",
        "origin": "Origen",
        "delivery": "Entregada / Entrega",
        "destination": "Destino",
        "loadedMiles": "Mi cargadas",
        "gross": "Bruto",
        "agencyFee": "Comisión",
        "carrierNet": "Neto carrier",
        "agencyFeeEstimate": "Comisión (estimada)",
        "carrierCut": "Comisión del carrier",
        "carrierCutPct": "% del carrier",
        "carrierCutEstimate": "Comisión del carrier (estimada)",
        "booked": "Reservada"
      },
      "bucket": {
        "completed": "Completada",
        "pending": "Pendiente"
      },
      "rulePickup": "Cargas recogidas del {{from}} al {{to}}. Los días de recogida siguen la zona horaria de cada parada, o la de la agencia ({{timeZone}}) si la parada no tiene.",
      "pendingRulePickup": "Pendientes: de reservada a en tránsito, recogidas en el periodo, con su estado de ahora.",
      "estimated": "≈ {{amount}}",
      "estimatedTitle": "Estimada: la comisión de la agencia se gana al recibir el POD",
      "estimateRule": "≈ indica un estimado: una carga gana la comisión de la agencia al recibir el POD. Hasta entonces la comisión y el neto del carrier se calculan con el % de dispatch del carrier y la tarifa, y los totales los muestran en una segunda línea, aparte de lo ya ganado.",
      "carrierCutRule": "Comisión del carrier: lo que se queda el carrier, la comisión del arrendamiento menos la comisión de la agencia (por ejemplo 15% menos 5% deja 10%). Un camión sin arrendamiento se estima con el valor por defecto de la agencia (Ajustes, Comisiones); registra el arrendamiento del camión para que sea exacta. Una carga puede llevar su propia comisión.",
      "negativeCutTitle": "El estimado sale por debajo de cero: el % de dispatch del carrier supera la comisión por defecto de la agencia. Revisa ese valor en Ajustes, Comisiones."
    },
    "export": {
      "label": "Exportar",
      "csv": "CSV (.csv)",
      "xlsx": "Excel (.xlsx)",
      "pdf": "PDF (.pdf)",
      "preparing": "Preparando el archivo…",
      "failed": "No se pudo crear el archivo. Inténtalo de nuevo.",
      "metaCarrier": "Carrier: {{name}}",
      "metaDriver": "Chofer: {{name}}",
      "metaScope": "Cargas: {{scope}}",
      "metaDateBy": "Fecha por: {{basis}}",
      "metaStatuses": "Estados: {{list}}"
    },
    "period": {
      "label": "Periodo",
      "this_week": "Esta semana",
      "last_week": "La semana pasada",
      "this_month": "Este mes",
      "last_month": "El mes pasado",
      "work_week": "Semana laboral",
      "last_work_week": "Semana laboral pasada",
      "custom": "Rango personalizado",
      "from": "Desde",
      "to": "Hasta",
      "pickBoth": "Elige un día de inicio y uno de fin.",
      "inverted": "El día de inicio debe ser igual o anterior al de fin.",
      "tooLong": "Un informe abarca como mucho dos años."
    },
    "groups": {
      "carrier": "Carrier",
      "driver": "Chofer",
      "truck": "Camión",
      "dispatcher": "Dispatcher",
      "broker": "Broker"
    },
    "unassigned": {
      "carrier": "Sin carrier",
      "driver": "Sin chofer",
      "truck": "Sin camión",
      "dispatcher": "Sin dispatcher",
      "broker": "Sin broker"
    },
    "tiles": {
      "loads": "Cargas (entregadas + TONU)",
      "loadsSplit": "{{delivered}} entregadas · {{tonu}} TONU",
      "gross": "Ingresos brutos",
      "rpm": "Tarifa media / milla",
      "rpmBase": "Por milla total (cargado + en vacío)",
      "loadedMiles": "Millas cargadas",
      "deadheadMiles": "Millas en vacío",
      "deadheadPct": "{{pct}} % de las millas totales",
      "totalMiles": "Millas totales",
      "agencyFee": "Comisiones ganadas",
      "carrierNet": "Ingresos de carriers",
      "invoicesIssued": "Facturas emitidas",
      "invoicesPaid": "Pagos recibidos",
      "outstanding": "Facturas pendientes",
      "overdue": "Facturas vencidas",
      "invoiceCount_one": "{{count}} factura",
      "invoiceCount_other": "{{count}} facturas"
    },
    "columns": {
      "loads": "Cargas",
      "trucks": "Camiones",
      "carriers": "Carriers",
      "gross": "Bruto",
      "loadedMiles": "Mi cargadas",
      "deadheadMiles": "Mi en vacío",
      "totalMiles": "Mi totales",
      "rpmLoaded": "RPM (cargadas)",
      "rpmTotal": "RPM (totales)",
      "deadheadPct": "% en vacío",
      "agencyFee": "Comisión",
      "carrierNet": "Neto carrier"
    },
    "basis": {
      "label": "Cargas por",
      "activity": "Actividad en el período",
      "booked": "Reservadas en el período",
      "delivered": "Entregadas en el período",
      "help": {
        "activity": "Cargas reservadas, recogidas, entregadas o canceladas en el período, más toda carga aún abierta al final.",
        "booked": "Solo cargas reservadas en el período (la primera vez que se reservaron; canceladas incluidas).",
        "delivered": "Solo cargas entregadas en el período."
      }
    },
    "weekly": {
      "tableLabel": "Cargas de la semana por carrier y chofer",
      "rule": "Cargas reservadas del {{from}} al {{to}} ({{timeZone}}), con el estado que tienen ahora.",
      "help": "Una carga cuenta en la semana en que se reservó, aunque se recoja o se entregue después.",
      "empty": "No hay cargas reservadas en este periodo con los estados elegidos.",
      "hidden_one": "{{count}} carga más oculta por el filtro de estado.",
      "hidden_other": "{{count}} cargas más ocultas por el filtro de estado.",
      "statuses": {
        "label": "Estados",
        "reset": "Estados por defecto",
        "tonu": "Cancelada (TONU)",
        "lastOne": "Al menos un estado queda elegido."
      }
    }
  },
  "dispatchPlan": {
    "menu": "% de despacho",
    "carrierTitle": "% de despacho",
    "truckTitle": "% de despacho en este camión",
    "pct": "% de despacho",
    "carrierHelp": "La parte de la agencia en las cargas de este carrier, aplicada al confirmar cada POD. Déjalo vacío si aún no hay plan acordado; 0 es despacho gratis.",
    "truckHelp": "Sustituye el {{pct}}% del carrier solo en este camión. Déjalo vacío para usar el del carrier.",
    "truckHelpNoCarrier": "Sustituye el plan del carrier solo en este camión. El carrier aún no tiene plan; déjalo vacío para seguir el del carrier cuando lo tenga.",
    "carrierPlaceholder": "Sin plan",
    "truckPlaceholder": "Plan del carrier",
    "saved": "{{name}}: despacho {{pct}}%",
    "removed": "{{name}}: plan de despacho eliminado",
    "readFailed": "No se pudo leer el plan actual. Cierra e inténtalo de nuevo."
  },
  "invoiceTiming": {
    "menu": "Momento de facturación",
    "title": "Momento de facturación",
    "label": "Facturar las cargas en tránsito en el cierre del viernes",
    "help": "Por defecto, el cierre del viernes factura solo las cargas con POD recibido, con corte el viernes a las 00:00 ({{timeZone}}). Si lo activas, el cierre también factura las cargas de este carrier ya recogidas (cargadas, en tránsito o entregadas sin POD), marcadas como provisionales en la factura. Cuando llega el POD, cualquier diferencia en la comisión va en una factura posterior como ajuste. Una carga cancelada después de facturada se acredita, y el crédito va en la siguiente factura del carrier que tenga cargos para compensarlo.",
    "exampleLabel": "Ejemplo",
    "example": "Viernes 00:00: la carga 5512 se recogió el jueves y sigue en camino. Su comisión del 8%, $160.00, va en la factura de este viernes como provisional. El POD llega el lunes con detención; la siguiente factura lleva la diferencia.",
    "savedOn": "{{name}}: las cargas en tránsito se facturan en el cierre del viernes",
    "savedOff": "{{name}}: solo se facturan en el cierre del viernes las cargas con POD recibido",
    "readFailed": "No se pudo leer la configuración actual. Cierra e inténtalo de nuevo.",
    "tag": "Factura en tránsito",
    "tagHelp": "Las cargas ya recogidas van en la factura del viernes como provisionales."
  },
  "deductions": {
    "title": "Deducciones",
    "help": "Lo que se descuenta de su liquidación semanal: cargos semanales, cargos únicos y adelantos que devuelve.",
    "readFailed": "No se pudieron leer sus deducciones.",
    "none": "Todavía no tiene deducciones.",
    "off": {
      "title": "Las deducciones están apagadas para este chofer",
      "what": "Las deducciones salen de la liquidación semanal cuando tu agencia o un dueño le paga a este chofer.",
      "who": "Hoy le pagan sus carriers.",
      "action": "Abrir el pago a choferes"
    },
    "kind": {
      "recurring": "Semanal",
      "one_off": "Único",
      "advance": "Adelanto"
    },
    "kindOption": {
      "recurring": "Semanal (recurrente)",
      "one_off": "Único",
      "advance": "Adelanto (se devuelve en cuotas)"
    },
    "perWeek": "{{amount}} por semana",
    "installment": "{{amount}} por semana hasta devolverlo",
    "whole": "Se descuenta entero en la próxima liquidación",
    "recovered": "Recuperado",
    "retired": "Retirada",
    "owedAgency": "Se le debe a la agencia",
    "owedOwner": "Se le debe a {{owner}}",
    "since": "desde el {{date}}",
    "between": "del {{from}} al {{to}}",
    "withoutLoadsShort": "también en semanas sin cargas",
    "add": "Agregar deducciones",
    "editLabel": "Editar {{label}}",
    "retire": "Retirar",
    "retireLabel": "Retirar {{label}}",
    "retireDialog": {
      "title": "¿Retirar {{label}}?",
      "body": "Deja de aplicarse desde la próxima liquidación. Las líneas que ya están en liquidaciones se quedan como están.",
      "optional": "Opcional.",
      "done": "{{label}} retirada."
    },
    "form": {
      "legend": "Deducciones nuevas",
      "help": "Una línea por deducción. Parte del catálogo de la agencia o escríbela.",
      "template": "Del catálogo (línea {{n}})",
      "templateNone": "Escribirla",
      "kind": "Tipo (línea {{n}})",
      "label": "Nombre (línea {{n}})",
      "amount": "Monto (línea {{n}})",
      "amountWeekly": "Se descuenta cada semana.",
      "amountTotal": "El total que debe.",
      "installment": "Cuota (línea {{n}})",
      "installmentHelp": "Se descuenta cada semana. Vacío descuenta todo el saldo de una vez.",
      "installmentTooBig": "La cuota no puede ser mayor que el total.",
      "addLine": "Agregar una línea",
      "removeLine": "Quitar la línea {{n}}",
      "payer": "Se le debe a",
      "payerOption": {
        "agency": "La agencia",
        "owner": "El dueño del camión"
      },
      "owner": "Dueño",
      "ownerPick": "Elige el dueño",
      "startsOn": "Primera semana",
      "startsOnHelp": "La semana que contiene esta fecha es la primera que se cobra (hora de la agencia, {{timeZone}}).",
      "withoutLoads": "Cobrar las líneas semanales aunque esa semana no tenga cargas",
      "save": "Guardar deducciones",
      "saved_one": "{{count}} deducción agregada.",
      "saved_other": "{{count}} deducciones agregadas."
    },
    "editDialog": {
      "title": "Editar {{label}}",
      "body": "Los cambios aplican desde la próxima liquidación. Las líneas que ya están en liquidaciones se quedan como están.",
      "label": "Nombre",
      "weekly": "Monto semanal",
      "installment": "Cuota",
      "endsOn": "Última semana",
      "endsOnHelp": "Vacío la deja abierta.",
      "endsBeforeStart": "La última semana no puede ser antes de la primera.",
      "notes": "Notas",
      "done": "{{label}} guardada."
    }
  },
  "driverSettlements": {
    "noAccess": "Las liquidaciones de choferes las ven el admin y contabilidad.",
    "loading": "Cargando liquidaciones de choferes…",
    "error": "No se pudieron cargar las liquidaciones de choferes.",
    "empty": "No hay liquidaciones de choferes esta semana.",
    "emptyFiltered": "Ninguna liquidación coincide con estos filtros.",
    "cardsLabel": "Liquidaciones de choferes",
    "totals": "Totales",
    "off": {
      "title": "Las liquidaciones semanales de choferes están apagadas",
      "what": "Cada semana Coreway arma una liquidación por chofer con sus cargas y deducciones, para que la revises, la cierres y la pagues.",
      "who": "Para agencias que pagan ellas mismas a choferes de compañía, o para un dueño de camión. Hoy cada carrier paga a sus choferes.",
      "action": "Abrir el pago a choferes"
    },
    "weekRule": {
      "4": "Una semana va de lunes a domingo y cierra el viernes a las 00:00 (hora de la agencia, {{timeZone}}). Las cargas ganadas después del cierre van a la semana siguiente.",
      "5": "Una semana va de lunes a domingo y cierra el sábado a las 00:00 (hora de la agencia, {{timeZone}}). Las cargas ganadas después del cierre van a la semana siguiente.",
      "6": "Una semana va de lunes a domingo y cierra el domingo a las 00:00 (hora de la agencia, {{timeZone}}). Las cargas ganadas después del cierre van a la semana siguiente.",
      "7": "Una semana va de lunes a domingo y cierra el lunes siguiente a las 00:00 (hora de la agencia, {{timeZone}})."
    },
    "status": {
      "draft": "Borrador",
      "final": "Final",
      "paid": "Pagada",
      "canceled": "Cancelada"
    },
    "payer": {
      "agency": "Agencia",
      "owner": "Dueño del camión"
    },
    "filters": {
      "week": "Semana",
      "allWeeks": "Todas las semanas",
      "payer": "Paga",
      "driver": "Chofer",
      "status": "Estado",
      "all": "Todos"
    },
    "columns": {
      "number": "Número",
      "week": "Semana",
      "driver": "Chofer",
      "payer": "Paga",
      "loads": "Cargas",
      "deductions": "Deducciones",
      "adjustments": "Ajustes",
      "balanceForward": "Saldo anterior",
      "net": "Neto",
      "status": "Estado"
    },
    "orphans": {
      "title": "Cargas sin dueño que le pague al chofer",
      "body": "Estas cargas se ganaron en un carrier cuyos choferes paga el dueño del camión, pero el camión no tiene dueño registrado, así que la parte del chofer quedó con el carrier. Registra el dueño del camión para que las próximas cargas entren en una liquidación."
    },
    "generate": {
      "action": "Generar liquidación",
      "title": "Generar una liquidación de chofer",
      "body": "Arma la liquidación de la semana para un chofer, o agrega lo nuevo a su borrador. El cierre semanal arma el resto solo.",
      "driver": "Chofer",
      "driverPick": "Elige un chofer",
      "payer": "Paga",
      "owner": "Dueño",
      "ownerPick": "Elige el dueño",
      "week": "Semana",
      "weekHelp": "Cualquier día de la semana; la liquidación cubre de lunes a domingo (hora de la agencia, {{timeZone}}).",
      "weekFuture": "Esa semana todavía no empieza.",
      "confirm": "Generar",
      "done": "Liquidación lista.",
      "nothing": "No hay nada que liquidar para ese chofer y esa semana."
    },
    "how": {
      "perMile": "{{miles}} mi × ${{rate}}",
      "hourly": "{{hours}} h × ${{rate}}/h",
      "hourlyMissing": "Faltan las horas (${{rate}}/h)",
      "flat": "Fijo por carga",
      "percent": "{{pct}}% del linehaul",
      "percentAll": "{{pct}}% del linehaul y los accesorios",
      "truckNet": "Neto del camión"
    },
    "hours": {
      "label": "Horas en {{load}}",
      "saveLabel": "Guardar las horas de {{load}}",
      "invalid": "Más de 0 y como mucho 200, con hasta dos decimales.",
      "saved": "Horas de {{load}} guardadas."
    },
    "page": {
      "back": "Todas las liquidaciones de choferes",
      "error": "No se pudo cargar esta liquidación.",
      "notFound": "Esta liquidación no existe o no te corresponde verla.",
      "byAgency": "{{driver}} · la paga la agencia",
      "byOwner": "{{driver}} · la paga {{owner}}",
      "weekRange": "Semana del {{from}} al {{to}}",
      "finalNote": "Cerrada el {{date}}.",
      "paidNote": "Pagada el {{date}} por {{method}}",
      "paidNoteRef": "Pagada el {{date}} por {{method}} · {{reference}}",
      "canceledNote": "Cancelada: {{reason}}",
      "carriedNote": "Su saldo negativo pasó a una liquidación posterior.",
      "refresh": "Actualizar",
      "refreshed": "Liquidación actualizada.",
      "finalize": "Cerrar",
      "cancel": "Cancelar liquidación",
      "print": "Imprimir",
      "csv": "Exportar CSV",
      "sections": {
        "loads": "Cargas",
        "deductions": "Deducciones",
        "adjustments": "Ajustes",
        "balanceForward": "Saldo anterior",
        "totals": "Totales"
      },
      "none": "Ninguna.",
      "feeDisputed": "Fee en disputa",
      "defer": "Pasar a la semana siguiente",
      "deferred": "{{load}} pasó a la semana siguiente.",
      "stillOwed": "Quedan {{amount}} después de esta",
      "repaid": "Queda saldada con esta",
      "edited": "Editado, era {{amount}}",
      "editAmount": "Cambiar monto",
      "waive": "Perdonar",
      "waived": "Línea perdonada.",
      "waivedTag": "Perdonada",
      "restore": "Restaurar",
      "restored": "Línea restaurada.",
      "remove": "Quitar",
      "removed": "Ajuste quitado."
    },
    "formula": {
      "loads": "Cargas",
      "deductions": "Deducciones",
      "adjustments": "Ajustes",
      "balanceForward": "Saldo anterior",
      "pay": "Pagar a {{driver}}",
      "deficit": "{{driver}} pasa {{amount}} a la semana siguiente"
    },
    "finalize": {
      "title": "¿Cerrar {{number}}?",
      "body": "Neto {{net}}. Una liquidación final queda congelada: sus cargas, deducciones y montos ya no cambian. Para corregirla, cancélala.",
      "done": "{{number}} cerrada."
    },
    "cancel": {
      "title": "¿Cancelar {{number}}?",
      "body": "Sus cargas y deducciones vuelven a la próxima liquidación. El número no se vuelve a usar.",
      "confirm": "Cancelar liquidación",
      "done": "{{number}} cancelada."
    },
    "markPaid": {
      "action": "Marcar pagada",
      "title": "Marcar {{number}} como pagada",
      "body": "Registra que al chofer se le pagaron {{net}}.",
      "paidOn": "Pagada el",
      "paidOnHelp": "Hora de la agencia, {{timeZone}}.",
      "future": "La fecha de pago no puede ser futura.",
      "method": "Método",
      "methodPick": "Elige un método",
      "reference": "Referencia",
      "confirm": "Marcar pagada",
      "done": "{{number}} marcada como pagada."
    },
    "unmark": {
      "action": "Desmarcar pagada",
      "title": "¿Desmarcar {{number}} como pagada?",
      "body": "Se borran la fecha, el método y la referencia del pago. La liquidación sigue final.",
      "done": "{{number}} ya no está marcada como pagada."
    },
    "adjustment": {
      "action": "Agregar ajuste",
      "title": "Agregar un ajuste",
      "body": "Una línea manual en este borrador: un bono, un reembolso o algo que descontar.",
      "direction": "Sentido",
      "add": "Sumar a su pago",
      "take": "Descontar de su pago",
      "description": "Descripción",
      "amount": "Monto",
      "confirm": "Agregar",
      "done": "Ajuste agregado."
    },
    "amount": {
      "body": "Un monto nuevo para {{line}} solo en esta liquidación. La deducción en sí no cambia.",
      "reason": "Motivo",
      "done": "Monto cambiado."
    },
    "errors": {
      "needsHours": "Ingresa las horas de la carga {{load}} antes de cerrar.",
      "feeDisputed": "El fee de la carga {{load}} está en disputa: resuélvelo o pasa la carga a la semana siguiente antes de cerrar.",
      "unmarkFirst": "Esta liquidación está marcada como pagada: desmárcala antes de cancelarla.",
      "carried": "Una liquidación posterior lleva el saldo de esta: cancela {{number}} primero.",
      "weekFinal": "La liquidación de ese chofer para esa semana ya es final.",
      "notDraft": "Solo un borrador se puede cambiar.",
      "overRemaining": "Es más de lo que todavía se debe en esta deducción.",
      "notHourly": "Esa carga no se paga por hora."
    },
    "print": {
      "back": "Volver a la liquidación",
      "language": "Idioma de la copia",
      "print": "Imprimir",
      "title": "Liquidación de chofer",
      "from": "De",
      "to": "Para",
      "period": "Período",
      "description": "Descripción",
      "how": "Cómo",
      "amount": "Monto",
      "generatedOn": "Generada el {{date}}."
    }
  },
  "payPlan": {
    "title": "Plan de pago",
    "help": "Cómo se le paga a este chofer en cada carrier para el que maneja. Aplica a las cargas cuyo POD se confirme desde ahora.",
    "noSeats": "No tiene ningún asiento activo, así que no hay plan que fijar.",
    "readFailed": "No se pudo leer su plan de pago.",
    "kindLabel": "Plan de pago en {{carrier}}",
    "saveLabel": "Guardar el plan de pago en {{carrier}}",
    "saved": "Plan de pago en {{carrier}} guardado",
    "defaultIs": "{{pct}}% de {{base}}",
    "defaultUnset": "el porcentaje por defecto de la agencia",
    "base": {
      "linehaul": "linehaul",
      "linehaul_accessorial": "linehaul más accesorios"
    },
    "kind": {
      "default": "Por defecto de la agencia ({{value}})"
    },
    "explain": {
      "default": "Cobra lo que marca la agencia por defecto: {{value}}."
    }
  },
  "company": {
    "gaps": {
      "payment": "Tus facturas todavía no tienen instrucciones de pago.",
      "address": "Tus facturas todavía no tienen la dirección de la empresa.",
      "both": "Tus facturas todavía no tienen instrucciones de pago ni la dirección de la empresa.",
      "fixInSettings": "Añádelas en Ajustes > Empresa",
      "fixBelow": "Las facturas se envían igual sin ellas. Añádelas abajo."
    },
    "title": "Datos de la empresa en las facturas",
    "help": "Lo que ven tus carriers y brokers en cada factura que Coreway envía por ti.",
    "noAccess": "Los datos de la empresa son solo para el administrador y contabilidad.",
    "readOnly": "Solo el administrador de la agencia puede cambiar estos datos.",
    "saved": "Datos de la empresa guardados",
    "loadError": "No se pudieron cargar los datos de la empresa.",
    "defaultNote": "Aún no hay nada guardado: las facturas solo muestran {{name}}.",
    "sections": {
      "identity": "Nombre y dirección",
      "contact": "Contacto y autoridad",
      "payment": "Pagos"
    },
    "fields": {
      "legalName": "Razón social",
      "legalNameHelp": "Sale arriba en cada factura. Vacío: {{name}}.",
      "billingEmail": "Correo de facturación",
      "billingEmailHelp": "Los carriers responden a esta dirección.",
      "paymentInstructions": "Cómo pagarte",
      "paymentInstructionsHelp": "Sale en cada factura semanal. Ejemplo: Zelle a billing@tuagencia.com, o banco, ruta y cuenta.",
      "invoiceNote": "Nota bajo los totales",
      "invoiceNoteHelp": "Condiciones o un agradecimiento, bajo los totales de la factura semanal."
    },
    "logo": {
      "title": "Logo",
      "upload": "Subir logo",
      "replace": "Cambiar logo",
      "remove": "Quitar logo",
      "rules": "PNG o JPEG, 1 MB como máximo.",
      "uploadFirst": "Sube primero el logo (PNG o JPEG, 1 MB como máximo).",
      "alt": "Logo de la empresa",
      "none": "Aún no hay logo. Las facturas muestran tu nombre en su lugar.",
      "uploaded": "Logo actualizado",
      "removed": "Logo quitado"
    }
  },
  "delivery": {
    "title": "Envío de facturas",
    "saved": "Guardado",
    "exampleLabel": "Ejemplo",
    "autoSend": {
      "label": "Enviar las facturas por correo en el cierre del viernes",
      "help": "Cada carrier recibe su factura en PDF en su correo de facturación. Si no tiene correo, se crea una tarea. El cierre factura las cargas con POD recibido; los carriers configurados para facturar en tránsito (Carriers, menú de la fila, Momento de facturación) también reciben sus cargas ya recogidas.",
      "example": "El viernes a medianoche, Panthers Freight recibe la INV-1004 en su correo de facturación; un carrier sin correo genera una tarea para la oficina."
    },
    "locale": {
      "label": "Idioma de los documentos por defecto",
      "help": "Se usa cuando el carrier no tiene idioma propio.",
      "example": "Un carrier configurado en español recibe su factura en español diga lo que diga aquí; los demás, en este idioma."
    },
    "locales": {
      "en": "Inglés",
      "es": "Español"
    }
  },
  "billing": {
    "title": "Plan y facturación",
    "intro": "Lo que Coreway cobra a esta agencia cada mes, según sus camiones activos.",
    "noAccess": "El plan y la facturación son para el admin de la agencia o para un rol que el admin autorice.",
    "loadError": "No se pudo cargar el plan y la facturación.",
    "fields": {
      "plan": "Plan",
      "status": "Estado",
      "trucks": "Camiones activos",
      "band": "Tramo para la próxima renovación",
      "price": "Precio",
      "renewal": "Próxima renovación",
      "trial": "Prueba",
      "graceEnds": "Pagar antes del"
    },
    "perMonth": "{{amount}} al mes",
    "trucksValue": "{{now}} ahora, {{peak}} en el máximo de este periodo",
    "capUsage": "{{now}} de los {{cap}} camiones activos que cubre tu plan",
    "capReached": "Tu plan cubre hasta {{cap}} camiones activos. Escríbenos para pasar a un plan Enterprise y agregar más.",
    "bandRange": "{{name}} (de {{min}} a {{max}} camiones)",
    "bandFrom": "{{name}} ({{min}} camiones o más)",
    "nextPrice": "Desde la próxima renovación: {{band}} a {{amount}} al mes",
    "noPlanYet": "Se fija cuando la agencia se suscribe",
    "trialLeft_one": "Queda {{count}} día, hasta el {{date}}",
    "trialLeft_other": "Quedan {{count}} días, hasta el {{date}}",
    "endsOn": "Termina el {{date}}, cancelada al final del periodo",
    "pendingChange": "Un precio nuevo entra en vigor en la primera renovación después del {{date}}.",
    "comp": "Coreway no cobra a esta agencia.",
    "subscribe": "Suscribirse y añadir una tarjeta",
    "subscribeHelp": "Abre la página de pago segura de Stripe, el procesador de pagos que usa Coreway.",
    "manage": "Gestionar la facturación",
    "manageHelp": "Cambiar la tarjeta, descargar recibos o cancelar el plan en la página de facturación de Stripe.",
    "opening": "Abriendo la página de pago…",
    "invoices": {
      "title": "Facturas",
      "empty": "Todavía no hay facturas.",
      "number": "Número",
      "period": "Periodo",
      "total": "Total",
      "status": "Estado",
      "link": "Factura",
      "view": "Ver",
      "viewAria": "Ver la factura {{number}}",
      "periodRange": "Del {{from}} al {{to}}",
      "noNumber": "Aún sin número"
    },
    "status": {
      "trialing": "Prueba gratis",
      "trial_expired": "Prueba terminada",
      "active": "Activa",
      "past_due": "Pago vencido",
      "suspended": "Suspendida",
      "canceled": "Cancelada",
      "comp": "Sin cargo"
    },
    "invoiceStatus": {
      "draft": "Borrador",
      "open": "Abierta",
      "paid": "Pagada",
      "void": "Anulada",
      "uncollectible": "Incobrable"
    },
    "pastDue": {
      "label": "Pago vencido",
      "banner": "El pago de {{agency}} está vencido. Paga {{amount}} antes del {{date}} para conservar el acceso.",
      "bannerNoAmount": "El pago de {{agency}} está vencido. Paga antes del {{date}} para conservar el acceso.",
      "bannerShort": "El pago de {{agency}} está vencido. Págalo para conservar el acceso.",
      "payNow": "Pagar ahora",
      "open": "Abrir facturación"
    },
    "errors": {
      "notAllowed": "Solo el admin de la agencia, o un rol que el admin autorice, puede gestionar la facturación.",
      "checkoutOff": "Todavía no se puede suscribir desde el portal. Coreway te enviará un enlace de pago.",
      "notCharged": "Coreway no cobra a esta agencia, así que no hay nada que pagar.",
      "alreadySubscribed": "Esta agencia ya tiene una suscripción. Usa Gestionar la facturación para cambiar la tarjeta.",
      "notOpenYet": "Las suscripciones todavía no están abiertas. Coreway te escribirá cuando lo estén.",
      "checkoutPending": "Ya se está preparando una página de pago. Espera un minuto y vuelve a intentarlo.",
      "portalOff": "La página de facturación todavía no está abierta. Escribe al soporte de Coreway para cambiar la tarjeta o pagar.",
      "noCustomer": "Esta agencia todavía no tiene una tarjeta registrada. Suscríbete primero.",
      "selfSignupOff": "Todavía no se puede crear una agencia desde aquí.",
      "verifiedEmail": "Confirma tu correo electrónico antes de crear una agencia.",
      "alreadyCreated": "Esta cuenta ya creó una agencia.",
      "timeZone": "Elige la zona horaria de la agencia.",
      "prefix": "El prefijo de los números de carga debe tener de 2 a 5 letras o dígitos.",
      "requestFailed": "No se pudo abrir la página de pago. Vuelve a intentarlo en un minuto.",
      "requestTimeout": "La página de pago está tardando demasiado. Vuelve a intentarlo en un minuto.",
      "captchaRequired": "La verificación de seguridad caducó o ya se usó. Complétala de nuevo y reintenta.",
      "dailyLimit": "Hoy se crearon demasiadas agencias. Inténtalo mañana o escribe al soporte de Coreway.",
      "captchaFailed": "La verificación de seguridad no se superó. Complétala de nuevo y reintenta.",
      "captchaUnavailable": "La verificación de seguridad no está disponible ahora. Inténtalo en unos minutos."
    }
  },
  "dunning": {
    "title": "Recordatorios de facturas vencidas",
    "saved": "Guardado",
    "label": "Enviar al carrier un recordatorio cuando una factura semanal esté vencida",
    "help": "Apagado por defecto. Encendido, el carrier con una factura semanal vencida recibe un correo breve y cordial con el importe, la fecha de vencimiento y la factura adjunta (cómo pagar va en ella). Como mucho dos recordatorios por factura; paran en cuanto la factura se paga o se anula. La tarea de cobro para la oficina se crea igual.",
    "firstDay": "Primer recordatorio, días tras el vencimiento",
    "secondDay": "Segundo recordatorio, días tras el vencimiento",
    "daysHelp": "Días enteros, de 1 a 60, contados en la zona horaria de la agencia. El segundo va después del primero. Si lo enciendes con una factura ya atrasada, el carrier recibe un recordatorio, no los dos.",
    "example": "Una factura que vence el lunes: el carrier recibe un recordatorio {{first}} día(s) después y otro a los {{second}} días del vencimiento, salvo que la pague antes.",
    "secondAfterFirst": "El segundo recordatorio tiene que ir después del primero."
  },
  "dispatcherPay": {
    "basis": {
      "pct_of_fee": "% de la comisión de dispatch",
      "pct_of_gross": "% del bruto de la carga",
      "flat_per_load": "Fijo por carga",
      "weekly_salary": "Salario semanal"
    },
    "basisHelp": {
      "pct_of_fee": "Una parte de la comisión de la agencia en cada carga que lleva el dispatcher. El plan más común.",
      "pct_of_gross": "Una parte del bruto de la carga (linehaul más extras) en cada carga que lleva el dispatcher.",
      "flat_per_load": "El mismo monto en dólares por cada carga que lleva el dispatcher.",
      "weekly_salary": "Un monto fijo por semana, contado día a día mientras el plan está vigente."
    },
    "plan": {
      "title": "Pago",
      "basis": "Base de pago",
      "newBasis": "Cambiar el plan",
      "noPlan": "Sin plan",
      "none": "Sin pago",
      "noPlanYet": "Todavía sin plan de pago.",
      "ratePct": "Porcentaje",
      "rateAmount": "Monto",
      "effectiveFrom": "Empieza el",
      "effectiveHelp": "Hoy o después. Las cargas ya ganadas conservan la tarifa con que se pagaron.",
      "noBackdate": "Un cambio de plan empieza hoy o después.",
      "save": "Guardar plan",
      "saved": "Plan de pago guardado.",
      "history": "Historial de planes",
      "startsOn": "Desde el {{date}}: {{plan}}",
      "line": {
        "pct_of_fee": "{{rate}} de la comisión de dispatch",
        "pct_of_gross": "{{rate}} del bruto de la carga",
        "flat_per_load": "{{rate}} por carga",
        "weekly_salary": "{{rate}} por semana"
      }
    },
    "invite": {
      "title": "Plan de pago",
      "help": "Empieza el día que se une. Déjalo en Sin plan para usar el plan por defecto de la agencia."
    },
    "settings": {
      "title": "Pago de dispatchers",
      "intro": "Cómo paga la agencia a sus dispatchers. Los selectores de plan ofrecen solo las bases que uses aquí; apagar una nunca cambia un plan ya asignado.",
      "bases": "Bases de pago que usa la agencia",
      "atLeastOne": "Deja al menos una base.",
      "default": "Plan por defecto para nuevos dispatchers",
      "defaultHelp": "Se da a un dispatcher invitado sin plan, desde el día que se une.",
      "defaultOff": "El plan por defecto usa una base apagada.",
      "saved": "Ajustes de pago de dispatchers guardados."
    },
    "columns": {
      "dispatcher": "Dispatcher",
      "week": "Semana del",
      "loads": "Cargas",
      "commission": "Comisión",
      "held": "Retenido",
      "salary": "Salario",
      "earned": "Ganado",
      "paid": "Pagado",
      "balance": "Saldo",
      "actions": "Acciones"
    },
    "summary": {
      "earned": "Ganado",
      "paid": "Pagado",
      "balance": "Saldo",
      "held": "Retenido (comisión en disputa)"
    },
    "filters": {
      "range": "Semanas",
      "lastWeeks_one": "Última semana",
      "lastWeeks_other": "Últimas {{count}} semanas",
      "dispatcher": "Dispatcher",
      "all": "Todos los dispatchers"
    },
    "empty": "Sin pagos a dispatchers en estas semanas.",
    "emptyOwn": "Nada ganado en estas semanas.",
    "ownOnly": "Ves solo tu propio pago.",
    "week": {
      "range": "Semana del {{from}} al {{to}}",
      "loads": "Cargas",
      "noLoads": "Sin cargas esta semana.",
      "held": "Retenido: la comisión de dispatch está en disputa",
      "payments": "Pagos",
      "noPayments": "Todavía sin pagos."
    },
    "record": {
      "action": "Marcar pagado",
      "actionFor": "Marcar pagado a {{name}} la semana del {{week}}",
      "title": "Pagar a {{name}}",
      "description": "Semana del {{week}}. Saldo {{balance}}.",
      "amount": "Monto",
      "amountHelp": "Menos que el saldo es un pago parcial.",
      "paidOn": "Pagado el",
      "method": "Método",
      "note": "Nota",
      "submit": "Registrar pago",
      "saved": "Pago registrado."
    },
    "reverse": {
      "action": "Revertir",
      "reason": "Motivo",
      "confirm": "Revertir pago",
      "saved": "Pago revertido.",
      "reversed": "Revertido: {{reason}}"
    },
    "method": {
      "ach": "ACH",
      "check": "Cheque",
      "zelle": "Zelle",
      "cash": "Efectivo",
      "wire": "Transferencia",
      "other": "Otro"
    },
    "matrixMoneyOnly": "{{role}}: no disponible. El pago de dispatchers es solo para el administrador y contabilidad."
  },
  "driverPay": {
    "matrixMoneyOnly": "{{role}}: no disponible. El pago a choferes es solo para el administrador y contabilidad.",
    "moneyOnly": "El pago a choferes solo lo ven el administrador y contabilidad.",
    "readFailed": "No se pudo leer la configuración de pago a choferes.",
    "kind": {
      "percent": "Porcentaje de la carga",
      "per_mile": "Por milla",
      "flat": "Fijo por carga",
      "hourly": "Por hora",
      "truck_net": "Neto del camión (owner-operator)",
      "unknown": "Tipo desconocido"
    },
    "base": {
      "linehaul": "Linehaul",
      "linehaul_accessorial": "Linehaul más accesorios"
    },
    "milesBase": {
      "loaded": "Millas cargado",
      "loaded_deadhead": "Millas cargado y vacío"
    },
    "fields": {
      "pct": "Porcentaje del chofer",
      "base": "Porcentaje de",
      "milesBase": "Millas que se pagan",
      "rate": {
        "per_mile": "Tarifa por milla",
        "flat": "Monto por carga",
        "hourly": "Tarifa por hora"
      }
    },
    "pct": {
      "invalid": "Escribe un porcentaje de 0 a 100."
    },
    "rate": {
      "required": "Escribe la tarifa.",
      "invalid": "Escribe un número con hasta {{decimals}} decimales.",
      "range": "Hasta {{max}}."
    },
    "example": {
      "load": "En una carga de 1,200 mi y $3,000 este chofer gana {{amount}}.",
      "deadhead": "En una carga de 1,200 mi con 150 millas vacío, $3,000, este chofer gana {{amount}}.",
      "hourly": "En una carga de 10 horas este chofer gana {{amount}}.",
      "truckNet": "Este chofer se queda con el neto del carrier en cada carga (en un camión arrendado, menos la comisión del dueño).",
      "incomplete": "Escribe la tarifa para ver lo que paga una carga."
    },
    "weekday": {
      "1": "Lunes",
      "2": "Martes",
      "3": "Miércoles",
      "4": "Jueves",
      "5": "Viernes",
      "6": "Sábado",
      "7": "Domingo"
    },
    "weekdayShort": {
      "1": "Lun",
      "2": "Mar",
      "3": "Mié",
      "4": "Jue",
      "5": "Vie",
      "6": "Sáb",
      "7": "Dom"
    },
    "whoPays": {
      "title": "Quién paga al chofer",
      "intro": "Elige quién paga a tus choferes. Vale para todos los carriers salvo los que tengan una excepción.",
      "carrier": {
        "title": "Carrier",
        "description": "El carrier paga a sus choferes. Coreway muestra a cada chofer lo que ganó y cuándo; sin liquidación."
      },
      "agency": {
        "title": "Agencia",
        "description": "Tu agencia paga a los choferes. Cada semana Coreway arma una liquidación por chofer con sus cargas y deducciones para que la revises y la pagues."
      },
      "owner": {
        "title": "Dueño",
        "description": "El dueño del camión paga al chofer. Coreway prepara la liquidación semanal a nombre del dueño."
      },
      "noExceptions": "Todos los carriers siguen esta opción. Pon una excepción a un carrier desde",
      "exceptions_one": "{{count}} carrier tiene su propia opción. Míralo en",
      "exceptions_other": "{{count}} carriers tienen su propia opción. Míralos en",
      "carriersLink": "Carriers",
      "changeNote": "Desde la próxima carga entregada, Coreway anota el nuevo pagador. Las cargas ya entregadas conservan el pagador que tenían.",
      "save": "Guardar quién paga",
      "saved": "Guardado quién paga a los choferes."
    },
    "defaults": {
      "title": "Pago por defecto del chofer",
      "intro": "Lo que gana un chofer cuando no tiene plan de pago propio. Cambia un chofer desde su ficha en Choferes.",
      "kind": "Pago por defecto",
      "unknownKind": "El pago por defecto de esta agencia está fijado en una versión más nueva de Coreway. Recarga la página para verlo, o elige un tipo para reemplazarlo.",
      "payDays": "Días de pago",
      "payDaysHelp": "Una carga se paga el primer día de pago en o después de confirmar su POD.",
      "atLeastOneDay": "Elige al menos un día de pago.",
      "cutoff": "Hora límite de quick pay",
      "cutoffHelp": "Un quick pay pedido antes de esta hora (zona horaria de tu agencia) se paga el mismo día; después, al día siguiente.",
      "cutoffInvalid": "Escribe una hora.",
      "seeGross": "Los choferes ven el bruto de la carga",
      "seeGrossHelp": "Apagado: la app del chofer muestra su pago sin la tarifa del broker.",
      "save": "Guardar pago por defecto",
      "saved": "Pago por defecto guardado."
    },
    "settlements": {
      "offTitle": "Las liquidaciones semanales están apagadas",
      "offWhat": "Las liquidaciones semanales solo corren para choferes que paga tu agencia o un dueño.",
      "offWho": "Hoy los carriers pagan a sus choferes, así que aquí no hay nada que liquidar.",
      "offAction": "Elegir quién paga",
      "title": "Liquidaciones semanales de choferes",
      "intro": "Cada semana Coreway arma una liquidación por cada chofer que paga tu agencia o un dueño: sus cargas, menos sus deducciones.",
      "cut": "Cerrar la semana el",
      "cutHelp": "Las cargas entregadas antes de ese momento (zona horaria de tu agencia) entran en la liquidación de esa semana.",
      "cutOption": {
        "4": "Viernes a las 12:00 AM",
        "5": "Sábado a las 12:00 AM",
        "6": "Domingo a las 12:00 AM",
        "7": "Lunes a las 12:00 AM"
      },
      "auto": "Cerrar automáticamente",
      "autoHelp": "Apagado: cada liquidación espera como borrador hasta que alguien la revise y la cierre.",
      "carry": "Pasar un saldo negativo a la semana siguiente",
      "carryHelp": "Cuando las deducciones superan a las cargas, la diferencia sale de la siguiente liquidación.",
      "save": "Guardar reglas de liquidación",
      "saved": "Reglas de liquidación guardadas."
    },
    "catalog": {
      "title": "Catálogo de deducciones",
      "intro": "Deducciones que tu agencia usa con los choferes, con un monto por defecto. Salen de las liquidaciones semanales, así que solo aplican a choferes que paga tu agencia o un dueño.",
      "readFailed": "No se pudo leer el catálogo de deducciones.",
      "empty": "Aún no hay deducciones en el catálogo. Empieza con una común:",
      "emptyReadOnly": "Aún no hay deducciones en el catálogo.",
      "legend": "Deducciones",
      "label": "Nombre",
      "kindLabel": "Tipo",
      "amount": "Monto por defecto",
      "kind": {
        "recurring": "Cada semana",
        "one_off": "Una vez",
        "advance": "Adelanto (se devuelve)"
      },
      "suggestion": {
        "insurance": "Seguro",
        "escrow": "Escrow",
        "leasePurchase": "Compra a plazos del camión",
        "advance": "Adelanto"
      },
      "addSuggestion": "Añadir {{label}}",
      "add": "Añadir una deducción",
      "remove": "Quitar {{label}}",
      "unnamed": "esta deducción",
      "labelInvalid": "Ponle nombre (hasta 60 caracteres).",
      "save": "Guardar catálogo",
      "saved": "Catálogo de deducciones guardado."
    },
    "payer": {
      "menu": "Pago a choferes…",
      "title": "Quién paga a los choferes",
      "readFailed": "No se pudo leer quién paga a los choferes de este carrier.",
      "inherit": "Opción de la agencia ({{value}})",
      "inheritHelp": "Sigue Configuración > Pago a choferes y cambia cuando cambie la opción de la agencia.",
      "saved": "Guardado quién paga a los choferes de {{name}}.",
      "badge": {
        "agency": "La agencia paga a los choferes",
        "owner": "El dueño paga a los choferes"
      }
    },
    "summary": {
      "perMileLoaded": "{{rate}} por milla cargado",
      "perMileAll": "{{rate}} por milla, cargado y vacío",
      "flat": "{{amount}} por carga",
      "hourly": "{{amount}} por hora"
    },
    "plan": {
      "unknownNote": "Este plan usa un tipo que esta versión de Coreway no conoce. Recarga la página para verlo, o elige otro tipo para reemplazarlo."
    }
  },
  "factoring": {
    "title": "Empresas de factoring",
    "intro": "Las empresas a las que tus carriers venden sus facturas al broker. Cada carrier elige una en su ficha; la factura al broker de una carga con factoring le dice al broker que le pague a ella.",
    "new": "Nueva empresa de factoring",
    "createTitle": "Nueva empresa de factoring",
    "editTitle": "Editar empresa de factoring",
    "saved": "Empresa de factoring guardada",
    "created": "Empresa de factoring creada",
    "sections": {
      "company": "Empresa y dirección de pago",
      "noa": "Aviso de cesión",
      "notes": "Notas"
    },
    "noaHelp": "Márcalo cuando tengas el NOA firmado que indica a los brokers que paguen a esta empresa.",
    "col": {
      "name": "Empresa",
      "remitTo": "Pagar a",
      "noa": "NOA",
      "carriers": "Carriers",
      "status": "Estado",
      "actions": "Acciones"
    },
    "empty": "Todavía no hay empresas de factoring. Añade la primera para elegirla en un carrier.",
    "emptyReadOnly": "Todavía no hay empresas de factoring.",
    "noAddress": "Sin dirección todavía",
    "noaOnFile": "Archivado",
    "noaOnFileSince": "Archivado desde el {{date}}",
    "noaMissing": "No archivado",
    "active": "Activa",
    "inactive": "Inactiva",
    "deactivate": "Desactivar",
    "reactivate": "Reactivar",
    "deactivated": "Empresa de factoring desactivada",
    "reactivated": "Empresa de factoring reactivada",
    "deactivateTitle": "¿Desactivar {{name}}?",
    "deactivateBody": "Deja de aparecer en la lista de los carriers. Las facturas ya emitidas la siguen mostrando. No se puede desactivar mientras un carrier activo la tenga asignada.",
    "errors": {
      "notFound": "Esa empresa de factoring ya no existe. Recarga la página.",
      "inactive": "Esa empresa de factoring está inactiva. Reactívala en Ajustes > Factoring o elige otra.",
      "duplicate": "Ya existe una empresa de factoring con este nombre.",
      "assigned": "Sigue asignada a {{count}} carrier(s) activo(s). Primero elige otra empresa de factoring en ellos.",
      "noaFuture": "La fecha del NOA no puede ser futura."
    }
  },
  "brokerReport": {
    "title": "Informe del broker",
    "open": "Informe",
    "openHint": "Abrir el informe imprimible del broker",
    "loading": "Cargando el informe…",
    "error": "No se pudo leer el informe.",
    "notFound": "Este broker no es de tu agencia, o se eliminó.",
    "backToBrokers": "Volver a brokers",
    "back": "Volver",
    "print": "Imprimir",
    "knownAs": "En Coreway figura como {{name}}",
    "date": "Fecha",
    "currency": "Moneda",
    "by": "Por",
    "riskScore": "Puntaje de riesgo",
    "noScore": "Sin puntaje",
    "recordCheck": "Registrar una verificación de crédito",
    "scoreFrom": "Verificación de {{source}} del {{date}}",
    "lastCheck": "Última verificación: {{source}}, {{value}}, {{date}}",
    "band": {
      "high": "Riesgo alto",
      "med": "Riesgo medio",
      "low": "Riesgo bajo"
    },
    "bandRisk": {
      "high": "Riesgo alto",
      "med": "Riesgo medio",
      "low": "Riesgo bajo"
    },
    "identity": "Datos del broker",
    "address": "Dirección",
    "phone": "Teléfono",
    "email": "Correo",
    "loads": "Tus cargas con este broker",
    "noFmcsa": "Todavía no se consultó FMCSA para este broker.",
    "ledger": "Historial de pagos (tus carriers)",
    "noInvoices": "Todavía no hay facturas a este broker: los gráficos empiezan con la primera.",
    "noMoneyRole": "Tu rol no muestra las cuentas por cobrar, así que se omiten las cifras de dinero y los gráficos de saldo y días de pago.",
    "kpi": {
      "invoiced": "Facturado",
      "invoices_one": "{{count}} factura",
      "invoices_other": "{{count}} facturas",
      "received": "Cobrado",
      "closed_one": "{{count}} cerrada",
      "closed_other": "{{count}} cerradas",
      "outstanding": "Pendiente",
      "open_one": "{{count}} abierta",
      "open_other": "{{count}} abiertas",
      "avgDays": "Días promedio de pago",
      "lastPaid": "Último pago {{date}}",
      "overdue": "Vencidas",
      "shortPays": "Pagos incompletos",
      "disputes": "Disputas"
    },
    "trends": "Tendencias, últimos {{count}} meses",
    "balanceTitle": "Saldo en dólares",
    "balanceHelp": "Lo que este broker aún debía a tus carriers al cierre de cada mes",
    "daysTitle": "Días de pago",
    "daysHelp": "Días promedio de la factura al pago, por mes de pago",
    "scoreTitle": "Historial del puntaje",
    "scoreHelp": "El puntaje de la última verificación de crédito de cada mes",
    "noScores": "Ninguna verificación de crédito con puntaje en estos meses.",
    "noPayments": "Ninguna factura pagada en estos meses.",
    "noScoreMonth": "Sin puntaje",
    "noPaymentMonth": "Sin pagos",
    "daysValue_one": "{{count}} día",
    "daysValue_other": "{{count}} días",
    "checksInMonth_one": "{{count}} verificación este mes",
    "checksInMonth_other": "{{count}} verificaciones este mes",
    "invoicedInMonth_one": "{{count}} factura este mes, {{amount}}",
    "invoicedInMonth_other": "{{count}} facturas este mes, {{amount}}",
    "closedInMonth_one": "{{count}} factura pagada",
    "closedInMonth_other": "{{count}} facturas pagadas",
    "theAgency": "la agencia",
    "disclaimer": "Hecho con los registros propios de {{agency}} en Coreway: sus verificaciones de crédito, sus consultas a FMCSA y las facturas de sus carriers. No es un informe de una agencia de crédito. Un buen puntaje no garantiza que este broker pague, ahora ni en el futuro.",
    "plotLabel": "{{title}}, últimos {{count}} meses. Usa las flechas izquierda y derecha para moverte entre los meses.",
    "tableMonth": "Mes",
    "tableValue": "Valor"
  },
  "announcements": {
    "label": "Avisos de Coreway",
    "dismiss": "Cerrar este aviso",
    "dismissFailed": "No se pudo cerrar el aviso. Vuelve a estar en pantalla; inténtalo de nuevo.",
    "kind": {
      "info": "Aviso",
      "maintenance": "Mantenimiento programado",
      "terms": "Cambio de términos",
      "pricing": "Precios",
      "release": "Novedades"
    },
    "activeUntil": "{{start}} · activo hasta el {{end}}",
    "endedOn": "{{start}} · terminó el {{end}}",
    "unread": "Sin leer",
    "markRead": "Marcar como leído",
    "markReadFailed": "No se pudo marcar el aviso como leído. Inténtalo de nuevo.",
    "page": {
      "title": "Avisos",
      "blurb": "Todo lo que te envió el equipo de Coreway: novedades, ventanas de mantenimiento y cambios de términos y precios. Leído o no, se queda aquí.",
      "tabs": "Mostrar",
      "all": "Todos",
      "unread": "Sin leer",
      "markAll": "Marcar todos como leídos",
      "markAllDone": "Todos los avisos marcados como leídos.",
      "markAllFailed": "Algunos avisos no se pudieron marcar como leídos. Inténtalo de nuevo.",
      "emptyTitle": "Todavía no hay avisos",
      "empty": "Aquí aparecen las novedades, las ventanas de mantenimiento y los cambios de términos del equipo de Coreway.",
      "emptyUnreadTitle": "Estás al día",
      "emptyUnread": "Todos los avisos están leídos. La pestaña Todos los guarda.",
      "error": "No se pudieron cargar los avisos.",
      "retry": "Reintentar",
      "loadMore": "Ver avisos anteriores",
      "loading": "Cargando avisos"
    },
    "button": {
      "label": "Avisos",
      "unread_one": "Avisos, {{count}} sin leer",
      "unread_other": "Avisos, {{count}} sin leer"
    }
  },
  "activity": {
    "kinds": {
      "load_events": {
        "created": "Carga creada",
        "transition": "Estado cambiado a {{status}}",
        "declined": "El chofer rechazó la carga",
        "unassigned": "Carga retirada al chofer",
        "updated": "Datos de la carga editados",
        "repriced": "Tarifa de la carga cambiada",
        "stop_added": "Parada añadida: {{stop}}",
        "stop_removed": "Parada quitada: {{stop}}",
        "stop_rescheduled": "Cita cambiada en {{stop}}",
        "stop_arrived": "Llegó a {{stop}}",
        "stop_departed": "Salió de {{stop}}",
        "document_added": "Documento subido",
        "document_replaced": "Documento reemplazado",
        "document_archived": "Documento archivado",
        "document_invoice_flag": "Recibo marcado para la factura al broker",
        "fee_disputed": "Comisión en disputa",
        "fee_dispute_cleared": "Disputa de la comisión resuelta",
        "quick_pay_requested": "Pago rápido solicitado",
        "fee_reversed": "Comisión revertida"
      },
      "activity_log": {
        "load": {
          "updated": "Carga editada",
          "priced": "Precio de la carga fijado",
          "owner_commission_set": "Comisión del dueño fijada en una carga",
          "owner_commission_cleared": "Comisión del dueño quitada de una carga",
          "driver_hours_set": "Horas del chofer anotadas en una carga"
        },
        "receivable": {
          "invoiced": "Marcada como facturada al broker",
          "invoice_emailed": "Factura al broker enviada por email",
          "payment_recorded": "Pago del broker registrado",
          "payment_reversed": "Pago del broker revertido",
          "disputed": "Pago del broker en disputa",
          "dispute_cleared": "Disputa con el broker resuelta",
          "reopened": "Cobro al broker reabierto",
          "unmarked": "Marca de facturada quitada",
          "updated": "Cobro al broker corregido"
        },
        "document": {
          "added": "Documento subido",
          "replaced": "Documento reemplazado",
          "archived": "Documento archivado",
          "dates_set": "Fechas del documento fijadas"
        },
        "carrier": {
          "created": "Carrier añadido",
          "updated": "Carrier actualizado",
          "status_changed": "Estado del carrier cambiado",
          "dispatch_plan_set": "Porcentaje de despacho del carrier fijado",
          "dispatch_plan_removed": "Porcentaje de despacho del carrier quitado",
          "invoice_settings_updated": "Ajustes de factura del carrier actualizados",
          "driver_payer_set": "Cambió quién paga a los choferes del carrier"
        },
        "truck": {
          "created": "Camión añadido",
          "updated": "Camión actualizado",
          "status_changed": "Estado del camión cambiado",
          "driver_assigned": "Chofer asignado a un camión",
          "driver_unassigned": "Chofer quitado de un camión",
          "dispatch_plan_set": "Porcentaje de despacho del camión fijado",
          "dispatch_plan_removed": "Porcentaje de despacho del camión quitado",
          "maintenance_tracking_set": "Seguimiento de mantenimiento del camión activado o desactivado",
          "odometer_recorded": "Lectura de odómetro registrada",
          "odometer_voided": "Lectura de odómetro anulada",
          "maintenance_plan_saved": "Plan de servicio del camión guardado",
          "maintenance_plan_retired": "Plan de servicio del camión retirado",
          "maintenance_event_recorded": "Servicio del camión registrado",
          "maintenance_event_voided": "Servicio del camión anulado"
        },
        "driver": {
          "created": "Chofer añadido",
          "updated": "Chofer actualizado",
          "status_changed": "Estado del chofer cambiado",
          "seat_added": "Chofer añadido a un carrier",
          "seat_ended": "Chofer salió de un carrier",
          "linked": "El chofer entró en la app",
          "invite_created": "Código de la app creado para un chofer",
          "invite_revoked": "Código de la app revocado",
          "account_deleted": "El chofer borró su cuenta de la app",
          "pay_plan_set": "Plan de pago del chofer fijado",
          "pay_plan_removed": "Plan de pago del chofer quitado",
          "deduction_created": "Deducción de chofer añadida",
          "deduction_updated": "Deducción de chofer cambiada",
          "deduction_retired": "Deducción de chofer retirada"
        },
        "owner": {
          "created": "Dueño añadido",
          "updated": "Dueño actualizado",
          "status_changed": "Estado del dueño cambiado"
        },
        "broker_setup": {
          "created": "Alta con broker iniciada",
          "updated": "Alta con broker actualizada"
        },
        "broker_incident": {
          "recorded": "Incidente con broker registrado",
          "resolved": "Incidente con broker resuelto",
          "reopened": "Incidente con broker reabierto"
        },
        "broker": {
          "created": "Broker añadido",
          "updated": "Broker actualizado"
        },
        "broker_credit": {
          "checked": "Crédito del broker consultado",
          "fmcsa_lookup": "Broker consultado en FMCSA",
          "overridden": "Broker bloqueado permitido por el admin"
        },
        "factoring": {
          "created": "Empresa de factoring añadida",
          "updated": "Empresa de factoring actualizada",
          "deactivated": "Empresa de factoring desactivada"
        },
        "dispatcher": {
          "carrier_assigned": "Carrier asignado a un dispatcher",
          "carrier_unassigned": "Carrier quitado a un dispatcher"
        },
        "member": {
          "invited": "Miembro del equipo invitado",
          "invite_resent": "Invitación al equipo reenviada",
          "invite_revoked": "Invitación al equipo revocada",
          "invite_declined": "Invitación al equipo rechazada",
          "joined": "Nuevo miembro en el equipo",
          "role_changed": "Rol de un miembro cambiado",
          "status_changed": "Estado de un miembro cambiado"
        },
        "permission": {
          "changed": "Permisos cambiados"
        },
        "dispatcher_pay": {
          "plan_set": "Plan de pago de dispatcher fijado",
          "payment_recorded": "Pago a dispatcher registrado",
          "payment_reversed": "Pago a dispatcher revertido",
          "settings_set": "Ajustes de pago de dispatchers cambiados"
        },
        "agency": {
          "created": "Agencia creada",
          "profile_updated": "Datos de la empresa actualizados",
          "settings_updated": "Ajustes de la agencia actualizados",
          "document_requirement_set": "Documentos requeridos cambiados",
          "suspended": "Agencia suspendida",
          "reactivated": "Agencia reactivada",
          "closed": "Agencia cerrada",
          "flag_set": "Función de la agencia cambiada por Coreway",
          "fee_settings_updated": "Ajustes de comisiones actualizados",
          "pay_settings_updated": "Ajustes de pago actualizados",
          "deduction_template_saved": "Entrada del catálogo de deducciones guardada",
          "deduction_template_retired": "Entrada del catálogo de deducciones retirada"
        },
        "invoice": {
          "raised": "Factura al carrier emitida",
          "charge_raised": "Cargo añadido a una factura al carrier",
          "line_added": "Línea añadida a una factura al carrier",
          "email_requested": "Factura al carrier enviada por email",
          "payment_recorded": "Pago del carrier registrado",
          "payment_reversed": "Pago del carrier revertido",
          "written_off": "Factura al carrier dada por perdida"
        },
        "owner_statement": {
          "generated": "Estado de cuenta del dueño generado",
          "finalized": "Estado de cuenta del dueño cerrado",
          "canceled": "Estado de cuenta del dueño cancelado",
          "line_added": "Línea añadida a un estado de cuenta",
          "line_amount_set": "Línea de un estado de cuenta cambiada",
          "line_removed": "Línea quitada de un estado de cuenta",
          "line_restored": "Línea restaurada en un estado de cuenta"
        },
        "truck_lease": {
          "created": "Arrendamiento de camión creado",
          "updated": "Arrendamiento de camión actualizado",
          "ended": "Arrendamiento de camión terminado"
        },
        "driver_settlement": {
          "generated": "Liquidación de chofer armada",
          "line_added": "Ajuste añadido a una liquidación de chofer",
          "line_removed": "Línea quitada de una liquidación de chofer",
          "line_restored": "Línea restaurada en una liquidación de chofer",
          "line_amount_set": "Monto de deducción cambiado en una liquidación de chofer",
          "finalized": "Liquidación de chofer cerrada",
          "canceled": "Liquidación de chofer cancelada",
          "paid_marked": "Liquidación de chofer marcada pagada",
          "paid_unmarked": "Pago de liquidación de chofer deshecho"
        }
      },
      "other": "Otra actividad"
    },
    "stop": {
      "pickup": "la recogida",
      "delivery": "la entrega",
      "any": "una parada"
    },
    "groups": {
      "load_lifecycle": "Estado de cargas",
      "load_changes": "Cambios en cargas",
      "load_tracking": "Llegadas y salidas",
      "documents": "Documentos",
      "receivables": "Pagos de brokers",
      "fleet": "Carriers, camiones y choferes",
      "brokers": "Brokers",
      "team": "Equipo",
      "agency": "Ajustes de la agencia",
      "money": "Dinero",
      "other": "Otra actividad"
    },
    "actor": {
      "system": "Coreway",
      "operator": "Soporte de Coreway",
      "former": "Antiguo miembro",
      "onBehalf": "por {{name}}",
      "driver": "Chofer"
    },
    "col": {
      "when": "Cuándo",
      "who": "Quién",
      "what": "Qué",
      "driver": "Chofer",
      "carrier": "Carrier"
    },
    "filters": {
      "label": "Filtrar la actividad",
      "person": "Persona",
      "allPeople": "Todos",
      "driver": "Chofer",
      "allDrivers": "Todos los choferes",
      "group": "Tipo",
      "allGroups": "Toda la actividad",
      "from": "Desde",
      "to": "Hasta",
      "clear": "Quitar filtros"
    },
    "dispatcher": "Dispatcher",
    "loadMore": "Cargar más",
    "newActivity": "Hay actividad nueva. Actualizar",
    "empty": "Todavía no hay actividad.",
    "emptyFiltered": "Ninguna actividad coincide con estos filtros.",
    "noAccess": "La actividad del equipo no está activada para tu rol. Un admin puede activarla en Ajustes, Permisos.",
    "prefs": {
      "title": "Avisos de actividad",
      "description": "Los grupos silenciados no suenan en la campana. La página de Actividad siempre muestra todo lo que puedes ver.",
      "groupLabel": "Avisarme de {{group}}",
      "save": "Guardar avisos",
      "saved": "Avisos de actividad guardados",
      "master": "Avisos de actividad",
      "masterOnHint": "Encendido: la campana cuenta lo que hace el equipo, según los grupos de abajo.",
      "masterOffHint": "Apagado: la campana no cuenta la actividad del equipo. Tus grupos elegidos se conservan para cuando lo vuelvas a encender.",
      "masterOn": "Avisos de actividad encendidos",
      "masterOff": "Avisos de actividad apagados"
    }
  },
  "maintenance": {
    "state": {
      "off": "Apagado",
      "no_plan": "Sin plan",
      "ok": "Al día",
      "due_soon": "Vence pronto",
      "overdue": "Vencido",
      "unknown": "Sin lectura"
    },
    "switch": {
      "label": "Seguimiento de mantenimiento",
      "help": "Planes, odómetro e historial de servicios de este camión. Los recordatorios llegan como tareas.",
      "turnOn": "Activar el seguimiento de mantenimiento",
      "turnOnShort": "Activar",
      "turnedOn": "El seguimiento de mantenimiento está activo en la unidad {{unit}}.",
      "turnedOff": "El seguimiento de mantenimiento está apagado en la unidad {{unit}}."
    },
    "off": {
      "title": "El seguimiento de mantenimiento está apagado",
      "what": "Lleva el servicio por millas o por días y recibe una tarea antes de que venza.",
      "who": "Para los camiones que opera tu agencia o sus dueños. Los owner-operators suelen llevar el suyo.",
      "askManager": "Un administrador, gerente o despachador puede activarlo."
    },
    "tabs": {
      "label": "Secciones del camión",
      "plan": "Plan",
      "history": "Historial",
      "odometer": "Odómetro",
      "documents": "Documentos"
    },
    "readFailed": "No se pudo cargar el mantenimiento de este camión.",
    "plan": {
      "intro": "Reglas de servicio por millas, por días o por ambas. Llega una tarea antes de que venza cada una.",
      "add": "Agregar plan",
      "editTitle": "Editar plan",
      "dialogHelp": "El intervalo cuenta desde hoy y el odómetro actual. Registrar un servicio en el plan lo reinicia.",
      "presets": "Empezar con una plantilla",
      "label": "Nombre",
      "labelTooLong": "Hasta 60 caracteres.",
      "everyMiles": "Cada (millas)",
      "everyMilesHelp": "Déjalo vacío para una regla solo por días.",
      "everyDays": "Cada (días)",
      "everyDaysHelp": "Déjalo vacío para una regla solo por millas.",
      "warnMiles": "Avisar esta cantidad de millas antes",
      "warnDays": "Avisar esta cantidad de días antes",
      "milesRange": "Entre 500 y 1,000,000 millas.",
      "daysRange": "Entre 1 y 3,650 días.",
      "needRule": "Indica cada cuántas millas, días o ambos.",
      "warnMilesRange": "Entre 0 y 100,000 millas.",
      "warnDaysRange": "Entre 0 y 365 días.",
      "needsReading": "Una regla por millas cuenta desde el odómetro actual: primero agrega una lectura en la pestaña Odómetro.",
      "save": "Guardar plan",
      "saved": "Plan guardado.",
      "ruleBoth_one": "Cada {{miles}} mi o {{count}} día",
      "ruleBoth_other": "Cada {{miles}} mi o {{count}} días",
      "ruleMiles": "Cada {{miles}} mi",
      "ruleDays_one": "Cada {{count}} día",
      "ruleDays_other": "Cada {{count}} días",
      "nextAt": "Próximo servicio a las {{miles}} mi",
      "dueToday": "Vence hoy, {{date}}",
      "inDays_one": "Vence en {{count}} día, {{date}}",
      "inDays_other": "Vence en {{count}} días, {{date}}",
      "daysOverdue_one": "{{count}} día vencido, desde {{date}}",
      "daysOverdue_other": "{{count}} días vencido, desde {{date}}",
      "logService": "Registrar servicio",
      "editNamed": "Editar {{label}}",
      "retire": "Retirar",
      "retireNamed": "Retirar {{label}}",
      "retireTitle": "¿Retirar {{label}}?",
      "retireBody": "El plan deja de enviar recordatorios. Sus servicios pasados quedan en el historial.",
      "retired": "Plan retirado.",
      "emptyTitle": "Aún no hay planes",
      "emptyText": "Agrega un cambio de aceite, una inspección anual o cualquier regla por millas o días."
    },
    "presets": {
      "oil": "Cambio de aceite",
      "inspection": "Inspección anual",
      "tires": "Llantas",
      "brakes": "Frenos"
    },
    "kinds": {
      "preventive": "Preventivo",
      "repair": "Reparación",
      "inspection": "Inspección",
      "tires": "Llantas",
      "other": "Otro"
    },
    "sources": {
      "office": "Oficina",
      "driver": "Chofer",
      "maintenance_event": "Servicio"
    },
    "service": {
      "title": "Registrar servicio",
      "kind": "Tipo",
      "date": "Fecha",
      "description": "Qué se hizo",
      "odometer": "Odómetro",
      "odometerHelp": "Actual: {{miles}} mi.",
      "cost": "Costo",
      "shop": "Taller",
      "plan": "Plan",
      "planHelp": "Reinicia el intervalo de ese plan desde este servicio.",
      "noPlan": "Sin plan",
      "file": "Factura u orden de trabajo",
      "fileHelp": "Opcional. Un PDF o una foto, hasta 25 MB.",
      "save": "Guardar servicio",
      "saved": "Servicio registrado.",
      "future": "La fecha no puede ser posterior a hoy.",
      "costInvalid": "Escribe un monto de hasta $1,000,000.00.",
      "fileKept": "El archivo se subió pero el servicio no se guardó. Guarda de nuevo: el archivo no se sube dos veces."
    },
    "history": {
      "intro": "Todos los servicios de este camión, el más reciente primero.",
      "emptyTitle": "Aún no hay servicios",
      "emptyText": "Registra un cambio de aceite, una reparación o una inspección con su costo y su factura.",
      "atMiles": "a {{miles}} mi",
      "openFile": "Abrir {{name}}",
      "void": "Anular",
      "voidNamed": "Anular {{what}}",
      "voidTitle": "¿Anular este servicio?",
      "voidBody": "{{what}} sale del historial y del reporte de costos. Si reinició un plan, el plan vuelve a su cuenta anterior.",
      "voided": "Servicio anulado.",
      "year": "Este año: {{cost}} · {{perMile}} por milla",
      "yearNoMiles": "Este año: {{cost}} · aún sin millas"
    },
    "odometer": {
      "current": "Odómetro actual",
      "miles": "{{miles}} mi",
      "estimate": "aprox. {{miles}} mi",
      "estimateHelp": "Última lectura el {{date}} más las millas de las cargas entregadas desde entonces.",
      "none": "Aún no hay lecturas. Agrega una para que cuenten las reglas por millas.",
      "reading": "Lectura del odómetro",
      "date": "Fecha",
      "add": "Agregar lectura",
      "saved": "Lectura agregada.",
      "invalid": "Millas enteras, como 123,450.",
      "list": "Lecturas",
      "empty": "Aún no hay lecturas.",
      "voidNamed": "Anular la lectura de {{miles}} mi",
      "voidTitle": "¿Anular esta lectura?",
      "voidBody": "La lectura de {{miles}} mi deja de contar para los planes.",
      "voided": "Lectura anulada."
    },
    "list": {
      "column": "Mantenimiento",
      "odometer": "Odómetro",
      "attention": "Requiere atención",
      "menu": "Mantenimiento",
      "openNamed": "Mantenimiento de la unidad {{unit}}: {{state}}",
      "noAttention": "Ningún camión requiere atención."
    },
    "suggestion": {
      "label": "Sugerencia de seguimiento de mantenimiento",
      "text_one": "{{count}} camión de carriers cuyos choferes pagas no tiene seguimiento.",
      "text_other": "{{count}} camiones de carriers cuyos choferes pagas no tienen seguimiento.",
      "help": "El seguimiento viene apagado. Actívalo para recibir los recordatorios de servicio como tareas.",
      "action": "Activar seguimiento",
      "dismiss": "Ahora no",
      "done_one": "El seguimiento está activo en {{count}} camión.",
      "done_other": "El seguimiento está activo en {{count}} camiones.",
      "partial": "Se activaron {{done}} de {{total}} camiones. Abre un camión para ver por qué falló el resto."
    },
    "kpi": {
      "label": "Atención de flota",
      "hint": "{{service}} servicio · {{docs}} documentos",
      "link": "Atención de flota: {{count}}, abrir los camiones que la requieren"
    },
    "due": {
      "title": "Servicio pendiente",
      "viewAll": "Ver camiones",
      "empty": "No hay servicio pendiente. Todos los camiones con seguimiento están al día.",
      "error": "No se pudo cargar el servicio pendiente.",
      "line": "{{label}}",
      "plansDue_one": "{{count}} plan pendiente",
      "plansDue_other": "{{count}} planes pendientes"
    },
    "report": {
      "view": "Costo por milla",
      "tableLabel": "Costo por milla por camión",
      "chartLabel": "Costo por milla por camión, del mayor al menor",
      "unit": "Camión",
      "carrier": "Carrier",
      "miles": "Millas",
      "cost": "Costo de mantenimiento",
      "events": "Servicios",
      "perMile": "$ por milla",
      "na": "n/d",
      "naHelp": "Sin millas en el periodo",
      "source": {
        "odometer": "Odómetro",
        "loads": "Cargas"
      },
      "sourceColumn": "Millas según",
      "sourceHelp": "Las millas salen del odómetro cuando hay una lectura anterior al inicio del periodo y otra dentro de él; si no, de las cargas entregadas.",
      "total": "Total",
      "rule": "Servicios realizados del {{from}} al {{to}}; millas en los mismos días (hora de {{timeZone}}).",
      "empty": "No hay camiones con seguimiento ni servicios en este periodo.",
      "offTitle": "Aún no hay camiones con seguimiento",
      "offWhat": "Mira cuánto cuesta cada camión por milla en servicio y reparaciones.",
      "offWho": "Para agencias que operan o pagan sus camiones. Activa el seguimiento desde un camión en la lista de Camiones.",
      "offAction": "Abrir camiones",
      "error": "No se pudo cargar el costo por milla.",
      "fileTitle": "Costo por milla"
    }
  }
}
